/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: string; output: string; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: string; output: string; }
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any; }
  /**
   * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
   * character sequences. The Json type is most often used to represent a free-form
   * human-readable json string.
   */
  Json: { input: any; output: any; }
  /** Represents an uploaded file. */
  Upload: { input: any; output: any; }
};

export enum AccessLevel {
  /** advanced */
  ADVANCED = 'ADVANCED',
  /** free */
  FREE = 'FREE',
  /** member */
  MEMBER = 'MEMBER'
}

/** An account */
export type Account = {
  __typename?: 'Account';
  /** The account manager of the account */
  accountManager?: Maybe<User>;
  /** The account manager email of the account */
  accountManagerEmail?: Maybe<Scalars['String']['output']>;
  /** The address of the account */
  address?: Maybe<Scalars['String']['output']>;
  /** The address region of the account */
  addressRegion?: Maybe<Scalars['String']['output']>;
  /** The balances of the account per credit type */
  balances: Array<Balance>;
  /** The city of the account */
  city?: Maybe<Scalars['String']['output']>;
  /** The company name of the account */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country of the account */
  country?: Maybe<Scalars['String']['output']>;
  /** The CRM organization number of the account */
  crmOrganizationNumber?: Maybe<Scalars['String']['output']>;
  /** The first name of the holder of the account */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The id of the account */
  id: Scalars['Int']['output'];
  /** The creation date of the account */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the account */
  insertedBy?: Maybe<User>;
  /** The last name of the holder of the account */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The locale of the account */
  locale?: Maybe<Scalars['String']['output']>;
  /** The Mollie Customer ID for this account */
  mollieCustomerId?: Maybe<Scalars['String']['output']>;
  /** The name of the account */
  name?: Maybe<Scalars['String']['output']>;
  /** The organization status of the account */
  organizationStatus?: Maybe<Scalars['String']['output']>;
  /** The post code of the account */
  postCode?: Maybe<Scalars['String']['output']>;
  /** The profiles of the account */
  profiles: Array<Profile>;
  /** The profiles of the account */
  profilesConnection: ProfileConnection;
  /** The query to retrieve the number of profiles */
  profilesCount: Scalars['Int']['output'];
  /** The transactions of the account */
  transactions: Array<Transaction>;
  /** The transactions of the account */
  transactionsConnection: TransactionConnection;
  /** The query to retrieve the number of transactions */
  transactionsCount: Scalars['Int']['output'];
  /** The type of the account */
  type: AccountType;
  /** The date of the last update of the account */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the account */
  updatedBy?: Maybe<User>;
  /** The users of the account */
  users: Array<User>;
  /** The users of the account */
  usersConnection: UserConnection;
  /** The query to retrieve the number of users */
  usersCount: Scalars['Int']['output'];
  /** The VAT number of the account */
  vatNumber?: Maybe<Scalars['String']['output']>;
  /** The VAT rate for the account */
  vatRate?: Maybe<Scalars['Decimal']['output']>;
  /** The vtiger account id of the account */
  vtigerAccountId?: Maybe<Scalars['Int']['output']>;
  /** The vtiger account manager id of the account */
  vtigerAccountManagerId?: Maybe<Scalars['Int']['output']>;
  /** The date of the last vtiger update of the account */
  vtigerUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An account */
export type AccountprofilesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<ProfileSorting>;
};


/** An account */
export type AccountprofilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfileSorting>;
};


/** An account */
export type AccounttransactionsArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  creditIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: Scalars['Int']['input'];
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An account */
export type AccounttransactionsConnectionArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  creditIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An account */
export type AccounttransactionsCountArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  creditIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An account */
export type AccountusersArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** An account */
export type AccountusersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account */
export type AccountvatRateArgs = {
  bundleId?: InputMaybe<Scalars['Int']['input']>;
};

/** An account address */
export type AccountAddress = {
  __typename?: 'AccountAddress';
  /** The address of the account */
  address?: Maybe<Scalars['String']['output']>;
  /** The address region of the account */
  addressRegion?: Maybe<Scalars['String']['output']>;
  /** The city of the account */
  city?: Maybe<Scalars['String']['output']>;
  /** The company name of the account */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country of the account */
  country?: Maybe<Scalars['String']['output']>;
  /** The post code of the account */
  postCode?: Maybe<Scalars['String']['output']>;
};

export type AccountConnection = {
  __typename?: 'AccountConnection';
  edges: Array<AccountEdge>;
  pageInfo: PageInfo;
};

export type AccountEdge = {
  __typename?: 'AccountEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Account;
};

/** Account type */
export enum AccountType {
  ORGANIZATION = 'ORGANIZATION',
  PERSONAL = 'PERSONAL'
}

export enum AgeGroup {
  /** Adults */
  ADULTS = 'ADULTS',
  /** Babies */
  BABIES = 'BABIES',
  /** Children */
  CHILDREN = 'CHILDREN'
}

/** An analytics event */
export type AnalyticsEvent = {
  __typename?: 'AnalyticsEvent';
  /** The id of the event */
  id: Scalars['Int']['output'];
  /** The creation date of the event */
  insertedAt: Scalars['DateTime']['output'];
  /** The payload of the event */
  payload?: Maybe<Scalars['Json']['output']>;
  /** The subject id of the event */
  subjectId?: Maybe<Scalars['String']['output']>;
  /** The subject type of the event */
  subjectType?: Maybe<Scalars['String']['output']>;
  /** The title of the event */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of the event */
  type: AnalyticsEventType;
  /** The url of the event */
  url?: Maybe<Scalars['String']['output']>;
  /** The numeric value of the event */
  value?: Maybe<Scalars['Decimal']['output']>;
};

/** Analytics event type enum */
export enum AnalyticsEventType {
  /** Click */
  CLICK = 'CLICK',
  /** Event */
  EVENT = 'EVENT',
  /** Pageview */
  PAGEVIEW = 'PAGEVIEW',
  /** Timing */
  TIMING = 'TIMING',
  /** Usage */
  USAGE = 'USAGE'
}

/** An applicant */
export type Applicant = {
  __typename?: 'Applicant';
  /** The applicant's meteor id */
  _id: Scalars['String']['output'];
  /** The query to retrieve the applicant messages of the applicant */
  applicantMessages: Array<ApplicantMessage>;
  /** The query to retrieve the applicant messages of the applicant */
  applicantMessagesConnection: ApplicantMessageConnection;
  /** The query to retrieve the count of applicant messages of the applicant */
  applicantMessagesCount: Scalars['Int']['output'];
  /** Cover letter url */
  coverLetterUrl?: Maybe<Scalars['String']['output']>;
  /** The id of the applicant user if exist */
  createdById: Scalars['String']['output'];
  /** The applicant user if exist */
  creator?: Maybe<User>;
  /** CV url */
  cvUrl?: Maybe<Scalars['String']['output']>;
  /** Email */
  email: Scalars['String']['output'];
  /** Extra document 1 url */
  extraDocument1Url?: Maybe<Scalars['String']['output']>;
  /** Extra document 2 url */
  extraDocument2Url?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** The applicant's numeric id */
  id: Scalars['Int']['output'];
  /** Creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The the job of the applicant */
  job?: Maybe<Job>;
  /** The id of the applicant's job */
  jobId: Scalars['Int']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Locale */
  locale: Scalars['String']['output'];
  /** Motivation */
  motivation?: Maybe<Scalars['String']['output']>;
  /** The status of the applicant */
  status: ApplicantStatus;
  /** Subscribed to newsletter */
  subscribedToNewsletter?: Maybe<Scalars['Boolean']['output']>;
  /** The date of the last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** An applicant */
export type ApplicantapplicantMessagesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  reasons?: InputMaybe<Array<InputMaybe<ApplicantMessageReason>>>;
};


/** An applicant */
export type ApplicantapplicantMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reasons?: InputMaybe<Array<InputMaybe<ApplicantMessageReason>>>;
};


/** An applicant */
export type ApplicantapplicantMessagesCountArgs = {
  reasons?: InputMaybe<Array<InputMaybe<ApplicantMessageReason>>>;
};


/** An applicant */
export type ApplicantjobArgs = {
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  status?: InputMaybe<JobStatus>;
};

export type ApplicantConnection = {
  __typename?: 'ApplicantConnection';
  edges: Array<ApplicantEdge>;
  pageInfo: PageInfo;
};

export type ApplicantEdge = {
  __typename?: 'ApplicantEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Applicant;
};

/** An applicant message */
export type ApplicantMessage = {
  __typename?: 'ApplicantMessage';
  /** The meteor ID of the message */
  _id: Scalars['String']['output'];
  /** The applicant of the message */
  applicant: Applicant;
  /** The creator of the message */
  creator?: Maybe<User>;
  /** The numeric ID of the message */
  id: Scalars['Int']['output'];
  /** Creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The reason of the message */
  reason: ApplicantMessageReason;
  /** The subject of the message */
  subject: Scalars['String']['output'];
  /** The text of the message */
  text: Scalars['String']['output'];
  /** The date of the last update */
  updatedAt: Scalars['DateTime']['output'];
  /** The updater of the message */
  updater?: Maybe<User>;
};

export type ApplicantMessageConnection = {
  __typename?: 'ApplicantMessageConnection';
  edges: Array<ApplicantMessageEdge>;
  pageInfo: PageInfo;
};

export type ApplicantMessageEdge = {
  __typename?: 'ApplicantMessageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: ApplicantMessage;
};

export enum ApplicantMessageReason {
  /** invite */
  INVITE = 'INVITE',
  /** message */
  MESSAGE = 'MESSAGE',
  /** rejection */
  REJECTION = 'REJECTION'
}

export enum ApplicantStatus {
  /** applied */
  APPLIED = 'APPLIED',
  /** hired */
  HIRED = 'HIRED',
  /** offer */
  OFFER = 'OFFER',
  /** on-site interview */
  ON_SITE_INTERVIEW = 'ON_SITE_INTERVIEW',
  /** rejected */
  REJECTED = 'REJECTED',
  /** remote interview */
  REMOTE_INTERVIEW = 'REMOTE_INTERVIEW',
  /** shortlisted */
  SHORTLISTED = 'SHORTLISTED'
}

/** A balance of an account per credit type */
export type Balance = {
  __typename?: 'Balance';
  /** The amount of the credit */
  amount: Scalars['Decimal']['output'];
  /** The credit type of the credit */
  creditType: CreditType;
};

export type Brand = {
  __typename?: 'Brand';
  /** The id of the brand */
  id: Scalars['Int']['output'];
  /** The image url of the brand */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of the brand */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The brand's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The name of the brand */
  name: Scalars['String']['output'];
  /** The query to retrieve the products */
  products: Array<Product>;
  /** The query to retrieve the products */
  productsConnection: ProductConnection;
  /** The query to retrieve the products */
  productsCount: Scalars['Int']['output'];
  /** The query to retrieve the profiles */
  profiles: Array<Profile>;
  /** The brand's last modification date */
  updatedAt: Scalars['DateTime']['output'];
};


export type BrandimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


export type BrandproductsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<ProductSorting>;
};


export type BrandproductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<ProductSorting>;
};


export type BrandproductsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type BrandprofilesArgs = {
  sort?: InputMaybe<ProfileSorting>;
};

export type BrandConnection = {
  __typename?: 'BrandConnection';
  edges: Array<BrandEdge>;
  pageInfo: PageInfo;
};

export type BrandEdge = {
  __typename?: 'BrandEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Brand;
};

export enum BrandSorting {
  /** Alphabetical */
  ALPHABETICAL = 'ALPHABETICAL',
  /** Randomized */
  RANDOM = 'RANDOM',
  /** Relevance */
  RELEVANCE = 'RELEVANCE'
}

/** A bundle */
export type Bundle = {
  __typename?: 'Bundle';
  /** The query to retrieve the bundle items of the bundle */
  bundleItems: Array<BundleItem>;
  /** The query to retrieve the bundle items of the bundle */
  bundleItemsConnection: BundleItemConnection;
  /** The query to retrieve the number of bundle items of the bundle */
  bundleItemsCount: Scalars['Int']['output'];
  /** The description of the bundle */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of the bundle */
  id: Scalars['Int']['output'];
  /** The creation date of the bundle */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the bundle */
  insertedBy?: Maybe<User>;
  /** The name of the bundle */
  name: Scalars['String']['output'];
  /** The price of the bundle */
  price: PriceWithCurrency;
  /** The service code for invoicing for this bundle */
  serviceCode: Scalars['Int']['output'];
  /** The type of the bundle */
  type: PaymentType;
  /** The date of the last update of the bundle */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the bundle */
  updatedBy?: Maybe<User>;
  /** The vtiger service ID for invoicing for this bundle */
  vtigerServiceId: Scalars['Int']['output'];
};


/** A bundle */
export type BundlebundleItemsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** A bundle */
export type BundlebundleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BundleConnection = {
  __typename?: 'BundleConnection';
  edges: Array<BundleEdge>;
  pageInfo: PageInfo;
};

export type BundleEdge = {
  __typename?: 'BundleEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Bundle>;
};

/** A bundle item */
export type BundleItem = {
  __typename?: 'BundleItem';
  /** The amount of the bundle item */
  amount: Scalars['Decimal']['output'];
  /** The bundle of the bundle item */
  bundle: Bundle;
  /** The credit type of the bundle item */
  creditType: CreditType;
  /** The id of the bundle item */
  id: Scalars['Int']['output'];
  /** The creation date of the bundle item */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the bundle item */
  insertedBy?: Maybe<User>;
  /** The date of the last update of the bundle item */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the bundle item */
  updatedBy?: Maybe<User>;
};

export type BundleItemConnection = {
  __typename?: 'BundleItemConnection';
  edges: Array<BundleItemEdge>;
  pageInfo: PageInfo;
};

export type BundleItemEdge = {
  __typename?: 'BundleItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<BundleItem>;
};

export enum CareerLevel {
  /** Entry level */
  ENTRY_LEVEL = 'ENTRY_LEVEL',
  /** Executive */
  EXECUTIVE = 'EXECUTIVE',
  /** Internship */
  INTERNSHIP = 'INTERNSHIP',
  /** Management */
  MANAGEMENT = 'MANAGEMENT',
  /** Mid-career */
  MID_CAREER = 'MID_CAREER',
  /** None */
  NONE = 'NONE',
  /** Senior */
  SENIOR = 'SENIOR'
}

/** A category keyword */
export type CategoryKeyword = {
  __typename?: 'CategoryKeyword';
  /** The category keyword's categories */
  categories: Array<Scalars['String']['output']>;
  /** The category keyword's id */
  id: Scalars['String']['output'];
};

export type CategoryKeywordConnection = {
  __typename?: 'CategoryKeywordConnection';
  edges: Array<CategoryKeywordEdge>;
  pageInfo: PageInfo;
};

export type CategoryKeywordEdge = {
  __typename?: 'CategoryKeywordEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: CategoryKeyword;
};

/** A city */
export type City = {
  __typename?: 'City';
  /** The country of the city */
  country: Scalars['String']['output'];
  /** The city's id */
  id: Scalars['String']['output'];
  /** The city's image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The city's responsive image urls */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The creation date of the city */
  insertedAt: Scalars['DateTime']['output'];
  /** The jobs in the city */
  jobs: Array<Job>;
  /** The jobs in the city */
  jobsConnection: JobConnection;
  /** The count of jobs in the city */
  jobsCount: Scalars['Int']['output'];
  /** The date of the last job published in the city */
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The city's locales */
  locales: Array<Scalars['String']['output']>;
  /** The city's name */
  name: Scalars['String']['output'];
  /** The city's alternative names */
  names: Array<Scalars['String']['output']>;
  /** The city's slug */
  slug: Scalars['String']['output'];
  /** The state or province of the city */
  state?: Maybe<Scalars['String']['output']>;
  /** The date of the last update of the city */
  updatedAt: Scalars['DateTime']['output'];
};


/** A city */
export type CityimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A city */
export type CityjobsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A city */
export type CityjobsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A city */
export type CityjobsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A city */
export type CitylastPublishedAtArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CityConnection = {
  __typename?: 'CityConnection';
  edges: Array<CityEdge>;
  pageInfo: PageInfo;
};

export type CityEdge = {
  __typename?: 'CityEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: City;
};

export enum CitySorting {
  /** By active jobs count ascending */
  ACTIVE_JOBS_COUNT_ASCENDING = 'ACTIVE_JOBS_COUNT_ASCENDING',
  /** By active jobs count descending */
  ACTIVE_JOBS_COUNT_DESCENDING = 'ACTIVE_JOBS_COUNT_DESCENDING',
  /** By slug ascending */
  SLUG_ASCENDING = 'SLUG_ASCENDING',
  /** By slug descending */
  SLUG_DESCENDING = 'SLUG_DESCENDING'
}

export type Color = {
  __typename?: 'Color';
  /** The id of the color */
  id: Scalars['Int']['output'];
  /** The name of the color */
  name: Scalars['String']['output'];
};

export type ColorConnection = {
  __typename?: 'ColorConnection';
  edges: Array<ColorEdge>;
  pageInfo: PageInfo;
};

export type ColorEdge = {
  __typename?: 'ColorEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Color;
};

/** A company's address */
export type CompanyAddress = {
  __typename?: 'CompanyAddress';
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Locality address */
  locality?: Maybe<Scalars['String']['output']>;
  /** Post box number */
  postbox?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** Street */
  street?: Maybe<Scalars['String']['output']>;
  /** ZIP Code */
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** A company's address */
export type CompanyAddressInput = {
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Locality address */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** Post box number */
  postbox?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Street */
  street?: InputMaybe<Scalars['String']['input']>;
  /** ZIP Code */
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/** A company profile's localized descriptions */
export type CompanyDescriptions = {
  __typename?: 'CompanyDescriptions';
  /** Localized version for locale bg-BG */
  bgBg?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale cs-CZ */
  csCz?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale da-DK */
  daDk?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale de-AT */
  deAt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale de-CH */
  deCh?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale de-DE */
  deDe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale el-CY */
  elCy?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale el-GR */
  elGr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-AU */
  enAu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-CA */
  enCa?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-GB */
  enGb?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-IE */
  enIe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-IN */
  enIn?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-NZ */
  enNz?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-US */
  enUs?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-AR */
  esAr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-CL */
  esCl?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-CO */
  esCo?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-ES */
  esEs?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-MX */
  esMx?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-PE */
  esPe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale et-EE */
  etEe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fi-FI */
  fiFi?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-BE */
  frBe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-CH */
  frCh?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-FR */
  frFr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-LU */
  frLu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale hr-HR */
  hrHr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale hu-HU */
  huHu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale it-CH */
  itCh?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale it-IT */
  itIt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale ja-JP */
  jaJp?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale lt-LT */
  ltLt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale lv-LV */
  lvLv?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale mt-MT */
  mtMt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale nb-NO */
  nbNo?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale nl-BE */
  nlBe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale nl-NL */
  nlNl?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale pl-PL */
  plPl?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale pt-BR */
  ptBr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale pt-PT */
  ptPt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale ro-RO */
  roRo?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale ru-RU */
  ruRu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale sk-SK */
  skSk?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale sl-SI */
  slSi?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale sv-SE */
  svSe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale tr-TR */
  trTr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale zh-CN */
  zhCn?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale zh-HK */
  zhHk?: Maybe<Scalars['String']['output']>;
};

/** A company profile's localized descriptions */
export type CompanyDescriptionsInput = {
  /** Localized version for locale bg-BG */
  bgBg?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale cs-CZ */
  csCz?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale da-DK */
  daDk?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale de-AT */
  deAt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale de-CH */
  deCh?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale de-DE */
  deDe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale el-CY */
  elCy?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale el-GR */
  elGr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-AU */
  enAu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-CA */
  enCa?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-GB */
  enGb?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-IE */
  enIe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-IN */
  enIn?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-NZ */
  enNz?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-US */
  enUs?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-AR */
  esAr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-CL */
  esCl?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-CO */
  esCo?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-ES */
  esEs?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-MX */
  esMx?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-PE */
  esPe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale et-EE */
  etEe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fi-FI */
  fiFi?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-BE */
  frBe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-CH */
  frCh?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-FR */
  frFr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-LU */
  frLu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale hr-HR */
  hrHr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale hu-HU */
  huHu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale it-CH */
  itCh?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale it-IT */
  itIt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale ja-JP */
  jaJp?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale lt-LT */
  ltLt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale lv-LV */
  lvLv?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale mt-MT */
  mtMt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale nb-NO */
  nbNo?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale nl-BE */
  nlBe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale nl-NL */
  nlNl?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale pl-PL */
  plPl?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale pt-BR */
  ptBr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale pt-PT */
  ptPt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale ro-RO */
  roRo?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale ru-RU */
  ruRu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale sk-SK */
  skSk?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale sl-SI */
  slSi?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale sv-SE */
  svSe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale tr-TR */
  trTr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale zh-CN */
  zhCn?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale zh-HK */
  zhHk?: InputMaybe<Scalars['String']['input']>;
};

/** A social network page */
export type CompanySocialNetworkPage = {
  __typename?: 'CompanySocialNetworkPage';
  fullName?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A social network page */
export type CompanySocialNetworkPageInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A social network user */
export type CompanySocialNetworkUser = {
  __typename?: 'CompanySocialNetworkUser';
  fullName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** A social network user */
export type CompanySocialNetworkUserInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A country */
export type Country = {
  __typename?: 'Country';
  /** Is the country EU member? */
  euMember: Scalars['Boolean']['output'];
  /** The name of the country */
  name: Scalars['String']['output'];
};

/** A course */
export type Course = {
  __typename?: 'Course';
  /** The course's additional information */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  /** The course's career level */
  careerLevel: CareerLevel;
  /** The course's category */
  category: CourseCategory;
  /** The course's city */
  city?: Maybe<Scalars['String']['output']>;
  /** The course's company information */
  companyDescription?: Maybe<Scalars['String']['output']>;
  /** The courses's company name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The course's country */
  country?: Maybe<Scalars['String']['output']>;
  /** The course's description */
  description?: Maybe<Scalars['String']['output']>;
  /** The course's education */
  education?: Maybe<Scalars['String']['output']>;
  /** The course's hits */
  hits?: Maybe<Scalars['Int']['output']>;
  /** The course's id */
  id: Scalars['Int']['output'];
  /** The course's introduction */
  introduction?: Maybe<Scalars['String']['output']>;
  /** The course's geo latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The course's logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The course's responsive logo URLs */
  logoUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The course's geo longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The responsive logo URLs of the course */
  responsiveLogoUrls?: Maybe<ResponsiveImageUrls>;
  /** The course's slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** The course's geo state province */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** The course's status */
  status?: Maybe<CourseStatus>;
  /** The course's title */
  title: Scalars['String']['output'];
};


/** A course */
export type CourseadditionalInformationArgs = {
  firstImageFetchPriority?: InputMaybe<FetchPriority>;
  transform?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A course */
export type CoursedescriptionArgs = {
  firstImageFetchPriority?: InputMaybe<FetchPriority>;
  transform?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A course */
export type CourselogoUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

/** A category in the courseboard */
export type CourseCategory = {
  __typename?: 'CourseCategory';
  /** The id of the category */
  id: Scalars['Int']['output'];
  /** The name of the category */
  title: Scalars['String']['output'];
};

export type CourseCategoryConnection = {
  __typename?: 'CourseCategoryConnection';
  edges: Array<CourseCategoryEdge>;
  pageInfo: PageInfo;
};

export type CourseCategoryEdge = {
  __typename?: 'CourseCategoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: CourseCategory;
};

export type CourseConnection = {
  __typename?: 'CourseConnection';
  edges: Array<CourseEdge>;
  pageInfo: PageInfo;
};

/** A country in the courseboard */
export type CourseCountry = {
  __typename?: 'CourseCountry';
  /** The id of the country */
  id: Scalars['Int']['output'];
  /** The name of the country */
  name: Scalars['String']['output'];
  /** The region of the country */
  region: Scalars['String']['output'];
  /** The short code of the country */
  shortCode: Scalars['String']['output'];
};

export type CourseCountryConnection = {
  __typename?: 'CourseCountryConnection';
  edges: Array<CourseCountryEdge>;
  pageInfo: PageInfo;
};

export type CourseCountryEdge = {
  __typename?: 'CourseCountryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: CourseCountry;
};

export type CourseEdge = {
  __typename?: 'CourseEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Course;
};

/** A education in the courseboard */
export type CourseEducation = {
  __typename?: 'CourseEducation';
  /** The id of the education */
  id: Scalars['Int']['output'];
  /** The level of the education */
  level: Scalars['String']['output'];
};

export type CourseEducationConnection = {
  __typename?: 'CourseEducationConnection';
  edges: Array<CourseEducationEdge>;
  pageInfo: PageInfo;
};

export type CourseEducationEdge = {
  __typename?: 'CourseEducationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: CourseEducation;
};

export enum CourseStatus {
  /** Published */
  PUBLISHED = 'PUBLISHED',
  /** Unpublished */
  UNPUBLISHED = 'UNPUBLISHED'
}

/** A credit */
export type Credit = {
  __typename?: 'Credit';
  /** The account of the credit */
  account: Account;
  /** Whether the credit is archived */
  archived: Scalars['Boolean']['output'];
  /** The credit type of the credit */
  creditType: CreditType;
  /** The expiry date of the credit */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the credit */
  id: Scalars['Int']['output'];
  /** The initial amount of the credit */
  initialAmount: Scalars['Decimal']['output'];
  /** The creation date of the credit */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the credit */
  insertedBy?: Maybe<User>;
  /** The remaining amount of the credit */
  remainingAmount: Scalars['Decimal']['output'];
  /** The date of the last update of the credit */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the credit */
  updatedBy?: Maybe<User>;
  /** The usage ratio of the credit */
  usageRatio: Scalars['Decimal']['output'];
  /** The used amount of the credit */
  usedAmount: Scalars['Decimal']['output'];
  /** The date the credit is valid from */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
};

export type CreditConnection = {
  __typename?: 'CreditConnection';
  edges: Array<CreditEdge>;
  pageInfo: PageInfo;
};

export type CreditEdge = {
  __typename?: 'CreditEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Credit;
};

/** A product */
export type CreditProduct = {
  __typename?: 'CreditProduct';
  /** The description of the product */
  description: Scalars['String']['output'];
  /** The id of the product */
  id: Scalars['Int']['output'];
  /** The creation date of the product */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the product */
  insertedBy?: Maybe<User>;
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The prices of the product */
  prices: Array<Price>;
  /** The prices of the product */
  pricesConnection: PriceConnection;
  /** The date of the last update of the product */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the product */
  updatedBy?: Maybe<User>;
};


/** A product */
export type CreditProductpricesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** A product */
export type CreditProductpricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CreditProductConnection = {
  __typename?: 'CreditProductConnection';
  edges: Array<CreditProductEdge>;
  pageInfo: PageInfo;
};

export type CreditProductEdge = {
  __typename?: 'CreditProductEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: CreditProduct;
};

/** Credit sorting */
export enum CreditSorting {
  /** By account name, ascending */
  ACCOUNT_NAME_ASCENDING = 'ACCOUNT_NAME_ASCENDING',
  /** By account name, descending */
  ACCOUNT_NAME_DESCENDING = 'ACCOUNT_NAME_DESCENDING',
  /** By expires at, ascending */
  EXPIRES_AT_ASCENDING = 'EXPIRES_AT_ASCENDING',
  /** By expires at, descending */
  EXPIRES_AT_DESCENDING = 'EXPIRES_AT_DESCENDING',
  /** By id, ascending */
  ID_ASCENDING = 'ID_ASCENDING',
  /** By id, descending */
  ID_DESCENDING = 'ID_DESCENDING',
  /** By initial amount, ascending */
  INITIAL_AMOUNT_ASCENDING = 'INITIAL_AMOUNT_ASCENDING',
  /** By initial amount, descending */
  INITIAL_AMOUNT_DESCENDING = 'INITIAL_AMOUNT_DESCENDING',
  /** By remaining amount, ascending */
  REMAINING_AMOUNT_ASCENDING = 'REMAINING_AMOUNT_ASCENDING',
  /** By remaining amount, descending */
  REMAINING_AMOUNT_DESCENDING = 'REMAINING_AMOUNT_DESCENDING',
  /** By usage ratio, ascending */
  USAGE_RATIO_ASCENDING = 'USAGE_RATIO_ASCENDING',
  /** By usage ratio, descending */
  USAGE_RATIO_DESCENDING = 'USAGE_RATIO_DESCENDING'
}

/** A credit type */
export type CreditType = {
  __typename?: 'CreditType';
  /** Whether the credit type should be automatically archived */
  autoArchive: Scalars['Boolean']['output'];
  /** The expiry interval of the credit type */
  expiryInterval?: Maybe<Interval>;
  /** The id of the credit type */
  id: Scalars['Int']['output'];
  /** The creation date of the credit type */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the credit type */
  insertedBy?: Maybe<User>;
  /** The name of the credit type */
  name: Scalars['String']['output'];
  /** The price of the credit type */
  price?: Maybe<PriceWithCurrency>;
  /** The priority of the credit type for ordering */
  priority?: Maybe<Scalars['Int']['output']>;
  /** The type of the credit type */
  type: AccountType;
  /** The date of the last update of the credit type */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the credit type */
  updatedBy?: Maybe<User>;
};

export type CreditTypeConnection = {
  __typename?: 'CreditTypeConnection';
  edges: Array<CreditTypeEdge>;
  pageInfo: PageInfo;
};

export type CreditTypeEdge = {
  __typename?: 'CreditTypeEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: CreditType;
};

/** Credit type sorting */
export enum CreditTypeSorting {
  /** By id, ascending */
  ID_ASCENDING = 'ID_ASCENDING',
  /** By priority, ascending */
  PRIORITY_ASCENDING = 'PRIORITY_ASCENDING'
}

/** Currency */
export enum Currency {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CUP = 'CUP',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EGP = 'EGP',
  ETB = 'ETB',
  EUR = 'EUR',
  FJD = 'FJD',
  FKP = 'FKP',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  IMP = 'IMP',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JEP = 'JEP',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRU = 'MRU',
  MUR = 'MUR',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SLL = 'SLL',
  SOS = 'SOS',
  SRD = 'SRD',
  SSP = 'SSP',
  STD = 'STD',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TVD = 'TVD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VES = 'VES',
  VND = 'VND',
  VUV = 'VUV',
  XAF = 'XAF',
  XCD = 'XCD',
  XOF = 'XOF',
  XPF = 'XPF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMW = 'ZMW'
}

export type DeliveryDaysRange = {
  __typename?: 'DeliveryDaysRange';
  /** The average number of days */
  average?: Maybe<Scalars['Float']['output']>;
  /** The maximum number of days */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** The minimum number of days */
  minimum?: Maybe<Scalars['Int']['output']>;
};

export enum EmbeddingsSearchModel {
  /** E5 */
  E5 = 'E5',
  /** Gecko */
  GECKO = 'GECKO'
}

/** Fetch priority */
export enum FetchPriority {
  /** Automatic priority */
  AUTO = 'AUTO',
  /** High priority */
  HIGH = 'HIGH',
  /** Low priority */
  LOW = 'LOW'
}

export enum Gender {
  /** Men */
  MEN = 'MEN',
  /** Women */
  WOMEN = 'WOMEN'
}

/** GeoJSON Coordinate Reference System */
export type GeoJsonCrs = {
  __typename?: 'GeoJsonCrs';
  /** Properties */
  properties?: Maybe<GeoJsonCrsProperties>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};

/** GeoJSON Coordinate Reference System properties */
export type GeoJsonCrsProperties = {
  __typename?: 'GeoJsonCrsProperties';
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
};

/** GeoJSON Geometry */
export type GeoJsonGeometry = {
  __typename?: 'GeoJsonGeometry';
  /** The coordinates of the GeoJSON object */
  coordinates: Array<Scalars['Float']['output']>;
  /** The Coordinate Reference System */
  crs?: Maybe<GeoJsonCrs>;
  /** The type of the GeoJSON object */
  type: Scalars['String']['output'];
};

/** GeoJSON Geometry input object */
export type GeoJsonGeometryInput = {
  /** The coordinates of the GeoJSON object */
  coordinates: Array<Scalars['Float']['input']>;
  /** The type of the GeoJSON object */
  type: Scalars['String']['input'];
};

export enum HighlightPeriodType {
  /** All highlighted jobs */
  ALL = 'ALL',
  /** Job of the week */
  JOB_OF_THE_WEEK = 'JOB_OF_THE_WEEK',
  /** Top job */
  TOP_JOB = 'TOP_JOB'
}

/** An image in the Global Fashion Image Library */
export type Image = {
  __typename?: 'Image';
  /** Is the image approved? */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** The category of the image */
  category?: Maybe<ImageCategory>;
  /** The creator of the image */
  creator?: Maybe<User>;
  /** The owner of the image */
  credits?: Maybe<Scalars['String']['output']>;
  /** The description of the image */
  description?: Maybe<Scalars['String']['output']>;
  /** Is the image free for commercial use? */
  freeForCommercialUse?: Maybe<Scalars['Boolean']['output']>;
  /** Is the image free for editorial use? */
  freeForEditorialUse?: Maybe<Scalars['Boolean']['output']>;
  /** The height of the image */
  height?: Maybe<Scalars['Int']['output']>;
  /** The id of the image */
  id: Scalars['Int']['output'];
  /** The responsive image urls */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The creation date of the image */
  insertedAt: Scalars['DateTime']['output'];
  /** Is the image internal use only? */
  internalUseOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Is the image with no attribution required? */
  noAttributionRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The photographer of the image */
  photographer?: Maybe<Scalars['String']['output']>;
  /** Is the image private? */
  private?: Maybe<Scalars['Boolean']['output']>;
  /** The slug of the image */
  slug?: Maybe<Scalars['String']['output']>;
  /** The title of the image */
  title?: Maybe<Scalars['String']['output']>;
  /** The creator of the image */
  updater?: Maybe<User>;
  /** The url of the original image */
  uploadUrl: Scalars['String']['output'];
  /** The width of the image */
  width?: Maybe<Scalars['Int']['output']>;
};


/** An image in the Global Fashion Image Library */
export type ImageimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

/** A category in the Global Fashion Image Library */
export type ImageCategory = {
  __typename?: 'ImageCategory';
  /** The id of the category */
  id: Scalars['Int']['output'];
  /** The images of the category */
  images: ImageConnection;
  /** The slug of the category */
  slug: Scalars['String']['output'];
  /** The title of the category */
  title: Scalars['String']['output'];
};


/** A category in the Global Fashion Image Library */
export type ImageCategoryimagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ImageSorting>;
};

export type ImageCategoryConnection = {
  __typename?: 'ImageCategoryConnection';
  edges: Array<ImageCategoryEdge>;
  pageInfo: PageInfo;
};

export type ImageCategoryEdge = {
  __typename?: 'ImageCategoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: ImageCategory;
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  edges: Array<ImageEdge>;
  pageInfo: PageInfo;
};

export type ImageEdge = {
  __typename?: 'ImageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Image;
};

/** Responsive image format */
export enum ImageFormat {
  /** automatic */
  AUTO = 'AUTO',
  /** AVIF */
  AVIF = 'AVIF',
  /** JPEG */
  JPEG = 'JPEG',
  /** PNG */
  PNG = 'PNG',
  /** WebP */
  WEBP = 'WEBP'
}

/** Responsive image gravity */
export enum ImageGravity {
  /** center */
  CE = 'CE',
  /** east (right edge) */
  EA = 'EA',
  /** north (top edge) */
  NO = 'NO',
  /** north-east (top-right corner) */
  NOEA = 'NOEA',
  /** north-west (top-left corner) */
  NOWE = 'NOWE',
  /** smart */
  SM = 'SM',
  /** south (bottom edge) */
  SO = 'SO',
  /** south-east (bottom-right corner) */
  SOEA = 'SOEA',
  /** south-west (bottom-left corner) */
  SOWE = 'SOWE',
  /** west (left edge) */
  WE = 'WE'
}

/** Responsive image resize type */
export enum ImageResize {
  /** if both source and resulting dimensions have the same orientation (portrait or landscape), imgproxy will use fill. Otherwise, it will use fit */
  AUTO = 'AUTO',
  /** image will be shrunk and cropped to fit within the area specified by width and height, the image will not be enlarged */
  CROP = 'CROP',
  /** resizes the image while keeping aspect ratio to fill given size and cropping projecting parts */
  FILL = 'FILL',
  /** the same as fill, but if the resized image is smaller than the requested size, imgproxy will crop the result to keep the requested aspect ratio */
  FILL_DOWN = 'FILL_DOWN',
  /** resizes the image while keeping aspect ratio to fit given size */
  FIT = 'FIT'
}

export enum ImageSorting {
  /** Latest */
  LATEST = 'LATEST',
  /** Relevance */
  RELEVANCE = 'RELEVANCE'
}

/** An interval */
export type Interval = {
  __typename?: 'Interval';
  /** The days of the interval */
  days?: Maybe<Scalars['Int']['output']>;
  /** The months of the interval */
  months?: Maybe<Scalars['Int']['output']>;
  /** The seconds of the interval */
  seconds?: Maybe<Scalars['Int']['output']>;
};

/** A job */
export type Job = {
  __typename?: 'Job';
  /** The job's meteor id */
  _id: Scalars['String']['output'];
  /** The account of the job */
  account?: Maybe<Account>;
  /** The account id of the job */
  accountId?: Maybe<Scalars['Int']['output']>;
  /**
   * The account manager of the job
   * @deprecated Use the job's account's account manager instead
   */
  accountManager?: Maybe<Scalars['String']['output']>;
  /** Is the job currently active? */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** The address */
  address?: Maybe<Scalars['String']['output']>;
  /** The address region (state or county) */
  addressRegion?: Maybe<Scalars['String']['output']>;
  /** The query to retrieve the applicants of the job */
  applicants: Array<Applicant>;
  /** The query to retrieve the applicants of the job */
  applicantsConnection: ApplicantConnection;
  /** The query to retrieve the count of applicants of the job */
  applicantsCount: Scalars['Int']['output'];
  /** Is the job using the FashionUnited apply form? */
  applyForm?: Maybe<Scalars['Boolean']['output']>;
  /** The job's application URL */
  applyUrl?: Maybe<Scalars['String']['output']>;
  /** The apply urls of the job on the FashionUnited job boards */
  applyUrls?: Maybe<JobUrls>;
  /** Is the job approved? */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** The job's building name (office, mall, etc.) */
  buildingName?: Maybe<Scalars['String']['output']>;
  /** The job's categories */
  categories: Array<Scalars['String']['output']>;
  /** Has the job's categories been guessed? */
  categoriesGuessed?: Maybe<Scalars['Boolean']['output']>;
  /** The last change date including the statistics */
  changedAt: Scalars['DateTime']['output'];
  /** The job's cities */
  cities: Array<City>;
  /** The job's cities */
  citiesConnection: CityConnection;
  /** The count of the job's cities */
  citiesCount: Scalars['Int']['output'];
  /** The city */
  city: Scalars['String']['output'];
  /** The job's city ids */
  cityIds: Array<Scalars['String']['output']>;
  /** The job's company information */
  company: JobCompany;
  /** The date when the email to the company was sent */
  companyEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The country */
  country: Scalars['String']['output'];
  /** The creator's email address for the job */
  createdByEmail?: Maybe<Scalars['String']['output']>;
  /** The id of the job's creator */
  createdById: Scalars['String']['output'];
  /** The creator of the job */
  creator?: Maybe<User>;
  /** Default locale for the job */
  defaultLocale?: Maybe<Scalars['String']['output']>;
  /** The job's description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether application emails are disabled */
  disableEmails?: Maybe<Scalars['Boolean']['output']>;
  /** The distance from the specified geometry in distanceFrom in meters */
  distance?: Maybe<Scalars['Float']['output']>;
  /** The expiry date of this job */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The job's external ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The GeoJSON location */
  geolocation?: Maybe<GeoJsonGeometry>;
  /** Whether the job has active highlight period */
  hasActiveHighlightPeriod: Scalars['Boolean']['output'];
  /** If the job was ever published */
  hasBeenPublished: Scalars['Boolean']['output'];
  /** Whether the job has expired */
  hasExpired: Scalars['Boolean']['output'];
  /** The periods when the job is highlighted (Job of the Week) */
  highlightPeriods: Array<JobHighlightPeriod>;
  /** The job's numeric id */
  id: Scalars['Int']['output'];
  /** The creation date of the job */
  insertedAt: Scalars['DateTime']['output'];
  /** The keywords of the job */
  keywords: Array<Scalars['String']['output']>;
  /** The locales of the sites where this job is posted */
  locales: Array<Scalars['String']['output']>;
  /** The job's unparsed location */
  location?: Maybe<Scalars['String']['output']>;
  /** The job's template properties, including the ones provided by the template */
  mergedProperties: Array<JobProperty>;
  /** The number of positions available for the job */
  numberOfPositions?: Maybe<Scalars['Int']['output']>;
  /** The job's position ids */
  positionIds: Array<Scalars['String']['output']>;
  /** The job's positions */
  positions: Array<Position>;
  /** The job's positions */
  positionsConnection: PositionConnection;
  /** The count of the job's positions */
  positionsCount: Scalars['Int']['output'];
  /** The postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The job's posting type */
  postingType: JobPostingType;
  /** The job's company profile ids */
  profileIds: Array<Scalars['String']['output']>;
  /** The job's company profiles */
  profiles: Array<Profile>;
  /** The job's company profiles */
  profilesConnection: ProfileConnection;
  /** The count of the job's company profiles */
  profilesCount: Scalars['Int']['output'];
  /** The job's template properties */
  properties: Array<JobProperty>;
  /** The publication dates of the job */
  publications: Array<Scalars['DateTime']['output']>;
  /** The last publication date of the job */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The region */
  region?: Maybe<Scalars['String']['output']>;
  /** The job's salary */
  salary?: Maybe<JobSalary>;
  /** If the job is scheduled to be published */
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  /** The job's sender */
  sender?: Maybe<Scalars['String']['output']>;
  /** Should the title be visible on the job's page? */
  showTitle?: Maybe<Scalars['Boolean']['output']>;
  /** The job's slug */
  slug: Scalars['String']['output'];
  /** The statistics of the job */
  statistics: JobStatistics;
  /** The job's status */
  status: JobStatus;
  /** The date when the email to customer service was sent */
  supportEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The job's teaser */
  teaser: Scalars['String']['output'];
  /** The job's template */
  template: Template;
  /** The job's title */
  title: Scalars['String']['output'];
  /** The date of the last update of the job */
  updatedAt: Scalars['DateTime']['output'];
  /** The id of the job's updater */
  updatedById: Scalars['String']['output'];
  /** The updater of the job */
  updater?: Maybe<User>;
  /** The urls of the job */
  urls?: Maybe<JobUrls>;
  /** The job's versions */
  versions: Array<JobVersion>;
  /** The job's versions' connection */
  versionsConnection: JobVersionConnection;
  /** The number of the job's versions */
  versionsCount: Scalars['Int']['output'];
};


/** A job */
export type JobapplicantsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
};


/** A job */
export type JobapplicantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
};


/** A job */
export type JobapplicantsCountArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
};


/** A job */
export type JobcitiesArgs = {
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobsFilter?: InputMaybe<JobsFilter>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<CitySorting>;
};


/** A job */
export type JobcitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobsFilter?: InputMaybe<JobsFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<CitySorting>;
};


/** A job */
export type JobcitiesCountArgs = {
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A job */
export type JobdefaultLocaleArgs = {
  preferredLocale?: InputMaybe<Scalars['String']['input']>;
};


/** A job */
export type JobpositionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
};


/** A job */
export type JobpositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A job */
export type JobpositionsCountArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A job */
export type JobprofilesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<ProfileSorting>;
};


/** A job */
export type JobprofilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfileSorting>;
};


/** A job */
export type JobversionsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** A job */
export type JobversionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The company information of a job */
export type JobCompany = {
  __typename?: 'JobCompany';
  /** The contact person of the company */
  contact?: Maybe<Scalars['String']['output']>;
  /** The company description */
  description?: Maybe<Scalars['String']['output']>;
  /** The display name of the company */
  displayName: Scalars['String']['output'];
  /** The email address of the company contact */
  email?: Maybe<Scalars['String']['output']>;
  /** The social media image url of the company */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive social media image urls */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The logo url of the company */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive logo urls */
  logoUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The name of the company */
  name: Scalars['String']['output'];
  /** The phone number of the company contact */
  phone?: Maybe<Scalars['String']['output']>;
};


/** The company information of a job */
export type JobCompanyimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** The company information of a job */
export type JobCompanylogoUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

/** Job company input */
export type JobCompanyInput = {
  /** The company's contact person for the job */
  contact?: InputMaybe<Scalars['String']['input']>;
  /** The company's display name for the job */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The company's email address for the job */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The social media image URL for the job */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The logo URL for the job */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The company's name for the job */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The company's phone number for the job */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type JobConnection = {
  __typename?: 'JobConnection';
  edges: Array<JobEdge>;
  pageInfo: PageInfo;
};

export type JobEdge = {
  __typename?: 'JobEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Job;
};

/** A highlight period of a job on a site identified by locale */
export type JobHighlightPeriod = {
  __typename?: 'JobHighlightPeriod';
  /** The beginning of the highlight period */
  beginsAt: Scalars['DateTime']['output'];
  /** The end of the highlight period */
  endsAt: Scalars['DateTime']['output'];
  /** The locale of the site of the highlight period */
  locale: Scalars['String']['output'];
  /** The type of the highlight period */
  type: HighlightPeriodType;
};

/** A highlight period input of a job on a site identified by locale */
export type JobHighlightPeriodInput = {
  /** The beginning of the highlight period */
  beginsAt: Scalars['DateTime']['input'];
  /** The end of the highlight period */
  endsAt: Scalars['DateTime']['input'];
  /** The locale of the site of the highlight period */
  locale: Scalars['String']['input'];
  /** The type of the highlight period */
  type: HighlightPeriodType;
};

/** A job */
export type JobInput = {
  /** The account id of the job */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** The job's address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The job's address region (state or county) */
  addressRegion?: InputMaybe<Scalars['String']['input']>;
  /** Is the job using the FashionUnited apply form? */
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** The job's external application URL */
  applyUrl?: InputMaybe<Scalars['String']['input']>;
  /** The job's building name (office, mall, etc.) */
  buildingName?: InputMaybe<Scalars['String']['input']>;
  /** The job's categories */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The job's city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The job's company information */
  company?: InputMaybe<JobCompanyInput>;
  /** The job's country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The creator's email address for the job */
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  /** Whether application emails are disabled */
  disableEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /** The GeoJSON location */
  geolocation?: InputMaybe<GeoJsonGeometryInput>;
  /** The locales of the sites where this job is posted */
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The job's unparsed location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** The number of positions available for the job */
  numberOfPositions?: InputMaybe<Scalars['Int']['input']>;
  /** The job's postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The id of the profile that will populate the company names */
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** The job's template properties */
  properties?: InputMaybe<Array<JobPropertyInput>>;
  /** The publication date of the job */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The job's region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The job's salary */
  salary?: InputMaybe<JobSalaryInput>;
  /** Should the title be visible on the job's page? */
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The job's teaser */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** The job's template id */
  templateId?: InputMaybe<Scalars['String']['input']>;
  /** The job's title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum JobPostingType {
  /** All */
  ALL = 'ALL',
  /** Automated */
  AUTOMATED = 'AUTOMATED',
  /** Manual */
  MANUAL = 'MANUAL'
}

/** The custom properties of a job */
export type JobProperty = {
  __typename?: 'JobProperty';
  /** The responsive image urls when value is an image */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The name of the propery */
  name: Scalars['String']['output'];
  /** The type of the property */
  type?: Maybe<Scalars['String']['output']>;
  /** The value of the property */
  value?: Maybe<Scalars['String']['output']>;
};


/** The custom properties of a job */
export type JobPropertyimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

/** The custom properties of a job */
export type JobPropertyInput = {
  /** The name of the propery */
  name: Scalars['String']['input'];
  /** The type of the property */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The value of the property */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A salary indication of a job */
export type JobSalary = {
  __typename?: 'JobSalary';
  /** The amount of the salary */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the salary */
  currency?: Maybe<Scalars['String']['output']>;
};

/** The input object for the salary indication of a job */
export type JobSalaryInput = {
  /** The amount of the salary */
  amount: Scalars['Float']['input'];
  /** The currency of the salary */
  currency: Scalars['String']['input'];
};

export enum JobSorting {
  /** By applicant count ascending */
  APPLICANT_COUNT_ASCENDING = 'APPLICANT_COUNT_ASCENDING',
  /** By applicant count descending */
  APPLICANT_COUNT_DESCENDING = 'APPLICANT_COUNT_DESCENDING',
  /** By apply button click count ascending */
  APPLY_BUTTON_CLICK_COUNT_ASCENDING = 'APPLY_BUTTON_CLICK_COUNT_ASCENDING',
  /** By apply button click count descending */
  APPLY_BUTTON_CLICK_COUNT_DESCENDING = 'APPLY_BUTTON_CLICK_COUNT_DESCENDING',
  /** By categories ascending */
  CATEGORIES_ASCENDING = 'CATEGORIES_ASCENDING',
  /** By categories descending */
  CATEGORIES_DESCENDING = 'CATEGORIES_DESCENDING',
  /** By city ascending */
  CITY_ASCENDING = 'CITY_ASCENDING',
  /** By city descending */
  CITY_DESCENDING = 'CITY_DESCENDING',
  /** By company name ascending */
  COMPANY_NAME_ASCENDING = 'COMPANY_NAME_ASCENDING',
  /** By company name descending */
  COMPANY_NAME_DESCENDING = 'COMPANY_NAME_DESCENDING',
  /** By country ascending */
  COUNTRY_ASCENDING = 'COUNTRY_ASCENDING',
  /** By country descending */
  COUNTRY_DESCENDING = 'COUNTRY_DESCENDING',
  /** By distance ascending */
  DISTANCE_ASCENDING = 'DISTANCE_ASCENDING',
  /** By distance descending */
  DISTANCE_DESCENDING = 'DISTANCE_DESCENDING',
  /** By expires at ascending */
  EXPIRES_AT_ASCENDING = 'EXPIRES_AT_ASCENDING',
  /** By expires at descending */
  EXPIRES_AT_DESCENDING = 'EXPIRES_AT_DESCENDING',
  /** By id ascending */
  ID_ASCENDING = 'ID_ASCENDING',
  /** By id descending */
  ID_DESCENDING = 'ID_DESCENDING',
  /** By inserted at ascending */
  INSERTED_AT_ASCENDING = 'INSERTED_AT_ASCENDING',
  /** By inserted at descending */
  INSERTED_AT_DESCENDING = 'INSERTED_AT_DESCENDING',
  /** By locales ascending */
  LOCALES_ASCENDING = 'LOCALES_ASCENDING',
  /** By locales descending */
  LOCALES_DESCENDING = 'LOCALES_DESCENDING',
  /** By pageview count ascending */
  PAGE_VIEW_COUNT_ASCENDING = 'PAGE_VIEW_COUNT_ASCENDING',
  /** By pageview count descending */
  PAGE_VIEW_COUNT_DESCENDING = 'PAGE_VIEW_COUNT_DESCENDING',
  /** By publication date ascending */
  PUBLISHED_AT_ASCENDING = 'PUBLISHED_AT_ASCENDING',
  /** By publication date descending */
  PUBLISHED_AT_DESCENDING = 'PUBLISHED_AT_DESCENDING',
  /** By status ascending */
  STATUS_ASCENDING = 'STATUS_ASCENDING',
  /** By status descending */
  STATUS_DESCENDING = 'STATUS_DESCENDING',
  /** By title ascending */
  TITLE_ASCENDING = 'TITLE_ASCENDING',
  /** By title descending */
  TITLE_DESCENDING = 'TITLE_DESCENDING'
}

/** The statistics of a job */
export type JobStatistics = {
  __typename?: 'JobStatistics';
  /** The number of applications */
  applicantCount?: Maybe<Scalars['Int']['output']>;
  /** The number of apply button clicks */
  applyButtonClickCount?: Maybe<Scalars['Int']['output']>;
  /** The date of the last application */
  lastApplicationAt?: Maybe<Scalars['DateTime']['output']>;
  /** The number of page views */
  pageViewCount?: Maybe<Scalars['Int']['output']>;
};

export enum JobStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** All */
  ALL = 'ALL',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Pending */
  PENDING = 'PENDING',
  /** Scheduled */
  SCHEDULED = 'SCHEDULED'
}

/** The urls of a job */
export type JobUrls = {
  __typename?: 'JobUrls';
  /** The url for locale bg-BG */
  bgBg?: Maybe<Scalars['String']['output']>;
  /** The url for locale cs-CZ */
  csCz?: Maybe<Scalars['String']['output']>;
  /** The url for locale da-DK */
  daDk?: Maybe<Scalars['String']['output']>;
  /** The url for locale de-AT */
  deAt?: Maybe<Scalars['String']['output']>;
  /** The url for locale de-CH */
  deCh?: Maybe<Scalars['String']['output']>;
  /** The url for locale de-DE */
  deDe?: Maybe<Scalars['String']['output']>;
  /** The url for locale el-CY */
  elCy?: Maybe<Scalars['String']['output']>;
  /** The url for locale el-GR */
  elGr?: Maybe<Scalars['String']['output']>;
  /** The url for locale en-AU */
  enAu?: Maybe<Scalars['String']['output']>;
  /** The url for locale en-CA */
  enCa?: Maybe<Scalars['String']['output']>;
  /** The url for locale en-GB */
  enGb?: Maybe<Scalars['String']['output']>;
  /** The url for locale en-IE */
  enIe?: Maybe<Scalars['String']['output']>;
  /** The url for locale en-IN */
  enIn?: Maybe<Scalars['String']['output']>;
  /** The url for locale en-NZ */
  enNz?: Maybe<Scalars['String']['output']>;
  /** The url for locale en-US */
  enUs?: Maybe<Scalars['String']['output']>;
  /** The url for locale es-AR */
  esAr?: Maybe<Scalars['String']['output']>;
  /** The url for locale es-CL */
  esCl?: Maybe<Scalars['String']['output']>;
  /** The url for locale es-CO */
  esCo?: Maybe<Scalars['String']['output']>;
  /** The url for locale es-ES */
  esEs?: Maybe<Scalars['String']['output']>;
  /** The url for locale es-MX */
  esMx?: Maybe<Scalars['String']['output']>;
  /** The url for locale es-PE */
  esPe?: Maybe<Scalars['String']['output']>;
  /** The url for locale et-EE */
  etEe?: Maybe<Scalars['String']['output']>;
  /** The url for locale fi-FI */
  fiFi?: Maybe<Scalars['String']['output']>;
  /** The url for locale fr-BE */
  frBe?: Maybe<Scalars['String']['output']>;
  /** The url for locale fr-CH */
  frCh?: Maybe<Scalars['String']['output']>;
  /** The url for locale fr-FR */
  frFr?: Maybe<Scalars['String']['output']>;
  /** The url for locale fr-LU */
  frLu?: Maybe<Scalars['String']['output']>;
  /** The url for locale hr-HR */
  hrHr?: Maybe<Scalars['String']['output']>;
  /** The url for locale hu-HU */
  huHu?: Maybe<Scalars['String']['output']>;
  /** The url for locale it-CH */
  itCh?: Maybe<Scalars['String']['output']>;
  /** The url for locale it-IT */
  itIt?: Maybe<Scalars['String']['output']>;
  /** The url for locale ja-JP */
  jaJp?: Maybe<Scalars['String']['output']>;
  /** The url for locale lt-LT */
  ltLt?: Maybe<Scalars['String']['output']>;
  /** The url for locale lv-LV */
  lvLv?: Maybe<Scalars['String']['output']>;
  /** The url for locale mt-MT */
  mtMt?: Maybe<Scalars['String']['output']>;
  /** The url for locale nb-NO */
  nbNo?: Maybe<Scalars['String']['output']>;
  /** The url for locale nl-BE */
  nlBe?: Maybe<Scalars['String']['output']>;
  /** The url for locale nl-NL */
  nlNl?: Maybe<Scalars['String']['output']>;
  /** The url for locale pl-PL */
  plPl?: Maybe<Scalars['String']['output']>;
  /** The url for locale pt-BR */
  ptBr?: Maybe<Scalars['String']['output']>;
  /** The url for locale pt-PT */
  ptPt?: Maybe<Scalars['String']['output']>;
  /** The url for locale ro-RO */
  roRo?: Maybe<Scalars['String']['output']>;
  /** The url for locale ru-RU */
  ruRu?: Maybe<Scalars['String']['output']>;
  /** The url for locale sk-SK */
  skSk?: Maybe<Scalars['String']['output']>;
  /** The url for locale sl-SI */
  slSi?: Maybe<Scalars['String']['output']>;
  /** The url for locale sv-SE */
  svSe?: Maybe<Scalars['String']['output']>;
  /** The url for locale tr-TR */
  trTr?: Maybe<Scalars['String']['output']>;
  /** The url for locale zh-CN */
  zhCn?: Maybe<Scalars['String']['output']>;
  /** The url for locale zh-HK */
  zhHk?: Maybe<Scalars['String']['output']>;
};

/** A job version */
export type JobVersion = {
  __typename?: 'JobVersion';
  /** The job version's id */
  _id: Scalars['String']['output'];
  /**
   * The account manager of the job
   * @deprecated Use the job's account's account manager instead
   */
  accountManager?: Maybe<Scalars['String']['output']>;
  /** Is the job currently active? */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** The address */
  address?: Maybe<Scalars['String']['output']>;
  /** The address region (state or county) */
  addressRegion?: Maybe<Scalars['String']['output']>;
  /** Is the job using the FashionUnited apply form? */
  applyForm?: Maybe<Scalars['Boolean']['output']>;
  /** The job's application URL */
  applyUrl?: Maybe<Scalars['String']['output']>;
  /** The apply urls of the job on the FashionUnited job boards */
  applyUrls?: Maybe<JobUrls>;
  /** Is the job approved? */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** The job's building name (office, mall, etc.) */
  buildingName?: Maybe<Scalars['String']['output']>;
  /** The job's categories */
  categories: Array<Scalars['String']['output']>;
  /** Has the job's categories been guessed? */
  categoriesGuessed?: Maybe<Scalars['Boolean']['output']>;
  /** The last change date including the statistics */
  changedAt: Scalars['DateTime']['output'];
  /** The job's cities */
  cities: Array<City>;
  /** The job's cities */
  citiesConnection: CityConnection;
  /** The count of the job's cities */
  citiesCount: Scalars['Int']['output'];
  /** The city */
  city: Scalars['String']['output'];
  /** The job's city ids */
  cityIds: Array<Scalars['String']['output']>;
  /** The job's company information */
  company: JobCompany;
  /** The date when the email to the company was sent */
  companyEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The country */
  country: Scalars['String']['output'];
  /** The creator's email address for the job */
  createdByEmail?: Maybe<Scalars['String']['output']>;
  /** The id of the job's creator */
  createdById: Scalars['String']['output'];
  /** The creator of the job */
  creator?: Maybe<User>;
  /** The job's description */
  description?: Maybe<Scalars['String']['output']>;
  /** The expiry date of this job */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The job's external ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The GeoJSON location */
  geolocation?: Maybe<GeoJsonGeometry>;
  /** The periods when the job is highlighted (Job of the Week) */
  highlightPeriods: Array<JobHighlightPeriod>;
  /** The creation date of the job */
  insertedAt: Scalars['DateTime']['output'];
  /** The job's id */
  jobId?: Maybe<Scalars['String']['output']>;
  /** The keywords of the job */
  keywords: Array<Scalars['String']['output']>;
  /** The locales of the sites where this job is posted */
  locales: Array<Scalars['String']['output']>;
  /** The job's unparsed location */
  location?: Maybe<Scalars['String']['output']>;
  /** The job's template properties, including the ones provided by the template */
  mergedProperties: Array<JobProperty>;
  /** The number of positions available for the job */
  numberOfPositions?: Maybe<Scalars['Int']['output']>;
  /** The job's position ids */
  positionIds: Array<Scalars['String']['output']>;
  /** The job's positions */
  positions: Array<Position>;
  /** The job's positions */
  positionsConnection: PositionConnection;
  /** The count of the job's positions */
  positionsCount: Scalars['Int']['output'];
  /** The postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The job's company profile ids */
  profileIds: Array<Scalars['String']['output']>;
  /** The job's company profiles */
  profiles: Array<Profile>;
  /** The job's company profiles */
  profilesConnection: ProfileConnection;
  /** The count of the job's company profiles */
  profilesCount: Scalars['Int']['output'];
  /** The job's template properties */
  properties: Array<JobProperty>;
  /** The publication dates of the job */
  publications: Array<Scalars['DateTime']['output']>;
  /** The last publication date of the job */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The region */
  region?: Maybe<Scalars['String']['output']>;
  /** The job's salary */
  salary?: Maybe<JobSalary>;
  /** If the job is scheduled to be published */
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  /** The job's sender */
  sender?: Maybe<Scalars['String']['output']>;
  /** Should the title be visible on the job's page? */
  showTitle?: Maybe<Scalars['Boolean']['output']>;
  /** The job's slug */
  slug: Scalars['String']['output'];
  /** The statistics of the job */
  statistics: JobStatistics;
  /** The date when the email to customer service was sent */
  supportEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The job's teaser */
  teaser: Scalars['String']['output'];
  /** The job's template */
  template: Template;
  /** The job's title */
  title: Scalars['String']['output'];
  /** The date of the last update of the job */
  updatedAt: Scalars['DateTime']['output'];
  /** The id of the job's updater */
  updatedById: Scalars['String']['output'];
  /** The updater of the job */
  updater?: Maybe<User>;
  /** The urls of the job */
  urls?: Maybe<JobUrls>;
  /** The job's version number */
  version?: Maybe<Scalars['Int']['output']>;
};


/** A job version */
export type JobVersioncitiesArgs = {
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobsFilter?: InputMaybe<JobsFilter>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<CitySorting>;
};


/** A job version */
export type JobVersioncitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobsFilter?: InputMaybe<JobsFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<CitySorting>;
};


/** A job version */
export type JobVersioncitiesCountArgs = {
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A job version */
export type JobVersionpositionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
};


/** A job version */
export type JobVersionpositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A job version */
export type JobVersionpositionsCountArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A job version */
export type JobVersionprofilesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<ProfileSorting>;
};


/** A job version */
export type JobVersionprofilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfileSorting>;
};

export type JobVersionConnection = {
  __typename?: 'JobVersionConnection';
  edges: Array<JobVersionEdge>;
  pageInfo: PageInfo;
};

export type JobVersionEdge = {
  __typename?: 'JobVersionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: JobVersion;
};

export type JobsFilter = {
  /** Filter category of the jobs */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the city of the jobs */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Filter by city_id of the jobs */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the exact company name of the jobs */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the company name of the jobs */
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Include past and future highlighted jobs */
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for the highlighted jobs for a locale */
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  /** Filter highlighted jobs by type */
  highlightType?: InputMaybe<HighlightPeriodType>;
  /** Filter jobs by a list of ids */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** A keywords to look for in the jobs */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** A list of locales where the jobs are posted */
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by all the location fields of the jobs */
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  /** Filter jobs by maximum current expiry date */
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter jobs by maximum creation date */
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter jobs by maximum all time publication date */
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter jobs by maximum current publication date */
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter jobs by minimum current expiry date */
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter jobs by minimum creation date */
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter jobs by minimum all time publication date */
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter jobs by minimum current publication date */
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by company profile news tags */
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by position_id of the jobs */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Filter jobs by posting type */
  postingType?: InputMaybe<JobPostingType>;
  /** Filter by company profile_id of the jobs */
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by multiple company profile_id of the jobs */
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by profile IDs or keywords */
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  /** Filter jobs associated to the user's company profile */
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by */
  sort?: InputMaybe<JobSorting>;
  /** Filter jobs by status */
  status?: InputMaybe<JobStatus>;
  /** Filter by the template of the jobs */
  templateId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the title of the jobs */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A jobs integration */
export type JobsIntegration = {
  __typename?: 'JobsIntegration';
  /** The ID (sender) of the jobs integration */
  id: Scalars['String']['output'];
  /** The number of jobs by this integration */
  jobsCount: Scalars['Int']['output'];
  /** The last creation date */
  lastInsertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The last publication date */
  lastPublication?: Maybe<Scalars['DateTime']['output']>;
  /** The last active publication date */
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The last modification date */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A jobs integration */
export type JobsIntegrationjobsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A jobs integration */
export type JobsIntegrationlastInsertedAtArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A jobs integration */
export type JobsIntegrationlastPublicationArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A jobs integration */
export type JobsIntegrationlastPublishedAtArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A jobs integration */
export type JobsIntegrationlastUpdatedAtArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum JobsIntegrationSorting {
  /** Alphabetical */
  ALPHABETICAL = 'ALPHABETICAL',
  /** By jobs count */
  JOBS_COUNT = 'JOBS_COUNT'
}

/** An article in a local news board */
export type LocalNewsArticle = UniversalNewsArticle & {
  __typename?: 'LocalNewsArticle';
  /** The article's access level */
  accessLevel: AccessLevel;
  /** The article's attributes */
  attributes?: Maybe<NewsArticleAttributes>;
  /** Whether the article is auto-translated */
  autoTranslated: Scalars['Boolean']['output'];
  /** The article's body */
  body: Scalars['String']['output'];
  /** The article's category on the site */
  category?: Maybe<LocalNewsCategory>;
  /**
   * The article's creation date on the site
   * @deprecated Use insertedAt instead
   */
  createdAt: Scalars['DateTime']['output'];
  /** The article's creator user on the site */
  creator?: Maybe<LocalNewsUser>;
  /** The article's dek */
  dek?: Maybe<Scalars['String']['output']>;
  /** The article's meta description */
  description?: Maybe<Scalars['String']['output']>;
  /** The article's text as displayed on the site */
  displayText: Scalars['String']['output'];
  /** Is the article featured? */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** The article's first paragraph */
  firstParagraph: Scalars['String']['output'];
  /** Has the current user access to the artice? */
  hasAccess: Scalars['Boolean']['output'];
  /** The article's id */
  id: Scalars['Int']['output'];
  /** The caption of article's image */
  imageCaption?: Maybe<Scalars['String']['output']>;
  /** The url of article's image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The article's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The article's path on the site with joomla parameters */
  joomlaPath?: Maybe<Scalars['String']['output']>;
  /** The article's url on the site with joomla parameters */
  joomlaUrl?: Maybe<Scalars['String']['output']>;
  /** The article's meta keywords */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The acticle's labels */
  labels: Array<Scalars['String']['output']>;
  /** The article's pageviews */
  pageviews?: Maybe<Scalars['Int']['output']>;
  /** Is the news article partner content? */
  partnerContent: Scalars['Boolean']['output'];
  /** The article's path on the site */
  path?: Maybe<Scalars['String']['output']>;
  /** Is the news article a press release? */
  pressRelease: Scalars['Boolean']['output'];
  /** The article's scheduled publication date, null if not scheduled */
  publishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reference of the news article */
  reference?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  responsiveImageUrls?: Maybe<ResponsiveImageUrls>;
  /** The scores */
  scores: Array<Score>;
  /** The article's slug */
  slug: Scalars['String']['output'];
  /** The acticle's status: trashed, unpublished, published, archived */
  status: NewsArticleStatus;
  /** The article's summary */
  summary: Scalars['String']['output'];
  /** The article's tags */
  tags: Array<Tag>;
  /** The article's tags */
  tagsConnection: TagConnection;
  /** The count of the article's tags */
  tagsCount: Scalars['Int']['output'];
  /** The article's text */
  text: Scalars['String']['output'];
  /** The article's title */
  title: Scalars['String']['output'];
  /** The article's scheduled unpublish date, null if not scheduled */
  unpublishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The article's date of last modification */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who updated the article the last on the site */
  updater?: Maybe<LocalNewsUser>;
  /** The article's url on the site */
  url?: Maybe<Scalars['String']['output']>;
  /** The article's version */
  version?: Maybe<Scalars['Int']['output']>;
  /** The article's visibility: PUBLIC, REGISTERED, SPECIAL */
  visibility: NewsArticleVisibility;
};


/** An article in a local news board */
export type LocalNewsArticlecategoryArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in a local news board */
export type LocalNewsArticleimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** An article in a local news board */
export type LocalNewsArticlepageviewsArgs = {
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
};


/** An article in a local news board */
export type LocalNewsArticlescoresArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in a local news board */
export type LocalNewsArticletagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in a local news board */
export type LocalNewsArticletagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in a local news board */
export type LocalNewsArticletagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LocalNewsArticleConnection = UniversalNewsArticleConnection & {
  __typename?: 'LocalNewsArticleConnection';
  edges: Array<LocalNewsArticleEdge>;
  pageInfo: PageInfo;
};

export type LocalNewsArticleEdge = UniversalNewsArticleEdge & {
  __typename?: 'LocalNewsArticleEdge';
  cursor: Scalars['String']['output'];
  node: LocalNewsArticle;
};

/** A category of a local news board */
export type LocalNewsCategory = UniversalNewsCategory & {
  __typename?: 'LocalNewsCategory';
  /** The article's access level */
  accessLevel: AccessLevel;
  /** The article's attributes */
  attributes?: Maybe<NewsArticleAttributes>;
  /** Whether the article is auto-translated */
  autoTranslated: Scalars['Boolean']['output'];
  /** The article's body */
  body: Scalars['String']['output'];
  /**
   * The article's creation date on the site
   * @deprecated Use insertedAt instead
   */
  createdAt: Scalars['DateTime']['output'];
  /** The article's dek */
  dek?: Maybe<Scalars['String']['output']>;
  /** The article's meta description */
  description?: Maybe<Scalars['String']['output']>;
  /** The article's text as displayed on the site */
  displayText: Scalars['String']['output'];
  /** Is the article featured? */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** The article's first paragraph */
  firstParagraph: Scalars['String']['output'];
  /** Has the current user access to the artice? */
  hasAccess: Scalars['Boolean']['output'];
  /** The article's id */
  id: Scalars['Int']['output'];
  /** The caption of article's image */
  imageCaption?: Maybe<Scalars['String']['output']>;
  /** The url of article's image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The article's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The article's meta keywords */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The acticle's labels */
  labels: Array<Scalars['String']['output']>;
  /** The news articles related to this category */
  newsArticles: Array<LocalNewsArticle>;
  /** The news article connection of the category's local article */
  newsArticlesConnection: LocalNewsArticleConnection;
  /** The count of the category's local article */
  newsArticlesCount: Scalars['Int']['output'];
  /** The category's path */
  path?: Maybe<Scalars['String']['output']>;
  /** The article's scheduled publication date, null if not scheduled */
  publishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reference of the news article */
  reference?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  responsiveImageUrls?: Maybe<ResponsiveImageUrls>;
  /** The scores */
  scores: Array<Score>;
  /** The article's slug */
  slug: Scalars['String']['output'];
  /** The acticle's status: trashed, unpublished, published, archived */
  status: NewsArticleStatus;
  /** The article's summary */
  summary: Scalars['String']['output'];
  /** The article's tags */
  tags: Array<Tag>;
  /** The article's tags */
  tagsConnection: TagConnection;
  /** The count of the article's tags */
  tagsCount: Scalars['Int']['output'];
  /** The article's text */
  text: Scalars['String']['output'];
  /** The article's title */
  title: Scalars['String']['output'];
  /** The article's scheduled unpublish date, null if not scheduled */
  unpublishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The article's date of last modification */
  updatedAt: Scalars['DateTime']['output'];
  /** The article's version */
  version?: Maybe<Scalars['Int']['output']>;
  /** The article's visibility: PUBLIC, REGISTERED, SPECIAL */
  visibility: NewsArticleVisibility;
};


/** A category of a local news board */
export type LocalNewsCategoryimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A category of a local news board */
export type LocalNewsCategorynewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A category of a local news board */
export type LocalNewsCategorynewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A category of a local news board */
export type LocalNewsCategorynewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A category of a local news board */
export type LocalNewsCategoryscoresArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A category of a local news board */
export type LocalNewsCategorytagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A category of a local news board */
export type LocalNewsCategorytagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A category of a local news board */
export type LocalNewsCategorytagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A local newsboard user */
export type LocalNewsUser = UniversalNewsUser & {
  __typename?: 'LocalNewsUser';
  bio?: Maybe<Scalars['String']['output']>;
  /** The user's biography HTML */
  bioHtml?: Maybe<Scalars['String']['output']>;
  /** The user's email address */
  email: Scalars['String']['output'];
  /** The user's id */
  id: Scalars['Int']['output'];
  /** The image url of the author */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of the author */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The user's full name */
  name: Scalars['String']['output'];
  /** The news articles of the author */
  newsArticles: Array<LocalNewsArticle>;
  /** The news article connection of the author */
  newsArticlesConnection: LocalNewsArticleConnection;
  /** The count of the author's news articles */
  newsArticlesCount: Scalars['Int']['output'];
};


/** A local newsboard user */
export type LocalNewsUserimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A local newsboard user */
export type LocalNewsUsernewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A local newsboard user */
export type LocalNewsUsernewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A local newsboard user */
export type LocalNewsUsernewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum LocalNewsboard {
  /** https://au.fashionunited.com/ */
  AU_FASHIONUNITED_COM = 'AU_FASHIONUNITED_COM',
  /** https://fashionunited.be/ */
  FASHIONUNITED_BE = 'FASHIONUNITED_BE',
  /** https://fashionunited.be/fr/ */
  FASHIONUNITED_BE_FR = 'FASHIONUNITED_BE_FR',
  /** https://fashionunited.ca/ */
  FASHIONUNITED_CA = 'FASHIONUNITED_CA',
  /** https://fashionunited.ca/fr/ */
  FASHIONUNITED_CA_FR = 'FASHIONUNITED_CA_FR',
  /** https://fashionunited.ch/ */
  FASHIONUNITED_CH = 'FASHIONUNITED_CH',
  /** https://fashionunited.cl/ */
  FASHIONUNITED_CL = 'FASHIONUNITED_CL',
  /** https://cn.fashionunited.com/ */
  FASHIONUNITED_CN = 'FASHIONUNITED_CN',
  /** https://fashionunited.co/ */
  FASHIONUNITED_CO = 'FASHIONUNITED_CO',
  /** https://fashionunited.com/ */
  FASHIONUNITED_COM = 'FASHIONUNITED_COM',
  /** https://fashionunited.com.ar/ */
  FASHIONUNITED_COM_AR = 'FASHIONUNITED_COM_AR',
  /** https://fashionunited.com.pe/ */
  FASHIONUNITED_COM_PE = 'FASHIONUNITED_COM_PE',
  /** https://fashionunited.de/ */
  FASHIONUNITED_DE = 'FASHIONUNITED_DE',
  /** https://fashionunited.es/ */
  FASHIONUNITED_ES = 'FASHIONUNITED_ES',
  /** https://fashionunited.fr/ */
  FASHIONUNITED_FR = 'FASHIONUNITED_FR',
  /** https://fashionunited.in/ */
  FASHIONUNITED_IN = 'FASHIONUNITED_IN',
  /** https://fashionunited.info/ */
  FASHIONUNITED_INFO = 'FASHIONUNITED_INFO',
  /** https://fashionunited.it/ */
  FASHIONUNITED_IT = 'FASHIONUNITED_IT',
  /** https://fashionunited.mx/ */
  FASHIONUNITED_MX = 'FASHIONUNITED_MX',
  /** https://fashionunited.nl/ */
  FASHIONUNITED_NL = 'FASHIONUNITED_NL',
  /** https://fashionunited.nz/ */
  FASHIONUNITED_NZ = 'FASHIONUNITED_NZ',
  /** https://ru.fashionunited.com/ */
  FASHIONUNITED_RU = 'FASHIONUNITED_RU',
  /** https://fashionunited.uk/ */
  FASHIONUNITED_UK = 'FASHIONUNITED_UK',
  /** https://fashionweekweb.com/ */
  FASHIONWEEKWEB_COM = 'FASHIONWEEKWEB_COM',
  /** https://internationalfashionjobs.com/ */
  INTERNATIONALFASHIONJOBS_COM = 'INTERNATIONALFASHIONJOBS_COM'
}

/** A location */
export type Location = {
  __typename?: 'Location';
  /** The address */
  address?: Maybe<Scalars['String']['output']>;
  /** The address region (state or county) */
  addressRegion?: Maybe<Scalars['String']['output']>;
  /** The city */
  city: Scalars['String']['output'];
  /** The country */
  country: Scalars['String']['output'];
  /** The GeoJSON location */
  geolocation?: Maybe<GeoJsonGeometry>;
  /** The postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The region */
  region?: Maybe<Scalars['String']['output']>;
};

export type Market = {
  __typename?: 'Market';
  /** The body text of the market */
  body?: Maybe<Scalars['String']['output']>;
  /** The description of the market */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of the market */
  id: Scalars['Int']['output'];
  /** The image url of the market */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of the market */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The market's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The name of the market */
  name: Scalars['String']['output'];
  /** The slug of the market */
  slug: Scalars['String']['output'];
  /** The stands of the market */
  stands: Array<Stand>;
  /** The stands of the market */
  standsConnection: StandConnection;
  /** The text of the market */
  text?: Maybe<Scalars['String']['output']>;
  /** The market's last modification date */
  updatedAt: Scalars['DateTime']['output'];
};


export type MarketimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


export type MarketstandsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type MarketstandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketAccessRequest = {
  __typename?: 'MarketAccessRequest';
  /** The id of the market access request */
  id: Scalars['Int']['output'];
  /** The market of the access request */
  market: Market;
  /** The user of the access request */
  user?: Maybe<User>;
};

export type MarketAccessRequestConnection = {
  __typename?: 'MarketAccessRequestConnection';
  edges: Array<MarketAccessRequestEdge>;
  pageInfo: PageInfo;
};

export type MarketAccessRequestEdge = {
  __typename?: 'MarketAccessRequestEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: MarketAccessRequest;
};

export type MarketConnection = {
  __typename?: 'MarketConnection';
  edges: Array<MarketEdge>;
  pageInfo: PageInfo;
};

export type MarketEdge = {
  __typename?: 'MarketEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Market;
};

export type Material = {
  __typename?: 'Material';
  /** The id of the material */
  id: Scalars['Int']['output'];
  /** The name of the material */
  name: Scalars['String']['output'];
};

export type MaterialConnection = {
  __typename?: 'MaterialConnection';
  edges: Array<MaterialEdge>;
  pageInfo: PageInfo;
};

export type MaterialEdge = {
  __typename?: 'MaterialEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Material;
};

/** Monthly count */
export type MonthlyCount = {
  __typename?: 'MonthlyCount';
  /** The count */
  count?: Maybe<Scalars['Int']['output']>;
  /** The month */
  month?: Maybe<Scalars['String']['output']>;
};

/** An article in the central news board */
export type NewsArticle = UniversalNewsArticle & {
  __typename?: 'NewsArticle';
  /** The article's access level */
  accessLevel: AccessLevel;
  /** The article's attributes */
  attributes?: Maybe<NewsArticleAttributes>;
  /** The article on https://au.fashionunited.com */
  auFashionunitedComNewsArticle?: Maybe<LocalNewsArticle>;
  /** Whether the article is auto-translated */
  autoTranslated: Scalars['Boolean']['output'];
  /** The article's body */
  body: Scalars['String']['output'];
  /**
   * The article's category like: fashion, retail, business, culture, people,
   * fairs, news, schools, report, management, video
   */
  category?: Maybe<NewsCategory>;
  /** The comments for the news article */
  comments?: Maybe<Scalars['String']['output']>;
  /**
   * The article's creation date on the site
   * @deprecated Use insertedAt instead
   */
  createdAt: Scalars['DateTime']['output'];
  /** The article's creator user */
  creator?: Maybe<NewsUser>;
  /** The article's dek */
  dek?: Maybe<Scalars['String']['output']>;
  /** The article's meta description */
  description?: Maybe<Scalars['String']['output']>;
  /** The article's text as displayed on the site */
  displayText: Scalars['String']['output'];
  /** The duplicates of the article */
  duplicateNewsArticles: Array<NewsArticle>;
  /** The duplicates of the article */
  duplicateNewsArticlesConnection: NewsArticleConnection;
  /** The query to retrieve the number of duplicates of the article */
  duplicateNewsArticlesCount: Scalars['Int']['output'];
  /** The article on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.be */
  fashionunitedBeNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.ca */
  fashionunitedCaNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.ch */
  fashionunitedChNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.cl */
  fashionunitedClNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://cn.fashionunited.com */
  fashionunitedCnNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.co */
  fashionunitedCoNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.com.ar */
  fashionunitedComArNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article's url on https://fashionunited.com.br */
  fashionunitedComBrUrl?: Maybe<Scalars['String']['output']>;
  /** The article on https://fashionunited.com */
  fashionunitedComNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.de */
  fashionunitedDeNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.es */
  fashionunitedEsNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.fr */
  fashionunitedFrNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article's url on https://fashionunited.ie */
  fashionunitedIeUrl?: Maybe<Scalars['String']['output']>;
  /** The article on https://fashionunited.in */
  fashionunitedInNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.info */
  fashionunitedInfoNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.it */
  fashionunitedItNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article's url on https://fashionunited.jp */
  fashionunitedJpUrl?: Maybe<Scalars['String']['output']>;
  /** The article on https://fashionunited.mx */
  fashionunitedMxNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.nl */
  fashionunitedNlNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.nz */
  fashionunitedNzNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://ru.fashionunited.com */
  fashionunitedRuNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionunited.uk */
  fashionunitedUkNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article on https://fashionweekweb.com */
  fashionweekwebComNewsArticle?: Maybe<LocalNewsArticle>;
  /** Is the article featured? */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** The article's first paragraph */
  firstParagraph: Scalars['String']['output'];
  /** Has the current user access to the artice? */
  hasAccess: Scalars['Boolean']['output'];
  /** Has the article markdown? */
  hasMarkdown: Scalars['Boolean']['output'];
  /** Has the article HTML been modified? */
  htmlModified: Scalars['Boolean']['output'];
  /** The article's id */
  id: Scalars['Int']['output'];
  /** The caption of article's image */
  imageCaption?: Maybe<Scalars['String']['output']>;
  /** The url of article's image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The article's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The article on https://internationalfashionjobs.com */
  internationalfashionjobsComNewsArticle?: Maybe<LocalNewsArticle>;
  /** The article's meta keywords */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The acticle's labels */
  labels: Array<Scalars['String']['output']>;
  /** The article's language */
  language: Scalars['String']['output'];
  /** The article's markdown text if the article was written in markdown */
  markdown?: Maybe<Scalars['String']['output']>;
  /** The article is posted on the following newsboards */
  newsboards: Array<Newsboard>;
  /** The original article */
  originalNewsArticle?: Maybe<NewsArticle>;
  /** Has the article been created by the current user? */
  own: Scalars['Boolean']['output'];
  /** The article's pageviews */
  pageviews?: Maybe<Scalars['Int']['output']>;
  /** Is the news article partner content? */
  partnerContent: Scalars['Boolean']['output'];
  /** Is the news article a press release? */
  pressRelease: Scalars['Boolean']['output'];
  /** The article's scheduled publication date, null if not scheduled */
  publishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reference of the news article */
  reference?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  responsiveImageUrls?: Maybe<ResponsiveImageUrls>;
  /** The scores */
  scores: Array<Score>;
  /** The article's slug */
  slug: Scalars['String']['output'];
  /** Whether the article's slug is locked */
  slugLocked: Scalars['Boolean']['output'];
  /** The acticle's status: trashed, unpublished, published, archived */
  status: NewsArticleStatus;
  /** The article's suggested tags */
  suggestedTags: Array<Tag>;
  /** The article's suggested tags */
  suggestedTagsConnection: TagConnection;
  /** The count of the article's suggested tags */
  suggestedTagsCount: Scalars['Int']['output'];
  /** The article's summary */
  summary: Scalars['String']['output'];
  /** The article's tags */
  tags: Array<Tag>;
  /** The article's tags */
  tagsConnection: TagConnection;
  /** The count of the article's tags */
  tagsCount: Scalars['Int']['output'];
  /** The article's text */
  text: Scalars['String']['output'];
  /** The article's title */
  title: Scalars['String']['output'];
  /** The article's scheduled unpublish date, null if not scheduled */
  unpublishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The article's date of last modification */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who updated the article the last */
  updater?: Maybe<NewsUser>;
  /** The article's version */
  version?: Maybe<Scalars['Int']['output']>;
  /** The article's visibility: PUBLIC, REGISTERED, SPECIAL */
  visibility: NewsArticleVisibility;
};


/** An article in the central news board */
export type NewsArticlecategoryArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticleduplicateNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** An article in the central news board */
export type NewsArticleduplicateNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** An article in the central news board */
export type NewsArticleduplicateNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedBeFrNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedBeNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedCaFrNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedCaNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedChNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedClNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedCnNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedCoNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedComArNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedComNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedComPeNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedDeNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedEsNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedFrNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedInNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedItNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedMxNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedNlNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedRuNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionunitedUkNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlefashionweekwebComNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticleimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** An article in the central news board */
export type NewsArticleoriginalNewsArticleArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** An article in the central news board */
export type NewsArticlepageviewsArgs = {
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
};


/** An article in the central news board */
export type NewsArticlescoresArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in the central news board */
export type NewsArticlesuggestedTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in the central news board */
export type NewsArticlesuggestedTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in the central news board */
export type NewsArticlesuggestedTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in the central news board */
export type NewsArticletagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in the central news board */
export type NewsArticletagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An article in the central news board */
export type NewsArticletagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Attributes of a news article */
export type NewsArticleAttributes = {
  __typename?: 'NewsArticleAttributes';
  /** Add a custom Tag */
  alternativeReadmore?: Maybe<Scalars['String']['output']>;
  /** Use a different layout from the supplied component view or overrides in the templates */
  articleLayout?: Maybe<Scalars['String']['output']>;
  /** Alternative article page title */
  articlePageTitle?: Maybe<Scalars['String']['output']>;
  /** Puts the article information block above or below the text or splits it into two separate blocks, one above and the other below */
  infoBlockPosition?: Maybe<Scalars['Boolean']['output']>;
  /** Displays the 'Article Info' title on top of the article information block */
  infoBlockShowTitle?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the Name of the article's Author will be linked to its contact page */
  linkAuthor?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If set to true, and if Show Category is set to true,
   * the Category Title will link to a layout showing articles in that Category
   */
  linkCategory?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If set to true, and if Show Parent is set to true,
   * the Parent Category Title will link to a layout showing articles in that Category
   */
  linkParentCategory?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the article title will be a link to the article */
  linkTitles?: Maybe<Scalars['Boolean']['output']>;
  /** Display or hide article options slider in the backend article edit view */
  showArticleOptions?: Maybe<Scalars['Boolean']['output']>;
  /** Display or hide associations */
  showAssociations?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the Name of the article's Author will be displayed */
  showAuthor?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the title of the article's category will show */
  showCategory?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the date and time an Article was created will be displayed */
  showCreateDate?: Maybe<Scalars['Boolean']['output']>;
  /** Show/Hide the email icon */
  showEmailIcon?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the number of Hits on a particular Article will be displayed */
  showHits?: Maybe<Scalars['Boolean']['output']>;
  /** Print and email will utilize Icons or Text */
  showIcons?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If set to true, the Intro Text of the article will show when you drill down to the article,
   * if set to false, only the part of the article after the "Read More" break will show
   */
  showIntro?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, shows a navigation link (Next, Previous) between articles */
  showItemNavigation?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the date and time an Article was last modified will be displayed */
  showModifyDate?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, links to registered content will be shown even if you are not logged-in */
  showNoauth?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the title of the article&rsquo;s parent category will show */
  showParentCategory?: Maybe<Scalars['Boolean']['output']>;
  /** Show/Hide the Item Print button */
  showPrintIcon?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the date and time an Article was published will be displayed */
  showPublishDate?: Maybe<Scalars['Boolean']['output']>;
  /** Display or hide the publishing options slider in the article edit view */
  showPublishingOptions?: Maybe<Scalars['Boolean']['output']>;
  /** Display or hide article tags */
  showTags?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the article title is shown */
  showTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Display or hide fields to insert standardized images and links in the administrator */
  showUrlsImagesBackend?: Maybe<Scalars['Boolean']['output']>;
  /** Display or hide fields to insert standardized images and links when front end editing */
  showUrlsImagesFrontend?: Maybe<Scalars['Boolean']['output']>;
  /** If set to show, a voting system will be enabled for Articles */
  showVote?: Maybe<Scalars['Boolean']['output']>;
  /** Display the links above or below the content */
  urlsPosition?: Maybe<Scalars['Boolean']['output']>;
};

export type NewsArticleConnection = UniversalNewsArticleConnection & {
  __typename?: 'NewsArticleConnection';
  edges: Array<NewsArticleEdge>;
  pageInfo: PageInfo;
};

export type NewsArticleEdge = UniversalNewsArticleEdge & {
  __typename?: 'NewsArticleEdge';
  cursor: Scalars['String']['output'];
  node: NewsArticle;
};

export enum NewsArticleSorting {
  /**
   * Created at
   * @deprecated Use INSERTED_AT instead
   */
  CREATED_AT = 'CREATED_AT',
  /**
   * Created at ascending
   * @deprecated Use INSERTED_AT_ASCENDING instead
   */
  CREATED_AT_ASCENDING = 'CREATED_AT_ASCENDING',
  /** Disabled */
  DISABLED = 'DISABLED',
  /** Created at */
  INSERTED_AT = 'INSERTED_AT',
  /** Created at ascending */
  INSERTED_AT_ASCENDING = 'INSERTED_AT_ASCENDING',
  /** Normal sorting */
  NORMAL = 'NORMAL',
  /** Popularity */
  POPULARITY = 'POPULARITY',
  /** Relevance */
  RELEVANCE = 'RELEVANCE',
  /** Relevance and date */
  RELEVANCE_AND_DATE = 'RELEVANCE_AND_DATE',
  /** Score ascending */
  SCORE_ASCENDING = 'SCORE_ASCENDING',
  /** Score descending */
  SCORE_DESCENDING = 'SCORE_DESCENDING'
}

export enum NewsArticleStatus {
  /** Archived */
  ARCHIVED = 'ARCHIVED',
  /** Published */
  PUBLISHED = 'PUBLISHED',
  /** Trashed */
  TRASHED = 'TRASHED',
  /** Unpublished */
  UNPUBLISHED = 'UNPUBLISHED'
}

export enum NewsArticleVisibility {
  /** Public */
  PUBLIC = 'PUBLIC',
  /** Registered */
  REGISTERED = 'REGISTERED',
  /** Special */
  SPECIAL = 'SPECIAL'
}

/** A category of central newsboard */
export type NewsCategory = UniversalNewsCategory & {
  __typename?: 'NewsCategory';
  /** The article's access level */
  accessLevel: AccessLevel;
  /** The article's attributes */
  attributes?: Maybe<NewsArticleAttributes>;
  /** Whether the article is auto-translated */
  autoTranslated: Scalars['Boolean']['output'];
  /** The article's body */
  body: Scalars['String']['output'];
  /**
   * The article's creation date on the site
   * @deprecated Use insertedAt instead
   */
  createdAt: Scalars['DateTime']['output'];
  /** The article's dek */
  dek?: Maybe<Scalars['String']['output']>;
  /** The article's meta description */
  description?: Maybe<Scalars['String']['output']>;
  /** The article's text as displayed on the site */
  displayText: Scalars['String']['output'];
  /** Is the article featured? */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** The article's first paragraph */
  firstParagraph: Scalars['String']['output'];
  /** Has the current user access to the artice? */
  hasAccess: Scalars['Boolean']['output'];
  /** The article's id */
  id: Scalars['Int']['output'];
  /** The caption of article's image */
  imageCaption?: Maybe<Scalars['String']['output']>;
  /** The url of article's image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The article's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The article's meta keywords */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The acticle's labels */
  labels: Array<Scalars['String']['output']>;
  /** The news articles related to this category */
  newsArticles: Array<NewsArticle>;
  /** The news article connection of the category's article */
  newsArticlesConnection: NewsArticleConnection;
  /** The count of the category's article */
  newsArticlesCount: Scalars['Int']['output'];
  /** The category's path */
  path?: Maybe<Scalars['String']['output']>;
  /** The article's scheduled publication date, null if not scheduled */
  publishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reference of the news article */
  reference?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  responsiveImageUrls?: Maybe<ResponsiveImageUrls>;
  /** The scores */
  scores: Array<Score>;
  /** The article's slug */
  slug: Scalars['String']['output'];
  /** The acticle's status: trashed, unpublished, published, archived */
  status: NewsArticleStatus;
  /** The article's summary */
  summary: Scalars['String']['output'];
  /** The article's tags */
  tags: Array<Tag>;
  /** The article's tags */
  tagsConnection: TagConnection;
  /** The count of the article's tags */
  tagsCount: Scalars['Int']['output'];
  /** The article's text */
  text: Scalars['String']['output'];
  /** The article's title */
  title: Scalars['String']['output'];
  /** The article's scheduled unpublish date, null if not scheduled */
  unpublishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The article's date of last modification */
  updatedAt: Scalars['DateTime']['output'];
  /** The article's version */
  version?: Maybe<Scalars['Int']['output']>;
  /** The article's visibility: PUBLIC, REGISTERED, SPECIAL */
  visibility: NewsArticleVisibility;
};


/** A category of central newsboard */
export type NewsCategoryimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A category of central newsboard */
export type NewsCategorynewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A category of central newsboard */
export type NewsCategorynewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A category of central newsboard */
export type NewsCategorynewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A category of central newsboard */
export type NewsCategoryscoresArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A category of central newsboard */
export type NewsCategorytagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A category of central newsboard */
export type NewsCategorytagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A category of central newsboard */
export type NewsCategorytagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** News multilingual text input object */
export type NewsMultilingualTextInput = {
  csCz?: InputMaybe<Scalars['String']['input']>;
  daDk?: InputMaybe<Scalars['String']['input']>;
  deAt?: InputMaybe<Scalars['String']['input']>;
  deCh?: InputMaybe<Scalars['String']['input']>;
  deDe?: InputMaybe<Scalars['String']['input']>;
  enAu?: InputMaybe<Scalars['String']['input']>;
  enCa?: InputMaybe<Scalars['String']['input']>;
  enGb?: InputMaybe<Scalars['String']['input']>;
  enIe?: InputMaybe<Scalars['String']['input']>;
  enIn?: InputMaybe<Scalars['String']['input']>;
  enNz?: InputMaybe<Scalars['String']['input']>;
  enUs?: InputMaybe<Scalars['String']['input']>;
  esAr?: InputMaybe<Scalars['String']['input']>;
  esCl?: InputMaybe<Scalars['String']['input']>;
  esCo?: InputMaybe<Scalars['String']['input']>;
  esEs?: InputMaybe<Scalars['String']['input']>;
  esMx?: InputMaybe<Scalars['String']['input']>;
  esPe?: InputMaybe<Scalars['String']['input']>;
  fiFi?: InputMaybe<Scalars['String']['input']>;
  frBe?: InputMaybe<Scalars['String']['input']>;
  frCa?: InputMaybe<Scalars['String']['input']>;
  frFr?: InputMaybe<Scalars['String']['input']>;
  frLu?: InputMaybe<Scalars['String']['input']>;
  huHu?: InputMaybe<Scalars['String']['input']>;
  itIt?: InputMaybe<Scalars['String']['input']>;
  jaJp?: InputMaybe<Scalars['String']['input']>;
  nlBe?: InputMaybe<Scalars['String']['input']>;
  nlNl?: InputMaybe<Scalars['String']['input']>;
  noNo?: InputMaybe<Scalars['String']['input']>;
  plPl?: InputMaybe<Scalars['String']['input']>;
  ptBr?: InputMaybe<Scalars['String']['input']>;
  ptPt?: InputMaybe<Scalars['String']['input']>;
  ruRu?: InputMaybe<Scalars['String']['input']>;
  svSe?: InputMaybe<Scalars['String']['input']>;
  trTr?: InputMaybe<Scalars['String']['input']>;
  zhCn?: InputMaybe<Scalars['String']['input']>;
  zhHk?: InputMaybe<Scalars['String']['input']>;
};

/** A central newsboard user */
export type NewsUser = UniversalNewsUser & {
  __typename?: 'NewsUser';
  /** The user's biography */
  bio?: Maybe<Scalars['String']['output']>;
  /** The user's biography HTML */
  bioHtml?: Maybe<Scalars['String']['output']>;
  /** The user's email address */
  email: Scalars['String']['output'];
  /** The user's id */
  id: Scalars['Int']['output'];
  /** The image url of the author */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of the author */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The user's full name */
  name: Scalars['String']['output'];
  /** The news articles of the author */
  newsArticles: Array<NewsArticle>;
  /** The news article connection of the author */
  newsArticlesConnection: NewsArticleConnection;
  /** The count of the author's news articles */
  newsArticlesCount: Scalars['Int']['output'];
};


/** A central newsboard user */
export type NewsUserbioArgs = {
  locale: Scalars['String']['input'];
};


/** A central newsboard user */
export type NewsUserbioHtmlArgs = {
  locale: Scalars['String']['input'];
};


/** A central newsboard user */
export type NewsUserimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A central newsboard user */
export type NewsUsernewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A central newsboard user */
export type NewsUsernewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A central newsboard user */
export type NewsUsernewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum Newsboard {
  /** https://au.fashionunited.com/ */
  AU_FASHIONUNITED_COM = 'AU_FASHIONUNITED_COM',
  /** https://fashionunited.at/ */
  FASHIONUNITED_AT = 'FASHIONUNITED_AT',
  /** https://fashionunited.be/ */
  FASHIONUNITED_BE = 'FASHIONUNITED_BE',
  /** https://fashionunited.be/fr/ */
  FASHIONUNITED_BE_FR = 'FASHIONUNITED_BE_FR',
  /** https://fashionunited.ca/ */
  FASHIONUNITED_CA = 'FASHIONUNITED_CA',
  /** https://fashionunited.ca/fr/ */
  FASHIONUNITED_CA_FR = 'FASHIONUNITED_CA_FR',
  /** https://fashionunited.ch/ */
  FASHIONUNITED_CH = 'FASHIONUNITED_CH',
  /** https://fashionunited.cl/ */
  FASHIONUNITED_CL = 'FASHIONUNITED_CL',
  /** https://cn.fashionunited.com/ */
  FASHIONUNITED_CN = 'FASHIONUNITED_CN',
  /** https://fashionunited.co/ */
  FASHIONUNITED_CO = 'FASHIONUNITED_CO',
  /** https://fashionunited.com/ */
  FASHIONUNITED_COM = 'FASHIONUNITED_COM',
  /** https://fashionunited.com.ar/ */
  FASHIONUNITED_COM_AR = 'FASHIONUNITED_COM_AR',
  /** https://fashionunited.com.br/ */
  FASHIONUNITED_COM_BR = 'FASHIONUNITED_COM_BR',
  /** https://fashionunited.com.pe/ */
  FASHIONUNITED_COM_PE = 'FASHIONUNITED_COM_PE',
  /** https://fashionunited.com.tr/ */
  FASHIONUNITED_COM_TR = 'FASHIONUNITED_COM_TR',
  /** https://fashionunited.cz/ */
  FASHIONUNITED_CZ = 'FASHIONUNITED_CZ',
  /** https://fashionunited.de/ */
  FASHIONUNITED_DE = 'FASHIONUNITED_DE',
  /** https://fashionunited.dk/ */
  FASHIONUNITED_DK = 'FASHIONUNITED_DK',
  /** https://fashionunited.es/ */
  FASHIONUNITED_ES = 'FASHIONUNITED_ES',
  /** https://fashionunited.fi/ */
  FASHIONUNITED_FI = 'FASHIONUNITED_FI',
  /** https://fashionunited.fr/ */
  FASHIONUNITED_FR = 'FASHIONUNITED_FR',
  /** https://fashionunited.hk/ */
  FASHIONUNITED_HK = 'FASHIONUNITED_HK',
  /** https://fashionunited.hu/ */
  FASHIONUNITED_HU = 'FASHIONUNITED_HU',
  /** https://fashionunited.ie/ */
  FASHIONUNITED_IE = 'FASHIONUNITED_IE',
  /** https://fashionunited.in/ */
  FASHIONUNITED_IN = 'FASHIONUNITED_IN',
  /** https://fashionunited.info/ */
  FASHIONUNITED_INFO = 'FASHIONUNITED_INFO',
  /** https://fashionunited.it/ */
  FASHIONUNITED_IT = 'FASHIONUNITED_IT',
  /** https://fashionunited.jp/ */
  FASHIONUNITED_JP = 'FASHIONUNITED_JP',
  /** https://fashionunited.lu/ */
  FASHIONUNITED_LU = 'FASHIONUNITED_LU',
  /** https://fashionunited.mx/ */
  FASHIONUNITED_MX = 'FASHIONUNITED_MX',
  /** https://fashionunited.nl/ */
  FASHIONUNITED_NL = 'FASHIONUNITED_NL',
  /** https://fashionunited.no/ */
  FASHIONUNITED_NO = 'FASHIONUNITED_NO',
  /** https://fashionunited.nz/ */
  FASHIONUNITED_NZ = 'FASHIONUNITED_NZ',
  /** https://fashionunited.pl/ */
  FASHIONUNITED_PL = 'FASHIONUNITED_PL',
  /** https://fashionunited.pt/ */
  FASHIONUNITED_PT = 'FASHIONUNITED_PT',
  /** https://ru.fashionunited.com/ */
  FASHIONUNITED_RU = 'FASHIONUNITED_RU',
  /** https://fashionunited.se/ */
  FASHIONUNITED_SE = 'FASHIONUNITED_SE',
  /** https://fashionunited.uk/ */
  FASHIONUNITED_UK = 'FASHIONUNITED_UK',
  /** https://fashionweekweb.com/ */
  FASHIONWEEKWEB_COM = 'FASHIONWEEKWEB_COM',
  /** https://internationalfashionjobs.com/ */
  INTERNATIONALFASHIONJOBS_COM = 'INTERNATIONALFASHIONJOBS_COM'
}

/** An order */
export type Order = {
  __typename?: 'Order';
  /** The account of the order */
  account: Account;
  /** The checkout URL of the order */
  checkoutUrl: Scalars['String']['output'];
  /** The email address of the contact of the order (when it is not the creator) */
  email?: Maybe<Scalars['String']['output']>;
  /** The failure message of the order */
  failureMessage?: Maybe<Scalars['String']['output']>;
  /** The failure reason of the order */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The first name of the contact of the order (when it is not the creator) */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The id of the order */
  id: Scalars['Int']['output'];
  /** The creation date of the order */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the order */
  insertedBy?: Maybe<User>;
  /** The last name of the contact of the order (when it is not the creator) */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The locale of the order */
  locale?: Maybe<Scalars['String']['output']>;
  /** The query to retrieve the order items of the order */
  orderItems: Array<OrderItem>;
  /** The query to retrieve the order items of the order */
  orderItemsConnection: OrderItemConnection;
  /** The query to retrieve the number of order items of the order */
  orderItemsCount: Scalars['Int']['output'];
  /** The parent id of the order */
  parentId?: Maybe<Scalars['Int']['output']>;
  /** The payment provider checkout URL of the order */
  paymentCheckoutUrl?: Maybe<Scalars['String']['output']>;
  /** The payment ID of the order */
  paymentId?: Maybe<Scalars['String']['output']>;
  /** The redirect URL of the order */
  redirectUrl: Scalars['String']['output'];
  /** The referral code of the order */
  referralCode?: Maybe<Scalars['String']['output']>;
  /** Whether the order has been refunded */
  refunded: Scalars['Boolean']['output'];
  /** The status of the order */
  status: OrderStatus;
  /** Whether the subscription has been canceled */
  subscriptionCanceled: Scalars['Boolean']['output'];
  /** The total price of the order */
  total: PriceWithCurrency;
  /** The type of the order */
  type: PaymentType;
  /** The date of the last update of the order */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the order */
  updatedBy?: Maybe<User>;
};


/** An order */
export type OrderorderItemsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** An order */
export type OrderorderItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<OrderEdge>;
  pageInfo: PageInfo;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Order>;
};

/** An order item */
export type OrderItem = {
  __typename?: 'OrderItem';
  /** The amount of the order item */
  amount: Scalars['Int']['output'];
  /** The bundle of the order item */
  bundle: Bundle;
  /** The id of the order item */
  id: Scalars['Int']['output'];
  /** The creation date of the order item */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the order item */
  insertedBy?: Maybe<User>;
  /** The order of the order item */
  order: Order;
  /** The date of the last update of the order item */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the order item */
  updatedBy?: Maybe<User>;
};

export type OrderItemConnection = {
  __typename?: 'OrderItemConnection';
  edges: Array<OrderItemEdge>;
  pageInfo: PageInfo;
};

export type OrderItemEdge = {
  __typename?: 'OrderItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<OrderItem>;
};

/** An order item input */
export type OrderItemInput = {
  /** The amount of the order item */
  amount: Scalars['Int']['input'];
  /** The bundle id of the order item */
  bundleId: Scalars['Int']['input'];
};

export type OrderQuantityRange = {
  __typename?: 'OrderQuantityRange';
  /** The average order quantity */
  average?: Maybe<Scalars['Float']['output']>;
  /** The maximum order quantity */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** The minimum order quantity */
  minimum?: Maybe<Scalars['Int']['output']>;
};

/** Order status */
export enum OrderStatus {
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  NEW = 'NEW',
  PAID = 'PAID'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Payment type */
export enum PaymentType {
  /** One-off payment */
  ONE_OFF = 'ONE_OFF',
  /** Recurring payment */
  RECURRING = 'RECURRING'
}

/** A position */
export type Position = {
  __typename?: 'Position';
  /** The position's id */
  id: Scalars['String']['output'];
  /** The jobs in the position */
  jobs: Array<Job>;
  /** The jobs in the position */
  jobsConnection: JobConnection;
  /** The count of jobs in the position */
  jobsCount: Scalars['Int']['output'];
  /** The position's keywords */
  keywords: Array<Scalars['String']['output']>;
  /** The date of the last job published for the position */
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The position's name */
  name?: Maybe<Scalars['String']['output']>;
  /** The position's localized name */
  names?: Maybe<PositionNames>;
  /** The position's slug */
  slug: Scalars['String']['output'];
};


/** A position */
export type PositionjobsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A position */
export type PositionjobsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A position */
export type PositionjobsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A position */
export type PositionlastPublishedAtArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PositionConnection = {
  __typename?: 'PositionConnection';
  edges: Array<PositionEdge>;
  pageInfo: PageInfo;
};

export type PositionEdge = {
  __typename?: 'PositionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Position;
};

/** A positions's localized names */
export type PositionNames = {
  __typename?: 'PositionNames';
  /** Localized version for locale bg-BG */
  bgBg?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale cs-CZ */
  csCz?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale da-DK */
  daDk?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale de-AT */
  deAt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale de-CH */
  deCh?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale de-DE */
  deDe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale el-CY */
  elCy?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale el-GR */
  elGr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-AU */
  enAu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-CA */
  enCa?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-GB */
  enGb?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-IE */
  enIe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-IN */
  enIn?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-NZ */
  enNz?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale en-US */
  enUs?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-AR */
  esAr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-CL */
  esCl?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-CO */
  esCo?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-ES */
  esEs?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-MX */
  esMx?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale es-PE */
  esPe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale et-EE */
  etEe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fi-FI */
  fiFi?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-BE */
  frBe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-CH */
  frCh?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-FR */
  frFr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale fr-LU */
  frLu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale hr-HR */
  hrHr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale hu-HU */
  huHu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale it-CH */
  itCh?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale it-IT */
  itIt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale ja-JP */
  jaJp?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale lt-LT */
  ltLt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale lv-LV */
  lvLv?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale mt-MT */
  mtMt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale nb-NO */
  nbNo?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale nl-BE */
  nlBe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale nl-NL */
  nlNl?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale pl-PL */
  plPl?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale pt-BR */
  ptBr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale pt-PT */
  ptPt?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale ro-RO */
  roRo?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale ru-RU */
  ruRu?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale sk-SK */
  skSk?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale sl-SI */
  slSi?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale sv-SE */
  svSe?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale tr-TR */
  trTr?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale zh-CN */
  zhCn?: Maybe<Scalars['String']['output']>;
  /** Localized version for locale zh-HK */
  zhHk?: Maybe<Scalars['String']['output']>;
};

/** A positions's localized names */
export type PositionNamesInput = {
  /** Localized version for locale bg-BG */
  bgBg?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale cs-CZ */
  csCz?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale da-DK */
  daDk?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale de-AT */
  deAt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale de-CH */
  deCh?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale de-DE */
  deDe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale el-CY */
  elCy?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale el-GR */
  elGr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-AU */
  enAu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-CA */
  enCa?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-GB */
  enGb?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-IE */
  enIe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-IN */
  enIn?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-NZ */
  enNz?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale en-US */
  enUs?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-AR */
  esAr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-CL */
  esCl?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-CO */
  esCo?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-ES */
  esEs?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-MX */
  esMx?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale es-PE */
  esPe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale et-EE */
  etEe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fi-FI */
  fiFi?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-BE */
  frBe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-CH */
  frCh?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-FR */
  frFr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale fr-LU */
  frLu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale hr-HR */
  hrHr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale hu-HU */
  huHu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale it-CH */
  itCh?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale it-IT */
  itIt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale ja-JP */
  jaJp?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale lt-LT */
  ltLt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale lv-LV */
  lvLv?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale mt-MT */
  mtMt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale nb-NO */
  nbNo?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale nl-BE */
  nlBe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale nl-NL */
  nlNl?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale pl-PL */
  plPl?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale pt-BR */
  ptBr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale pt-PT */
  ptPt?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale ro-RO */
  roRo?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale ru-RU */
  ruRu?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale sk-SK */
  skSk?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale sl-SI */
  slSi?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale sv-SE */
  svSe?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale tr-TR */
  trTr?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale zh-CN */
  zhCn?: InputMaybe<Scalars['String']['input']>;
  /** Localized version for locale zh-HK */
  zhHk?: InputMaybe<Scalars['String']['input']>;
};

/** A price */
export type Price = {
  __typename?: 'Price';
  /** The amount of the price */
  amount: Scalars['Decimal']['output'];
  /** The credit type of the price */
  creditType: CreditType;
  /** The id of the price */
  id: Scalars['Int']['output'];
  /** The creation date of the price */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the price */
  insertedBy?: Maybe<User>;
  /** The product of the price */
  product: CreditProduct;
  /** The date of the last update of the price */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the price */
  updatedBy?: Maybe<User>;
};

export type PriceConnection = {
  __typename?: 'PriceConnection';
  edges: Array<PriceEdge>;
  pageInfo: PageInfo;
};

export type PriceEdge = {
  __typename?: 'PriceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Price;
};

export type PriceRange = {
  __typename?: 'PriceRange';
  /** The average price */
  average?: Maybe<Scalars['Decimal']['output']>;
  /** The maximum price */
  maximum?: Maybe<Scalars['Decimal']['output']>;
  /** The minimum price */
  minimum?: Maybe<Scalars['Decimal']['output']>;
};

export type PriceRangeWithCurrency = {
  __typename?: 'PriceRangeWithCurrency';
  /** The currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** The range */
  range?: Maybe<PriceRange>;
};

/** A price with currency */
export type PriceWithCurrency = {
  __typename?: 'PriceWithCurrency';
  /** The amount of the price */
  amount: Scalars['Decimal']['output'];
  /** The currency of the price */
  currency: Scalars['String']['output'];
};

export type Print = {
  __typename?: 'Print';
  /** The id of the print */
  id: Scalars['Int']['output'];
  /** The name of the print */
  name: Scalars['String']['output'];
};

export type PrintConnection = {
  __typename?: 'PrintConnection';
  edges: Array<PrintEdge>;
  pageInfo: PageInfo;
};

export type PrintEdge = {
  __typename?: 'PrintEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Print;
};

export type Product = {
  __typename?: 'Product';
  /** The age groups of the product */
  ageGroups: Array<AgeGroup>;
  /** The brand of the product */
  brand?: Maybe<Brand>;
  /** The main category of the product */
  categoryMain?: Maybe<Scalars['String']['output']>;
  /** The category path of the product */
  categoryPath?: Maybe<Scalars['String']['output']>;
  /** The sub category of the product */
  categorySub?: Maybe<Scalars['String']['output']>;
  /** The third level category of the product */
  categoryThree?: Maybe<Scalars['String']['output']>;
  /** The color names of the product */
  colorNames: Array<Scalars['String']['output']>;
  /** The colors of the product */
  colors: Array<Color>;
  /** The variant delivery day range for the product */
  deliveryDays?: Maybe<DeliveryDaysRange>;
  /** The delivery times of the product */
  deliveryTimes: Array<Scalars['String']['output']>;
  /** The description of the product */
  description?: Maybe<Scalars['String']['output']>;
  /** The genders of the product */
  genders: Array<Gender>;
  /** The GTINs of the product */
  gtins: Array<Scalars['String']['output']>;
  /** The id of the product */
  id: Scalars['Int']['output'];
  /** The variant image with the highest priority */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of the variant image with the highest priority */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The images of the variants */
  images: Array<ProductImage>;
  /** The images of the variants */
  imagesConnection: ProductImageConnection;
  /** The product's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The materials of the product */
  material?: Maybe<Scalars['String']['output']>;
  /** The materials of the product */
  materials: Array<Material>;
  /** The MPNs of the product */
  mpns: Array<Scalars['String']['output']>;
  /** The name of the product */
  name?: Maybe<Scalars['String']['output']>;
  /** The variant order quantity range for the product */
  orderQuantities?: Maybe<OrderQuantityRange>;
  /** The original main category of the product in the feed */
  originalCategoryMain?: Maybe<Scalars['String']['output']>;
  /** The original category path of the product in the feed */
  originalCategoryPath?: Maybe<Scalars['String']['output']>;
  /** The original sub category of the product in the feed */
  originalCategorySub?: Maybe<Scalars['String']['output']>;
  /** The original third level category of the product in the feed */
  originalCategoryThree?: Maybe<Scalars['String']['output']>;
  /** The price currencies of the product */
  priceCurrencies: Array<Scalars['String']['output']>;
  /** The variant price range for the product */
  prices?: Maybe<PriceRange>;
  /** The variant price ranges for the product by currencies */
  pricesWithCurrencies: Array<PriceRangeWithCurrency>;
  /** The prints of the product */
  print?: Maybe<Scalars['String']['output']>;
  /** The prints of the product */
  prints: Array<Print>;
  /** The retailer name of a product */
  retailerName?: Maybe<Scalars['String']['output']>;
  /** The season of the product */
  season?: Maybe<Scalars['String']['output']>;
  /** The variant shipping cost range for the product */
  shippingCosts?: Maybe<PriceRange>;
  /** The short description of the product */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** The size names of the product */
  sizeNames: Array<Scalars['String']['output']>;
  /** The size names of the product */
  sizes: Array<Scalars['String']['output']>;
  /** The slug of the product */
  slug: Scalars['String']['output'];
  /** The source name of a product */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** The summary of the product */
  summary?: Maybe<Scalars['String']['output']>;
  /** The product's last modification date */
  updatedAt: Scalars['DateTime']['output'];
  /** A url of a variant */
  url?: Maybe<Scalars['String']['output']>;
  /** The variants of the product */
  variants: Array<Variant>;
  /** The variants of the product */
  variantsConnection: VariantConnection;
};


export type ProductimageUrlArgs = {
  broken?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductimageUrlsArgs = {
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


export type ProductimagesArgs = {
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  prioritizedColorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  prioritizedModel?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductimagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  prioritizedColorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  prioritizedModel?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductpricesArgs = {
  currency: Scalars['String']['input'];
};


export type ProductshippingCostsArgs = {
  currency: Scalars['String']['input'];
};


export type ProductvariantsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type ProductvariantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductBrandSorting {
  /** Alphabetical */
  ALPHABETICAL = 'ALPHABETICAL',
  /** By number of products */
  PRODUCTS_COUNT = 'PRODUCTS_COUNT'
}

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Product;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  /** The id of the product image */
  id: Scalars['Int']['output'];
  /** Model or product only photo */
  model?: Maybe<Scalars['Boolean']['output']>;
  /** The type of the product image */
  type: ProductImageType;
  /** The url of the product image */
  url: Scalars['String']['output'];
  /** The responsive image urls */
  urls: Array<Scalars['String']['output']>;
};


export type ProductImageurlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

export type ProductImageConnection = {
  __typename?: 'ProductImageConnection';
  edges: Array<ProductImageEdge>;
  pageInfo: PageInfo;
};

export type ProductImageEdge = {
  __typename?: 'ProductImageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: ProductImage;
};

export enum ProductImageType {
  /** Large */
  LARGE = 'LARGE',
  /** Medium */
  MEDIUM = 'MEDIUM',
  /** Original */
  ORIGINAL = 'ORIGINAL',
  /** Small */
  SMALL = 'SMALL',
  /** Thumb */
  THUMB = 'THUMB'
}

export enum ProductSorting {
  /** Alphabetical */
  ALPHABETICAL = 'ALPHABETICAL',
  /** Latest */
  LATEST = 'LATEST',
  /** Randomized */
  RANDOM = 'RANDOM',
  /** Relevance */
  RELEVANCE = 'RELEVANCE'
}

/** A company profile */
export type Profile = {
  __typename?: 'Profile';
  /** The account of the company */
  account?: Maybe<Account>;
  /** The account id of the company */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** The addresses of the company */
  addresses: Array<CompanyAddress>;
  /** The brands of the company profile */
  brands: Array<Brand>;
  /** The brands of the company profile */
  brandsConnection: BrandConnection;
  /** The number of brands of the company profile */
  brandsCount: Scalars['Int']['output'];
  /** Whether the current user can update this profile */
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** The company profile's company information */
  company: ProfileCompany;
  /** The courses of the company */
  courses: Array<Course>;
  /** The courses of the company */
  coursesConnection: CourseConnection;
  /** The query to retrieve the count of courses */
  coursesCount: Scalars['Int']['output'];
  /** The company's facebook pages */
  facebook: Array<CompanySocialNetworkPage>;
  /** Is it a finished profile? */
  finished?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the company profile has a tabs */
  hasTabs: Scalars['Boolean']['output'];
  /** The profile's id */
  id: Scalars['String']['output'];
  /** The company's instagram users */
  instagram: Array<CompanySocialNetworkUser>;
  /** The jobs of the company profile */
  jobs: Array<Job>;
  /** The jobs of the company profile */
  jobsConnection: JobConnection;
  /** The count of jobs in the company profile */
  jobsCount: Scalars['Int']['output'];
  /** The date of the last job published for the company profile */
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The company profile's page information */
  page: ProfilePage;
  /** The company's pinterest pages */
  pinterest: Array<CompanySocialNetworkPage>;
  /** The company's snapchat users */
  snapchat: Array<CompanySocialNetworkUser>;
  /** The company's twitter pages */
  twitter: Array<CompanySocialNetworkPage>;
  /** The type of the profile */
  type: ProfileType;
};


/** A company profile */
export type ProfilebrandsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** A company profile */
export type ProfilebrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A company profile */
export type ProfilecoursesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** A company profile */
export type ProfilecoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A company profile */
export type ProfilecoursesCountArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};


/** A company profile */
export type ProfilejobsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A company profile */
export type ProfilejobsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A company profile */
export type ProfilejobsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** A company profile */
export type ProfilelastPublishedAtArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A company profile's company information */
export type ProfileCompany = {
  __typename?: 'ProfileCompany';
  /** The contact of the company */
  contact?: Maybe<Scalars['String']['output']>;
  /** The country of the company */
  country?: Maybe<Scalars['String']['output']>;
  /** The name of the company in courses */
  coursesName?: Maybe<Scalars['String']['output']>;
  /** The CRM organization number for the company */
  crmOrganizationNumber?: Maybe<Scalars['String']['output']>;
  /** The description of the company */
  description?: Maybe<Scalars['String']['output']>;
  /** The localized descriptions of the company */
  descriptions?: Maybe<CompanyDescriptions>;
  /** The display name of the company */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The email address of the company */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * The email domain of the company
   * @deprecated use emailDomains instead
   */
  emailDomain?: Maybe<Scalars['String']['output']>;
  /** The email domains of the company */
  emailDomains: Array<Scalars['String']['output']>;
  /** The full name of the company */
  fullName: Scalars['String']['output'];
  /** The image url of the company */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image URLs of the company */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The logo url of the company */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive logo URLs of the company */
  logoUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The tags for news articles of the company */
  newsTags: Array<Scalars['String']['output']>;
  /** The phone number of the company */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * The screen name of the company
   * @deprecated use displayName instead
   */
  screenName?: Maybe<Scalars['String']['output']>;
  /** The tags for the company */
  tags: Array<Scalars['String']['output']>;
  /** The url of the company's website */
  url?: Maybe<Scalars['String']['output']>;
};


/** A company profile's company information */
export type ProfileCompanyimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A company profile's company information */
export type ProfileCompanylogoUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  edges: Array<ProfileEdge>;
  pageInfo: PageInfo;
};

export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Profile;
};

/** Profile IDs or keywords filter */
export type ProfileIdsOrKeywords = {
  /** The jobs matching the keywords are shown with the assigned jobs */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** Filter by multiple company profile_id of the jobs */
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A company profile's company information */
export type ProfilePage = {
  __typename?: 'ProfilePage';
  /** About the company */
  about?: Maybe<Scalars['String']['output']>;
  /** The HTML version of the about page */
  aboutPageHtml?: Maybe<Scalars['String']['output']>;
  /** The markdown version of the about page */
  aboutPageMarkdown?: Maybe<Scalars['String']['output']>;
  /** The title of the about page */
  aboutPageTitle?: Maybe<Scalars['String']['output']>;
  /** The B2B partner policy of the company */
  b2bPartnerPolicy?: Maybe<Scalars['String']['output']>;
  /** The career site return url of the company */
  careerSiteReturnUrl?: Maybe<Scalars['String']['output']>;
  /** The list of collection image URLs of the company */
  collectionImageUrls: Array<Scalars['String']['output']>;
  /** The contact details of the company */
  contactDetails?: Maybe<Scalars['String']['output']>;
  /** The profile's image url */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The profile's responsive image URLs */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The list of industries of the company */
  industries: Array<Scalars['String']['output']>;
  /** Is EBP enabled? */
  isEbpEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The jobs matching the keywords are shown with the assigned jobs */
  jobKeywords?: Maybe<Scalars['String']['output']>;
  /** The meta description of the company */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** The profile's mobile image url */
  mobileImageUrl?: Maybe<Scalars['String']['output']>;
  /** The profile's responsive mobile image URLs */
  mobileImageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The HTML version of the news page */
  newsPageHtml?: Maybe<Scalars['String']['output']>;
  /** The markdown version of the news page */
  newsPageMarkdown?: Maybe<Scalars['String']['output']>;
  /** The title of the news page */
  newsPageTitle?: Maybe<Scalars['String']['output']>;
  /** Is it a premium profile? */
  premium?: Maybe<Scalars['Boolean']['output']>;
  /** The responsive collection image URLs of the company */
  responsiveCollectionImageUrls: Array<Array<Scalars['String']['output']>>;
  /** Whether to show the about page */
  showAboutPage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the news list on the news page */
  showNewsList?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the news page */
  showNewsPage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the working at page */
  showWorkingAtPage?: Maybe<Scalars['Boolean']['output']>;
  /** The profile's slug */
  slug: Scalars['String']['output'];
  /** The profile's page title */
  title?: Maybe<Scalars['String']['output']>;
  /** The video url of the company */
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** The HTML version of the working at page */
  workingAtPageHtml?: Maybe<Scalars['String']['output']>;
  /** The markdown version of the working at page */
  workingAtPageMarkdown?: Maybe<Scalars['String']['output']>;
  /** The title of the working at page */
  workingAtPageTitle?: Maybe<Scalars['String']['output']>;
};


/** A company profile's company information */
export type ProfilePageimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A company profile's company information */
export type ProfilePagemobileImageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A company profile's company information */
export type ProfilePageresponsiveCollectionImageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

export enum ProfileSorting {
  /** By full name ascending */
  FULL_NAME_ASCENDING = 'FULL_NAME_ASCENDING',
  /** By full name descending */
  FULL_NAME_DESCENDING = 'FULL_NAME_DESCENDING',
  /** Random */
  RANDOM = 'RANDOM',
  /** By slug ascending */
  SLUG_ASCENDING = 'SLUG_ASCENDING',
  /** By slug descending */
  SLUG_DESCENDING = 'SLUG_DESCENDING'
}

/** Profile type enum */
export enum ProfileType {
  /** Agency */
  AGENCY = 'AGENCY',
  /** Company */
  COMPANY = 'COMPANY',
  /** Event */
  EVENT = 'EVENT',
  /** Fashion week */
  FASHION_WEEK = 'FASHION_WEEK',
  /** Federation */
  FEDERATION = 'FEDERATION',
  /** Manufacturer */
  MANUFACTURER = 'MANUFACTURER',
  /** Retail */
  RETAIL = 'RETAIL',
  /** School */
  SCHOOL = 'SCHOOL',
  /** Software supplier */
  SOFTWARE_SUPPLIER = 'SOFTWARE_SUPPLIER'
}

/** The selected OAuth provider */
export enum Provider {
  /** Facebook */
  FACEBOOK = 'FACEBOOK',
  /** Google */
  GOOGLE = 'GOOGLE',
  /** LinkedIn */
  LINKEDIN = 'LINKEDIN'
}

/** The site the user registered on */
export enum Registrar {
  /** Dashboard */
  DASHBOARD = 'DASHBOARD',
  /** Jobs */
  JOBS = 'JOBS',
  /** Lookbook */
  LOOKBOOK = 'LOOKBOOK',
  /** Marketplace */
  MARKETPLACE = 'MARKETPLACE',
  /** News */
  NEWS = 'NEWS',
  /** PWA */
  PWA = 'PWA'
}

/** Responsive image configuration */
export type ResponsiveImageConfiguration = {
  enlarge?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<ImageFormat>;
  gravity?: InputMaybe<ImageGravity>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  resize?: InputMaybe<ImageResize>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Responsive image urls for a news article */
export type ResponsiveImageUrls = {
  __typename?: 'ResponsiveImageUrls';
  /** Url for 48x24px image */
  image48x24Url?: Maybe<Scalars['String']['output']>;
  /** Url for 100x100px image */
  image100x100Url?: Maybe<Scalars['String']['output']>;
  /** Url for 120px width image */
  image120xUrl?: Maybe<Scalars['String']['output']>;
  /** Url for 245px width image */
  image245xUrl?: Maybe<Scalars['String']['output']>;
  /** Url for 320px width image */
  image320xUrl?: Maybe<Scalars['String']['output']>;
  /** Url for 350x350 image */
  image350x350Url?: Maybe<Scalars['String']['output']>;
  /** Url for 600x600px image */
  image600x600Url?: Maybe<Scalars['String']['output']>;
  /** Url for 640px width image */
  image640xUrl?: Maybe<Scalars['String']['output']>;
  /** Url for 810px width image */
  image810xUrl?: Maybe<Scalars['String']['output']>;
  /** Url for 1200px width image */
  image1200xUrl?: Maybe<Scalars['String']['output']>;
};

/** Restricted job company input */
export type RestrictedJobCompanyInput = {
  /** The company's contact person for the job */
  contact?: InputMaybe<Scalars['String']['input']>;
  /** The company's email address for the job */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The social media image URL for the job */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The logo URL for the job */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The company's phone number for the job */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Restricted job input */
export type RestrictedJobInput = {
  /** The job's address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The job's address region (state or county) */
  addressRegion?: InputMaybe<Scalars['String']['input']>;
  /** Is the job using the FashionUnited apply form? */
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** The job's external application URL */
  applyUrl?: InputMaybe<Scalars['String']['input']>;
  /** The job's building name (office, mall, etc.) */
  buildingName?: InputMaybe<Scalars['String']['input']>;
  /** The job's categories */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The job's city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The job's company information */
  company?: InputMaybe<RestrictedJobCompanyInput>;
  /** The job's country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The GeoJSON location */
  geolocation?: InputMaybe<GeoJsonGeometryInput>;
  /** The locales of the sites where this job is posted */
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The number of positions available for the job */
  numberOfPositions?: InputMaybe<Scalars['Int']['input']>;
  /** The job's postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The job's template properties */
  properties?: InputMaybe<Array<JobPropertyInput>>;
  /** The job's region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The job's salary */
  salary?: InputMaybe<JobSalaryInput>;
  /** Should the title be visible on the job's page? */
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The job's teaser */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** The job's title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A role group */
export enum RoleGroup {
  /** Administrator */
  ADMIN = 'ADMIN',
  /** Client */
  CLIENT = 'CLIENT',
  /** Contractor editor */
  CONTRACTORS = 'CONTRACTORS',
  /** Editor */
  EDITOR = 'EDITOR',
  /** Editor support */
  EDITORSUPPORT = 'EDITORSUPPORT',
  /** FashionUnited employee */
  EMPLOYEE = 'EMPLOYEE',
  /** Finance */
  FINANCE = 'FINANCE',
  /** Freelancer editor */
  FREELANCERS = 'FREELANCERS',
  /** Job feed integration */
  INTEGRATION = 'INTEGRATION',
  /** member */
  MEMBER = 'MEMBER',
  /** Sales */
  SALES = 'SALES',
  /** Sales lead */
  SALESLEAD = 'SALESLEAD',
  /** Support */
  SUPPORT = 'SUPPORT',
  /** Support lead */
  SUPPORTLEAD = 'SUPPORTLEAD',
  /** Verified user */
  VERIFIEDUSER = 'VERIFIEDUSER',
  /** Webmaster */
  WEBMASTER = 'WEBMASTER'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** The mutation to add brands to profiles */
  addBrandToProfile: Scalars['Boolean']['output'];
  /** The mutation to add a highlight period for a job */
  addHighlightPeriod: Job;
  /** The mutation to add user to a group */
  addUserToGroup: Scalars['Boolean']['output'];
  /** The mutation to approve a job */
  approveJob: Job;
  /** The mutation to approve a market access request */
  approveMarketAccessRequest: Scalars['Boolean']['output'];
  /** The mutation to approve a stand access request */
  approveStandAccessRequest: Scalars['Boolean']['output'];
  /** The mutation to archive a credit */
  archiveCredit: Credit;
  /** The mutation to cancel subscription */
  cancelSubscription: Order;
  /** The mutation to correct text using generative AI */
  correctText: TextCorrectionResult;
  /** The mutation to create an analytics event */
  createAnalyticsEvent: AnalyticsEvent;
  /** The mutation to create an applicant */
  createApplicant: Scalars['Boolean']['output'];
  /** The mutation to create an author */
  createAuthor: NewsUser;
  /** The mutation to create a brand */
  createBrand: Brand;
  /** The mutation to create a new category keyword */
  createCategoryKeyword: CategoryKeyword;
  /** The mutation to create a new city */
  createCity: City;
  /** The mutation to create a course */
  createCourse: Course;
  /** The mutation to create a credit */
  createCredit: Credit;
  /** The mutation to create an image, returns the created image */
  createImage: Image;
  /** The mutation to create a new job */
  createJob: Job;
  /** The mutation to create a market access request */
  createMarketAccessRequest: Scalars['Boolean']['output'];
  /** The mutation to create a news article */
  createNewsArticle: NewsArticle;
  /** The mutation to create or update jobs by sender and external id */
  createOrUpdateJob: Job;
  /** The mutation to create an order */
  createOrder: Order;
  /** The mutation to create a personal account */
  createPersonalAccount: Account;
  /** The mutation to create a new position */
  createPosition: Position;
  /** The mutation to create a profile */
  createProfile: Profile;
  /** The mutation to create a schedule */
  createSchedule: Schedule;
  /** The mutation to create a special page */
  createSpecialPage: SpecialPage;
  /** The mutation to create a stand access request */
  createStandAccessRequest: Scalars['Boolean']['output'];
  /** The mutation to create a new template */
  createTemplate: Template;
  /** The mutation to delete a market access request */
  deleteMarketAccessRequest: Scalars['Boolean']['output'];
  /** The mutation to delete a source */
  deleteSource: Scalars['Boolean']['output'];
  /** The mutation to delete a stand access request */
  deleteStandAccessRequest: Scalars['Boolean']['output'];
  /** The mutation to duplicate a job */
  duplicateJob: Job;
  /** The mutation to duplicate a news article */
  duplicateNewsArticle: NewsArticle;
  /** The mutation to manually trigger an export of the invoices */
  exportInvoices: Scalars['Boolean']['output'];
  /** The mutation to generate text with generative AI */
  generateText: Scalars['String']['output'];
  /** The mutation to geocode an address */
  geocode: Location;
  /** The mutation to retrieve the account address by VAT number */
  getAddressByVatNumber: AccountAddress;
  /** The mutation to retrieve a currency rate */
  getExchangeRate: Scalars['Decimal']['output'];
  /** The mutation to increase the number of apply button clicks for a job */
  increaseApplyButtonClicks: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://au.fashionunited.com
   */
  increaseAuFashionunitedComNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.be/fr
   */
  increaseFashionunitedBeFrNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.be
   */
  increaseFashionunitedBeNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.ca/fr
   */
  increaseFashionunitedCaFrNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.ca
   */
  increaseFashionunitedCaNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.ch
   */
  increaseFashionunitedChNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.cl
   */
  increaseFashionunitedClNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://cn.fashionunited.com
   */
  increaseFashionunitedCnNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.co
   */
  increaseFashionunitedCoNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.com.ar
   */
  increaseFashionunitedComArNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.com
   */
  increaseFashionunitedComNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.com.pe
   */
  increaseFashionunitedComPeNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.de
   */
  increaseFashionunitedDeNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.es
   */
  increaseFashionunitedEsNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.fr
   */
  increaseFashionunitedFrNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.in
   */
  increaseFashionunitedInNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.info
   */
  increaseFashionunitedInfoNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.it
   */
  increaseFashionunitedItNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.mx
   */
  increaseFashionunitedMxNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.nl
   */
  increaseFashionunitedNlNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.nz
   */
  increaseFashionunitedNzNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://ru.fashionunited.com
   */
  increaseFashionunitedRuNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionunited.uk
   */
  increaseFashionunitedUkNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://fashionweekweb.com
   */
  increaseFashionweekwebComNewsArticleHits: Scalars['Boolean']['output'];
  /**
   * The mutation to increase the number of hits for a news article on
   * https://internationalfashionjobs.com
   */
  increaseInternationalfashionjobsComNewsArticleHits: Scalars['Boolean']['output'];
  /** The mutation to increase the number of page views for a job */
  increaseJobPageViews: Scalars['Boolean']['output'];
  /** The mutation to increase the number of hits for a news article */
  increaseNewsArticleHits: Scalars['Boolean']['output'];
  /** The mutation to increase the number of hits for a news article */
  increaseUniversalNewsArticleHits: Scalars['Boolean']['output'];
  /** The mutation to log in by username and password, returns an access token */
  login: Session;
  /**
   * The mutation to log in by resume token generated by Meteor,
   * returns an access token
   */
  loginWithResumeToken: Session;
  /**
   * The mutation to log in by an external OAuth provider using an access token,
   * returns an access token
   */
  loginWithToken?: Maybe<Session>;
  /** The mutation to publish a job */
  publishJob: Job;
  /** The mutation to publish a news article */
  publishNewsArticle: NewsArticle;
  /** The mutation to purge the cached article pages for a news article */
  purgeNewsArticleCache: Scalars['Boolean']['output'];
  /** The mutation to purge urls */
  purgeUrls: Scalars['Boolean']['output'];
  /**
   * The mutation to refresh the current access token,
   * when the permissions have changed or the token is about to expire,
   * it will return a new access token, otherwise the same token
   */
  refreshAccessToken: Session;
  /**
   * The mutation to register with email and password,
   * returns a registered user
   */
  register: User;
  /**
   * The mutation to register by an external OAuth provider using
   * an access token, returns a user
   */
  registerWithToken?: Maybe<User>;
  /** The mutation to remove brands from profiles */
  removeBrandFromProfile: Scalars['Boolean']['output'];
  /** The mutation to remove a category keyword */
  removeCategoryKeyword: Scalars['Boolean']['output'];
  /** The mutation to remove a city */
  removeCity: Scalars['Boolean']['output'];
  /** The mutation to remove a course */
  removeCourse: Course;
  /** The mutation to remove a credit */
  removeCredit: Credit;
  /** The mutation to remove a highlight period for a job */
  removeHighlightPeriod: Job;
  /** The mutation to remove an image */
  removeImage: Scalars['Boolean']['output'];
  /** The mutation to remove a job */
  removeJob: Job;
  /** The mutation to remove a position */
  removePosition: Scalars['Boolean']['output'];
  /** The mutation to remove a profile */
  removeProfile: Scalars['Boolean']['output'];
  /** The mutation to remove a schedule */
  removeSchedule: Schedule;
  /** The mutation to remove a template */
  removeTemplate: Scalars['Boolean']['output'];
  /** The mutation to remove user */
  removeUser: User;
  /** The mutation to remove user from a group */
  removeUserFromGroup: Scalars['Boolean']['output'];
  /** The mutation to repost a job */
  repostJob: Job;
  /** The mutation to resend verification email for the current user */
  resendVerificationEmail: Scalars['Boolean']['output'];
  /** The mutation to resend verification email for a user */
  resendVerificationEmailForUser: Scalars['Boolean']['output'];
  /** The mutation to reset password */
  resetPassword: Scalars['Boolean']['output'];
  /** The mutation to update the non-restricted fields of a job */
  restrictedUpdateJob: Job;
  /** The mutation to retry failed orders */
  retryFailedOrders: Scalars['Boolean']['output'];
  /** The mutation to run a schedule */
  runSchedule: Schedule;
  /** The mutation to schedule a job */
  scheduleJob: Job;
  /** The mutation to send a message to an applicant */
  sendMessageToApplicant: ApplicantMessage;
  /** The mutation to send a password reset email */
  sendResetPasswordEmail: Scalars['Boolean']['output'];
  /** The mutation to set the status of an applicant */
  setApplicantStatus: Scalars['Boolean']['output'];
  /** The mutation to subscribe to newsletter */
  subscribeToNewsletter: Scalars['Boolean']['output'];
  /** The mutation to translate a news article */
  translateNewsArticle: NewsArticle;
  /** The mutation to unpublish a job */
  unpublishJob: Job;
  /** The mutation to unpublish all the jobs for sender with the passed external ids */
  unpublishJobs: Array<Job>;
  /** The mutation to unpublish all the jobs for sender excluding the passed external ids */
  unpublishJobsExcluding: Array<Job>;
  /** The mutation to unpublish a news article */
  unpublishNewsArticle: NewsArticle;
  /** The mutation to update an author */
  updateAuthor: NewsUser;
  /** The mutation to update a brand */
  updateBrand: Brand;
  /** The mutation to update a category keyword */
  updateCategoryKeyword: CategoryKeyword;
  /** The mutation to create a new city */
  updateCity: City;
  /** The mutation to update a course */
  updateCourse: Course;
  /** The mutation to update the current user's profile */
  updateCurrentProfile: User;
  /** The mutation to update an image */
  updateImage: Image;
  /** The mutation to update a job */
  updateJob: Job;
  /** The mutation to update a news article */
  updateNewsArticle: NewsArticle;
  /** The mutation to create a new position */
  updatePosition: Position;
  /** The mutation to update a profile */
  updateProfile: Profile;
  /** The mutation to update a schedule */
  updateSchedule: Schedule;
  /** The mutation to update a special page */
  updateSpecialPage: SpecialPage;
  /** The mutation to update a tag */
  updateTag: Tag;
  /** The mutation to create a new template */
  updateTemplate: Template;
  /** The mutation to use credits */
  useCredits: Transaction;
  /** The mutation to use a product for a job */
  useProductForJob: Job;
};


export type RootMutationTypeaddBrandToProfileArgs = {
  brandId: Scalars['Int']['input'];
  profileId: Scalars['String']['input'];
};


export type RootMutationTypeaddHighlightPeriodArgs = {
  highlightPeriod: JobHighlightPeriodInput;
  id: Scalars['Int']['input'];
};


export type RootMutationTypeaddUserToGroupArgs = {
  group: RoleGroup;
  id: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeapproveJobArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeapproveMarketAccessRequestArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeapproveStandAccessRequestArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypearchiveCreditArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypecancelSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypecorrectTextArgs = {
  editorPrompt: Scalars['String']['input'];
  generationConfig?: InputMaybe<Scalars['Json']['input']>;
  maximumRevisions?: InputMaybe<Scalars['Int']['input']>;
  model: Scalars['String']['input'];
  proofreaderPrompt: Scalars['String']['input'];
  rules: Array<TextCorrectionRuleConfiguration>;
  text: Scalars['String']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypecreateAnalyticsEventArgs = {
  payload?: InputMaybe<Scalars['Json']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: AnalyticsEventType;
  url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};


export type RootMutationTypecreateApplicantArgs = {
  coverLetter?: InputMaybe<Scalars['Upload']['input']>;
  cv: Scalars['Upload']['input'];
  email: Scalars['String']['input'];
  extraDocument1?: InputMaybe<Scalars['Upload']['input']>;
  extraDocument2?: InputMaybe<Scalars['Upload']['input']>;
  firstName: Scalars['String']['input'];
  jobId: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  motivation?: InputMaybe<Scalars['String']['input']>;
  subscribedToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypecreateAuthorArgs = {
  bio?: InputMaybe<NewsMultilingualTextInput>;
  email: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type RootMutationTypecreateBrandArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypecreateCategoryKeywordArgs = {
  categories: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type RootMutationTypecreateCityArgs = {
  country: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  locales: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypecreateCourseArgs = {
  additionalInformation: Scalars['String']['input'];
  careerLevel?: InputMaybe<CareerLevel>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  city: Scalars['String']['input'];
  companyDescription: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  educationId?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CourseStatus>;
  title: Scalars['String']['input'];
};


export type RootMutationTypecreateCreditArgs = {
  accountId: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  creditTypeId: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  initialAmount?: InputMaybe<Scalars['Decimal']['input']>;
  remainingAmount?: InputMaybe<Scalars['Decimal']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypecreateImageArgs = {
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  freeForCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
  freeForEditorialUse?: InputMaybe<Scalars['Boolean']['input']>;
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noAttributionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  photographer?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypecreateJobArgs = {
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
  job: JobInput;
};


export type RootMutationTypecreateMarketAccessRequestArgs = {
  marketId: Scalars['Int']['input'];
};


export type RootMutationTypecreateNewsArticleArgs = {
  accessLevel?: InputMaybe<AccessLevel>;
  alternativeReadmore?: InputMaybe<Scalars['String']['input']>;
  articleLayout?: InputMaybe<Scalars['String']['input']>;
  articlePageTitle?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  dek?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  infoBlockPosition?: InputMaybe<Scalars['Boolean']['input']>;
  infoBlockShowTitle?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  linkAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  linkCategory?: InputMaybe<Scalars['Boolean']['input']>;
  linkParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  linkTitles?: InputMaybe<Scalars['Boolean']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  originalNewsArticleId?: InputMaybe<Scalars['Int']['input']>;
  publishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  showArticleOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  showCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showCreateDate?: InputMaybe<Scalars['Boolean']['input']>;
  showEmailIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showHits?: InputMaybe<Scalars['Boolean']['input']>;
  showIcons?: InputMaybe<Scalars['Boolean']['input']>;
  showIntro?: InputMaybe<Scalars['Boolean']['input']>;
  showItemNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  showModifyDate?: InputMaybe<Scalars['Boolean']['input']>;
  showNoauth?: InputMaybe<Scalars['Boolean']['input']>;
  showParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showPrintIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  showPublishingOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showTags?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showUrlsImagesBackend?: InputMaybe<Scalars['Boolean']['input']>;
  showUrlsImagesFrontend?: InputMaybe<Scalars['Boolean']['input']>;
  showVote?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  urlsPosition?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<NewsArticleVisibility>;
};


export type RootMutationTypecreateOrUpdateJobArgs = {
  externalId: Scalars['String']['input'];
  job: JobInput;
  sender: Scalars['String']['input'];
};


export type RootMutationTypecreateOrderArgs = {
  accountId: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  orderItems: Array<OrderItemInput>;
  redirectUrl: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentType>;
};


export type RootMutationTypecreatePersonalAccountArgs = {
  address: Scalars['String']['input'];
  addressRegion?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypecreatePositionArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<PositionNamesInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypecreateProfileArgs = {
  about?: InputMaybe<Scalars['String']['input']>;
  aboutPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  aboutPageTitle?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  addresses?: InputMaybe<Array<CompanyAddressInput>>;
  b2bPartnerPolicy?: InputMaybe<Scalars['String']['input']>;
  careerSiteReturnUrl?: InputMaybe<Scalars['String']['input']>;
  collectionImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<Scalars['String']['input']>;
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coursesName?: InputMaybe<Scalars['String']['input']>;
  crmOrganizationNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptions?: InputMaybe<CompanyDescriptionsInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  facebook?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  fullName: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  isEbpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobKeywords?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl?: InputMaybe<Scalars['String']['input']>;
  newsPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  newsPageTitle?: InputMaybe<Scalars['String']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  showAboutPage?: InputMaybe<Scalars['Boolean']['input']>;
  showNewsList?: InputMaybe<Scalars['Boolean']['input']>;
  showNewsPage?: InputMaybe<Scalars['Boolean']['input']>;
  showWorkingAtPage?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snapchat?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  type: ProfileType;
  url?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  workingAtPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  workingAtPageTitle?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypecreateScheduleArgs = {
  cron: Scalars['String']['input'];
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  template: Scalars['String']['input'];
  title: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
};


export type RootMutationTypecreateSpecialPageArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<SpecialPageLinkInput>>;
  mobileImageUrl?: InputMaybe<Scalars['String']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypecreateStandAccessRequestArgs = {
  standId: Scalars['Int']['input'];
};


export type RootMutationTypecreateTemplateArgs = {
  id: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<JobPropertyInput>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypedeleteMarketAccessRequestArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypedeleteSourceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypedeleteStandAccessRequestArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeduplicateJobArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeduplicateNewsArticleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypegenerateTextArgs = {
  generationConfig?: InputMaybe<Scalars['Json']['input']>;
  model: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypegeocodeArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  location: Scalars['String']['input'];
};


export type RootMutationTypegetAddressByVatNumberArgs = {
  vatNumber: Scalars['String']['input'];
};


export type RootMutationTypegetExchangeRateArgs = {
  from: Currency;
  to: Currency;
};


export type RootMutationTypeincreaseApplyButtonClicksArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseAuFashionunitedComNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedBeFrNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedBeNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedCaFrNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedCaNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedChNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedClNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedCnNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedCoNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedComArNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedComNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedComPeNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedDeNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedEsNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedFrNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedInNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedInfoNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedItNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedMxNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedNlNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedNzNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedRuNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionunitedUkNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseFashionweekwebComNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseInternationalfashionjobsComNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseJobPageViewsArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeincreaseNewsArticleHitsArgs = {
  id: Scalars['Int']['input'];
  newsboard: Newsboard;
};


export type RootMutationTypeincreaseUniversalNewsArticleHitsArgs = {
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  id: Scalars['Int']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  newsboard?: InputMaybe<Newsboard>;
};


export type RootMutationTypeloginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type RootMutationTypeloginWithResumeTokenArgs = {
  resumeToken: Scalars['String']['input'];
};


export type RootMutationTypeloginWithTokenArgs = {
  accessToken: Scalars['String']['input'];
  provider: Provider;
};


export type RootMutationTypepublishJobArgs = {
  id: Scalars['Int']['input'];
  preferredCreditTypeId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypepublishNewsArticleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypepurgeNewsArticleCacheArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypepurgeUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
  urls: Array<Scalars['String']['input']>;
};


export type RootMutationTyperegisterArgs = {
  captchaResponse: Scalars['String']['input'];
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  registeredVia?: InputMaybe<Registrar>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTyperegisterWithTokenArgs = {
  accessToken: Scalars['String']['input'];
  provider: Provider;
  registeredVia?: InputMaybe<Registrar>;
};


export type RootMutationTyperemoveBrandFromProfileArgs = {
  brandId: Scalars['Int']['input'];
  profileId: Scalars['String']['input'];
};


export type RootMutationTyperemoveCategoryKeywordArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTyperemoveCityArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTyperemoveCourseArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTyperemoveCreditArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type RootMutationTyperemoveHighlightPeriodArgs = {
  highlightPeriod: JobHighlightPeriodInput;
  id: Scalars['Int']['input'];
};


export type RootMutationTyperemoveImageArgs = {
  id: Scalars['Int']['input'];
  purgeResponsiveImageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
  removeFile?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTyperemoveJobArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTyperemovePositionArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTyperemoveProfileArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTyperemoveScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTyperemoveTemplateArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTyperemoveUserArgs = {
  _id: Scalars['String']['input'];
};


export type RootMutationTyperemoveUserFromGroupArgs = {
  group: RoleGroup;
  id: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTyperepostJobArgs = {
  id: Scalars['Int']['input'];
  preferredCreditTypeId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTyperesendVerificationEmailArgs = {
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTyperesendVerificationEmailForUserArgs = {
  _id: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTyperesetPasswordArgs = {
  password: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTyperestrictedUpdateJobArgs = {
  id: Scalars['Int']['input'];
  job: RestrictedJobInput;
};


export type RootMutationTyperunScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypescheduleJobArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypesendMessageToApplicantArgs = {
  applicantId: Scalars['Int']['input'];
  reason?: InputMaybe<ApplicantMessageReason>;
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypesendResetPasswordEmailArgs = {
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type RootMutationTypesetApplicantStatusArgs = {
  id: Scalars['Int']['input'];
  status: ApplicantStatus;
};


export type RootMutationTypesubscribeToNewsletterArgs = {
  captchaResponse: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


export type RootMutationTypetranslateNewsArticleArgs = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  generationConfig?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['Int']['input'];
  language: Scalars['String']['input'];
  model: Scalars['String']['input'];
  newsboards: Array<Newsboard>;
  prompt: Scalars['String']['input'];
};


export type RootMutationTypeunpublishJobArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeunpublishJobsArgs = {
  externalIds: Array<Scalars['String']['input']>;
  sender: Scalars['String']['input'];
};


export type RootMutationTypeunpublishJobsExcludingArgs = {
  externalIds: Array<Scalars['String']['input']>;
  sender: Scalars['String']['input'];
};


export type RootMutationTypeunpublishNewsArticleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeupdateAuthorArgs = {
  bio?: InputMaybe<NewsMultilingualTextInput>;
  id: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateBrandArgs = {
  id: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateCategoryKeywordArgs = {
  categories: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type RootMutationTypeupdateCityArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateCourseArgs = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  careerLevel?: InputMaybe<CareerLevel>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyDescription?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  educationId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CourseStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateCurrentProfileArgs = {
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateImageArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freeForCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
  freeForEditorialUse?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noAttributionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  photographer?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateJobArgs = {
  id: Scalars['Int']['input'];
  job: JobInput;
};


export type RootMutationTypeupdateNewsArticleArgs = {
  accessLevel?: InputMaybe<AccessLevel>;
  alternativeReadmore?: InputMaybe<Scalars['String']['input']>;
  articleLayout?: InputMaybe<Scalars['String']['input']>;
  articlePageTitle?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  dek?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  infoBlockPosition?: InputMaybe<Scalars['Boolean']['input']>;
  infoBlockShowTitle?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  linkAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  linkCategory?: InputMaybe<Scalars['Boolean']['input']>;
  linkParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  linkTitles?: InputMaybe<Scalars['Boolean']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  originalNewsArticleId?: InputMaybe<Scalars['Int']['input']>;
  publishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  showArticleOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  showCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showCreateDate?: InputMaybe<Scalars['Boolean']['input']>;
  showEmailIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showHits?: InputMaybe<Scalars['Boolean']['input']>;
  showIcons?: InputMaybe<Scalars['Boolean']['input']>;
  showIntro?: InputMaybe<Scalars['Boolean']['input']>;
  showItemNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  showModifyDate?: InputMaybe<Scalars['Boolean']['input']>;
  showNoauth?: InputMaybe<Scalars['Boolean']['input']>;
  showParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showPrintIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  showPublishingOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showTags?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showUrlsImagesBackend?: InputMaybe<Scalars['Boolean']['input']>;
  showUrlsImagesFrontend?: InputMaybe<Scalars['Boolean']['input']>;
  showVote?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  urlsPosition?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<NewsArticleVisibility>;
};


export type RootMutationTypeupdatePositionArgs = {
  id: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<PositionNamesInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateProfileArgs = {
  about?: InputMaybe<Scalars['String']['input']>;
  aboutPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  aboutPageTitle?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  addresses?: InputMaybe<Array<CompanyAddressInput>>;
  b2bPartnerPolicy?: InputMaybe<Scalars['String']['input']>;
  careerSiteReturnUrl?: InputMaybe<Scalars['String']['input']>;
  collectionImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<Scalars['String']['input']>;
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coursesName?: InputMaybe<Scalars['String']['input']>;
  crmOrganizationNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptions?: InputMaybe<CompanyDescriptionsInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  facebook?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  isEbpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobKeywords?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl?: InputMaybe<Scalars['String']['input']>;
  newsPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  newsPageTitle?: InputMaybe<Scalars['String']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  showAboutPage?: InputMaybe<Scalars['Boolean']['input']>;
  showNewsList?: InputMaybe<Scalars['Boolean']['input']>;
  showNewsPage?: InputMaybe<Scalars['Boolean']['input']>;
  showWorkingAtPage?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snapchat?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  type?: InputMaybe<ProfileType>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  workingAtPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  workingAtPageTitle?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateScheduleArgs = {
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['Json']['input']>;
};


export type RootMutationTypeupdateSpecialPageArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<SpecialPageLinkInput>>;
  mobileImageUrl?: InputMaybe<Scalars['String']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateTagArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeupdateTemplateArgs = {
  id: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<JobPropertyInput>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeuseCreditsArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Decimal']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  creditTypeId: Scalars['Int']['input'];
};


export type RootMutationTypeuseProductForJobArgs = {
  id: Scalars['Int']['input'];
  preferredCreditTypeId?: InputMaybe<Scalars['Int']['input']>;
  productName: Scalars['String']['input'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** The query to retrieve an account */
  account?: Maybe<Account>;
  /** The query to retrieve the accounts */
  accounts: Array<Account>;
  /** The query to retrieve the accounts */
  accountsConnection: AccountConnection;
  /** The query to retrieve the number of accounts */
  accountsCount: Scalars['Int']['output'];
  /** The query to retrieve the number of apply button clicks for all the jobs */
  allJobsApplyButtonClicksCount: Scalars['Int']['output'];
  /** The query to retrieve the number of pageviews for all the jobs */
  allJobsPageviewsCount: Scalars['Int']['output'];
  /** The query to retrieve one applicant id */
  applicant?: Maybe<Applicant>;
  /** The query to retrieve one applicant message id */
  applicantMessage?: Maybe<ApplicantMessage>;
  /** The query to retrieve the applicant messages */
  applicantMessages: Array<ApplicantMessage>;
  /** The query to retrieve the applicant messages */
  applicantMessagesConnection: ApplicantMessageConnection;
  /** The query to retrieve the count of applicant messages */
  applicantMessagesCount: Scalars['Int']['output'];
  /** The query to retrieve the applicants */
  applicants: Array<Applicant>;
  /** The query to retrieve the applicants */
  applicantsConnection: ApplicantConnection;
  /** The query to retrieve the count of applicants */
  applicantsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://au.fashionunited.com */
  auFashionunitedComAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://au.fashionunited.com */
  auFashionunitedComCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://au.fashionunited.com */
  auFashionunitedComCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://au.fashionunited.com */
  auFashionunitedComNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://au.fashionunited.com */
  auFashionunitedComNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://au.fashionunited.com */
  auFashionunitedComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://au.fashionunited.com with pagination */
  auFashionunitedComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://au.fashionunited.com */
  auFashionunitedComNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://au.fashionunited.com */
  auFashionunitedComNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://au.fashionunited.com */
  auFashionunitedComTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://au.fashionunited.com */
  auFashionunitedComTags: Array<Tag>;
  /** The query to retrieve tags count on https://au.fashionunited.com */
  auFashionunitedComTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email address */
  authorByEmail?: Maybe<NewsUser>;
  /** The query to retrieve the list of authors */
  authors: Array<Maybe<NewsUser>>;
  /**
   * The query to retrieve the billing countries
   * @deprecated Use `countries` instead
   */
  billingCountries: Array<Country>;
  /** The query to retrieve a brand by id */
  brand?: Maybe<Brand>;
  /** The query to retrieve the brands */
  brands: Array<Brand>;
  /** The query to retrieve the brands */
  brandsConnection: BrandConnection;
  /** The query to retrieve the number of brands */
  brandsCount: Scalars['Int']['output'];
  /** The query to retrieve a bundle */
  bundle?: Maybe<Bundle>;
  /** The query to retrieve a bundle item */
  bundleItem?: Maybe<BundleItem>;
  /** The query to retrieve the bundle items */
  bundleItems: Array<BundleItem>;
  /** The query to retrieve the bundle items */
  bundleItemsConnection: BundleItemConnection;
  /** The query to retrieve the number of bundle items */
  bundleItemsCount: Scalars['Int']['output'];
  /** The query to retrieve the bundles */
  bundles: Array<Bundle>;
  /** The query to retrieve the bundles */
  bundlesConnection: BundleConnection;
  /** The query to retrieve the number of bundles */
  bundlesCount: Scalars['Int']['output'];
  /** The query to retrieve categories */
  categories: Array<NewsCategory>;
  /** The query to retrieve a category */
  category?: Maybe<NewsCategory>;
  /** The query to retrieve one category keyword by locales and id */
  categoryKeyword?: Maybe<CategoryKeyword>;
  /** The query to retrieve the category keywords */
  categoryKeywords: Array<CategoryKeyword>;
  /** The query to retrieve the category keywords */
  categoryKeywordsConnection: CategoryKeywordConnection;
  /** The query to retrieve the count of category keywords */
  categoryKeywordsCount: Scalars['Int']['output'];
  /** The query to retrieve the cities */
  cities: Array<City>;
  /** The query to retrieve the cities */
  citiesConnection: CityConnection;
  /** The query to retrieve the count of cities */
  citiesCount: Scalars['Int']['output'];
  /** The query to retrieve one city by locales and id */
  city?: Maybe<City>;
  /** The query to retrieve one city by locales and id */
  cityBySlug?: Maybe<City>;
  /** The query to retrieve a color by id */
  color?: Maybe<Color>;
  /** The query to retrieve the colors */
  colors: Array<Color>;
  /** The query to retrieve the colors */
  colorsConnection: ColorConnection;
  /** The query to retrieve the countries */
  countries: Array<Country>;
  /** The query to retrieve one course by id */
  course?: Maybe<Course>;
  /** The query to retrieve the course categories */
  courseCategories: Array<CourseCategory>;
  /** The query to retrieve the course categories */
  courseCategoriesConnection: CourseCategoryConnection;
  /** The query to retrieve the count of course categories */
  courseCategoriesCount: Scalars['Int']['output'];
  /** The query to retrieve one course category by id */
  courseCategory?: Maybe<CourseCategory>;
  /** The query to retrieve the course countries */
  courseCountries: Array<CourseCountry>;
  /** The query to retrieve the course countries */
  courseCountriesConnection: CourseCountryConnection;
  /** The query to retrieve the count of course countries */
  courseCountriesCount: Scalars['Int']['output'];
  /** The query to retrieve one course country by id */
  courseCountry?: Maybe<CourseCountry>;
  /** The query to retrieve one education by id */
  courseEducation?: Maybe<CourseEducation>;
  /** The query to retrieve the educations */
  courseEducations: Array<CourseEducation>;
  /** The query to retrieve the educations */
  courseEducationsConnection: CourseEducationConnection;
  /** The query to retrieve the count of educations */
  courseEducationsCount: Scalars['Int']['output'];
  /** The query to retrieve the courses */
  courses: Array<Course>;
  /** The query to retrieve the courses */
  coursesConnection: CourseConnection;
  /** The query to retrieve the count of courses */
  coursesCount: Scalars['Int']['output'];
  /** The query to retrieve a credit */
  credit?: Maybe<Credit>;
  /** The query to retrieve a credit product */
  creditProduct?: Maybe<CreditProduct>;
  /** The query to retrieve the credit products */
  creditProducts: Array<CreditProduct>;
  /** The query to retrieve the credit products */
  creditProductsConnection: CreditProductConnection;
  /** The query to retrieve the number of credit products */
  creditProductsCount: Scalars['Int']['output'];
  /** The query to retrieve a credit type */
  creditType?: Maybe<CreditType>;
  /** The query to retrieve the credit types */
  creditTypes: Array<CreditType>;
  /** The query to retrieve the credit types */
  creditTypesConnection: CreditTypeConnection;
  /** The query to retrieve the number of credit types */
  creditTypesCount: Scalars['Int']['output'];
  /** The query to retrieve the credits */
  credits: Array<Credit>;
  /** The query to retrieve the credits */
  creditsConnection: CreditConnection;
  /** The query to retrieve the number of credits */
  creditsCount: Scalars['Int']['output'];
  /** The query to retrieve the current user */
  currentUser?: Maybe<User>;
  /** The query to retrieve an author by email on https://fashionunited.be */
  fashionunitedBeAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.be */
  fashionunitedBeCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.be */
  fashionunitedBeCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve an author by email on https://fashionunited.be/fr */
  fashionunitedBeFrAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.be/fr */
  fashionunitedBeFrCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.be/fr */
  fashionunitedBeFrCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be/fr with pagination */
  fashionunitedBeFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.be/fr */
  fashionunitedBeFrTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.be/fr */
  fashionunitedBeFrTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.be/fr */
  fashionunitedBeFrTagsCount: Scalars['Int']['output'];
  /** The query to retrieve a news article by id on https://fashionunited.be */
  fashionunitedBeNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.be */
  fashionunitedBeNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be */
  fashionunitedBeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be with pagination */
  fashionunitedBeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.be */
  fashionunitedBeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.be */
  fashionunitedBeNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.be */
  fashionunitedBeTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.be */
  fashionunitedBeTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.be */
  fashionunitedBeTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.ca */
  fashionunitedCaAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.ca */
  fashionunitedCaCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.ca */
  fashionunitedCaCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve an author by email on https://fashionunited.ca/fr */
  fashionunitedCaFrAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.ca/fr */
  fashionunitedCaFrCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.ca/fr */
  fashionunitedCaFrCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca/fr with pagination */
  fashionunitedCaFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.ca/fr */
  fashionunitedCaFrTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.ca/fr */
  fashionunitedCaFrTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.ca/fr */
  fashionunitedCaFrTagsCount: Scalars['Int']['output'];
  /** The query to retrieve a news article by id on https://fashionunited.ca */
  fashionunitedCaNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.ca */
  fashionunitedCaNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca */
  fashionunitedCaNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca with pagination */
  fashionunitedCaNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ca */
  fashionunitedCaNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.ca */
  fashionunitedCaNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.ca */
  fashionunitedCaTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.ca */
  fashionunitedCaTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.ca */
  fashionunitedCaTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.ch */
  fashionunitedChAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.ch */
  fashionunitedChCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.ch */
  fashionunitedChCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.ch */
  fashionunitedChNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.ch */
  fashionunitedChNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ch */
  fashionunitedChNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ch with pagination */
  fashionunitedChNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ch */
  fashionunitedChNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.ch */
  fashionunitedChNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.ch */
  fashionunitedChTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.ch */
  fashionunitedChTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.ch */
  fashionunitedChTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.cl */
  fashionunitedClAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.cl */
  fashionunitedClCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.cl */
  fashionunitedClCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.cl */
  fashionunitedClNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.cl */
  fashionunitedClNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.cl */
  fashionunitedClNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.cl with pagination */
  fashionunitedClNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.cl */
  fashionunitedClNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.cl */
  fashionunitedClNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.cl */
  fashionunitedClTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.cl */
  fashionunitedClTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.cl */
  fashionunitedClTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://cn.fashionunited.com */
  fashionunitedCnAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://cn.fashionunited.com */
  fashionunitedCnCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://cn.fashionunited.com */
  fashionunitedCnCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://cn.fashionunited.com */
  fashionunitedCnNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://cn.fashionunited.com */
  fashionunitedCnNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://cn.fashionunited.com */
  fashionunitedCnNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://cn.fashionunited.com with pagination */
  fashionunitedCnNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://cn.fashionunited.com */
  fashionunitedCnNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://cn.fashionunited.com */
  fashionunitedCnNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://cn.fashionunited.com */
  fashionunitedCnTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://cn.fashionunited.com */
  fashionunitedCnTags: Array<Tag>;
  /** The query to retrieve tags count on https://cn.fashionunited.com */
  fashionunitedCnTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.co */
  fashionunitedCoAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.co */
  fashionunitedCoCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.co */
  fashionunitedCoCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.co */
  fashionunitedCoNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.co */
  fashionunitedCoNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.co */
  fashionunitedCoNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.co with pagination */
  fashionunitedCoNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.co */
  fashionunitedCoNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.co */
  fashionunitedCoNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.co */
  fashionunitedCoTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.co */
  fashionunitedCoTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.co */
  fashionunitedCoTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.com.ar */
  fashionunitedComArAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.com.ar */
  fashionunitedComArCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.com.ar */
  fashionunitedComArCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.com.ar */
  fashionunitedComArNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.com.ar */
  fashionunitedComArNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.com.ar */
  fashionunitedComArNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ar with pagination */
  fashionunitedComArNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com.ar */
  fashionunitedComArNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.com.ar */
  fashionunitedComArNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.com.ar */
  fashionunitedComArTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.com.ar */
  fashionunitedComArTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.com.ar */
  fashionunitedComArTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.com */
  fashionunitedComAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.com */
  fashionunitedComCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.com */
  fashionunitedComCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.com */
  fashionunitedComNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.com */
  fashionunitedComNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.com */
  fashionunitedComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.com with pagination */
  fashionunitedComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com */
  fashionunitedComNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.com */
  fashionunitedComNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve an author by email on https://fashionunited.com.pe */
  fashionunitedComPeAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.com.pe */
  fashionunitedComPeCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.com.pe */
  fashionunitedComPeCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.pe with pagination */
  fashionunitedComPeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.com.pe */
  fashionunitedComPeTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.com.pe */
  fashionunitedComPeTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.com.pe */
  fashionunitedComPeTagsCount: Scalars['Int']['output'];
  /** The query to retrieve a tag on https://fashionunited.com */
  fashionunitedComTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.com */
  fashionunitedComTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.com */
  fashionunitedComTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.de */
  fashionunitedDeAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.de */
  fashionunitedDeCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.de */
  fashionunitedDeCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.de */
  fashionunitedDeNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.de */
  fashionunitedDeNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.de */
  fashionunitedDeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.de with pagination */
  fashionunitedDeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.de */
  fashionunitedDeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.de */
  fashionunitedDeNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.de */
  fashionunitedDeTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.de */
  fashionunitedDeTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.de */
  fashionunitedDeTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.es */
  fashionunitedEsAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.es */
  fashionunitedEsCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.es */
  fashionunitedEsCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.es */
  fashionunitedEsNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.es */
  fashionunitedEsNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.es */
  fashionunitedEsNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.es with pagination */
  fashionunitedEsNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.es */
  fashionunitedEsNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.es */
  fashionunitedEsNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.es */
  fashionunitedEsTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.es */
  fashionunitedEsTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.es */
  fashionunitedEsTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.fr */
  fashionunitedFrAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.fr */
  fashionunitedFrCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.fr */
  fashionunitedFrCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.fr */
  fashionunitedFrNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.fr */
  fashionunitedFrNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.fr */
  fashionunitedFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.fr with pagination */
  fashionunitedFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.fr */
  fashionunitedFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.fr */
  fashionunitedFrNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.fr */
  fashionunitedFrTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.fr */
  fashionunitedFrTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.fr */
  fashionunitedFrTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.in */
  fashionunitedInAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.in */
  fashionunitedInCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.in */
  fashionunitedInCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.in */
  fashionunitedInNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.in */
  fashionunitedInNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.in */
  fashionunitedInNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.in with pagination */
  fashionunitedInNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.in */
  fashionunitedInNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.in */
  fashionunitedInNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.in */
  fashionunitedInTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.in */
  fashionunitedInTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.in */
  fashionunitedInTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.info */
  fashionunitedInfoAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.info */
  fashionunitedInfoCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category https://fashionunited.info */
  fashionunitedInfoCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.info */
  fashionunitedInfoNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.info */
  fashionunitedInfoNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.info */
  fashionunitedInfoNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.info with pagination */
  fashionunitedInfoNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.info */
  fashionunitedInfoNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.info */
  fashionunitedInfoNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.info */
  fashionunitedInfoTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.info */
  fashionunitedInfoTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.info */
  fashionunitedInfoTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.it */
  fashionunitedItAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.it */
  fashionunitedItCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.it */
  fashionunitedItCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.it */
  fashionunitedItNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.it */
  fashionunitedItNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.it */
  fashionunitedItNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.it with pagination */
  fashionunitedItNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.it */
  fashionunitedItNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.it */
  fashionunitedItNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.it */
  fashionunitedItTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.it */
  fashionunitedItTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.it */
  fashionunitedItTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.mx */
  fashionunitedMxAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.mx */
  fashionunitedMxCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.mx */
  fashionunitedMxCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.mx */
  fashionunitedMxNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.mx */
  fashionunitedMxNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.mx */
  fashionunitedMxNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.mx with pagination */
  fashionunitedMxNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.mx */
  fashionunitedMxNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.mx */
  fashionunitedMxNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.mx */
  fashionunitedMxTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.mx */
  fashionunitedMxTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.mx */
  fashionunitedMxTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.nl */
  fashionunitedNlAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.nl */
  fashionunitedNlCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.nl */
  fashionunitedNlCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.nl */
  fashionunitedNlNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.nl */
  fashionunitedNlNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nl */
  fashionunitedNlNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nl with pagination */
  fashionunitedNlNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.nl */
  fashionunitedNlNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.nl */
  fashionunitedNlNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.nl */
  fashionunitedNlTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.nl */
  fashionunitedNlTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.nl */
  fashionunitedNlTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.nz */
  fashionunitedNzAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.nz */
  fashionunitedNzCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.nz */
  fashionunitedNzCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.nz */
  fashionunitedNzNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.nz */
  fashionunitedNzNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nz */
  fashionunitedNzNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nz with pagination */
  fashionunitedNzNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.nz */
  fashionunitedNzNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.nz */
  fashionunitedNzNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.nz */
  fashionunitedNzTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.nz */
  fashionunitedNzTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.nz */
  fashionunitedNzTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://ru.fashionunited.com */
  fashionunitedRuAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://ru.fashionunited.com */
  fashionunitedRuCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://ru.fashionunited.com */
  fashionunitedRuCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://ru.fashionunited.com */
  fashionunitedRuNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://ru.fashionunited.com */
  fashionunitedRuNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://ru.fashionunited.com */
  fashionunitedRuNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://ru.fashionunited.com with pagination */
  fashionunitedRuNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://ru.fashionunited.com */
  fashionunitedRuNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://ru.fashionunited.com */
  fashionunitedRuNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://ru.fashionunited.com */
  fashionunitedRuTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://ru.fashionunited.com */
  fashionunitedRuTags: Array<Tag>;
  /** The query to retrieve tags count on https://ru.fashionunited.com */
  fashionunitedRuTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionunited.uk */
  fashionunitedUkAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionunited.uk */
  fashionunitedUkCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category on https://fashionunited.uk */
  fashionunitedUkCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionunited.uk */
  fashionunitedUkNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionunited.uk */
  fashionunitedUkNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.uk */
  fashionunitedUkNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.uk with pagination */
  fashionunitedUkNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.uk */
  fashionunitedUkNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionunited.uk */
  fashionunitedUkNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionunited.uk */
  fashionunitedUkTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionunited.uk */
  fashionunitedUkTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionunited.uk */
  fashionunitedUkTagsCount: Scalars['Int']['output'];
  /** The query to retrieve an author by email on https://fashionweekweb.com */
  fashionweekwebComAuthorByEmail?: Maybe<LocalNewsUser>;
  /** The query to retrieve categories on https://fashionweekweb.com */
  fashionweekwebComCategories: Array<LocalNewsCategory>;
  /** The query to retrieve a category https://fashionweekweb.com */
  fashionweekwebComCategory?: Maybe<LocalNewsCategory>;
  /** The query to retrieve a news article by id on https://fashionweekweb.com */
  fashionweekwebComNewsArticle?: Maybe<LocalNewsArticle>;
  /** The query to retrieve a news article by path on https://fashionweekweb.com */
  fashionweekwebComNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionweekweb.com */
  fashionweekwebComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionweekweb.com with pagination */
  fashionweekwebComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionweekweb.com */
  fashionweekwebComNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month on https://fashionweekweb.com */
  fashionweekwebComNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve a tag on https://fashionweekweb.com */
  fashionweekwebComTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://fashionweekweb.com */
  fashionweekwebComTags: Array<Tag>;
  /** The query to retrieve tags count on https://fashionweekweb.com */
  fashionweekwebComTagsCount: Scalars['Int']['output'];
  /** If the user already has requested access for the market */
  hasMarketAccessRequest: Scalars['Boolean']['output'];
  /** If the user already has requested access for the stand */
  hasStandAccessRequest: Scalars['Boolean']['output'];
  /** The query to retrieve if there are hidden products */
  hiddenProductsExist: Scalars['Boolean']['output'];
  /** The query to retrieve an image by id */
  image?: Maybe<Image>;
  /** The query to retrieve image categories */
  imageCategories: ImageCategoryConnection;
  /** The query to retrieve an image category by id */
  imageCategory?: Maybe<ImageCategory>;
  /** The query to retrieve images */
  images: ImageConnection;
  /** The query to retrieve an author by email on https://internationalfashionjobs.com */
  internationalfashionjobsComAuthorByEmail?: Maybe<LocalNewsUser>;
  /**
   * The query to retrieve categories on
   * https://internationalfashionjobs.com
   */
  internationalfashionjobsComCategories: Array<LocalNewsCategory>;
  /**
   * The query to retrieve a category on
   * https://internationalfashionjobs.com
   */
  internationalfashionjobsComCategory?: Maybe<LocalNewsCategory>;
  /**
   * The query to retrieve a news article by id on
   * https://internationalfashionjobs.com
   */
  internationalfashionjobsComNewsArticle?: Maybe<LocalNewsArticle>;
  /**
   * The query to retrieve a news article by path on
   * https://internationalfashionjobs.com
   */
  internationalfashionjobsComNewsArticleByPath?: Maybe<LocalNewsArticle>;
  /** The query to retrieve news articles on https://internationalfashionjobs.com */
  internationalfashionjobsComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://internationalfashionjobs.com with pagination */
  internationalfashionjobsComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve a tag on https://internationalfashionjobs.com */
  internationalfashionjobsComTag?: Maybe<Tag>;
  /** The query to retrieve tags on https://internationalfashionjobs.com */
  internationalfashionjobsComTags: Array<Tag>;
  /** The query to retrieve tags count on https://internationalfashionjobs.com */
  internationalfashionjobsComTagsCount: Scalars['Int']['output'];
  /** The query to retrieve one job by locales and id */
  job?: Maybe<Job>;
  /** The query to retrieve the jobs */
  jobs: Array<Job>;
  /**
   * The query to retrieve the account managers for the selected jobs
   * @deprecated Use the job's account's account manager instead
   */
  jobsAccountManagers: Array<Scalars['String']['output']>;
  /** The query to retrieve the number of applicants for the selected jobs */
  jobsApplicantsCount: Scalars['Int']['output'];
  /** The query to retrieve the number of apply button clicks for the selected jobs */
  jobsApplyButtonClicksCount: Scalars['Int']['output'];
  /** The query to retrieve the average number of applicants for the selected jobs */
  jobsAverageApplicantsCount: Scalars['Float']['output'];
  /** The query to retrieve the average number of apply button clicks for the selected jobs */
  jobsAverageApplyButtonClicksCount: Scalars['Float']['output'];
  /** The query to retrieve the average number of pageviews for the selected jobs */
  jobsAveragePageviewsCount: Scalars['Float']['output'];
  /** The query to retrieve the average number of reposts for the selected jobs */
  jobsAverageRepostsCount: Scalars['Float']['output'];
  /** The query to retrieve the city names of the selected jobs */
  jobsCityNames?: Maybe<Array<Scalars['String']['output']>>;
  /** The query to retrieve the jobs */
  jobsConnection: JobConnection;
  /** The query to retrieve the count of jobs */
  jobsCount: Scalars['Int']['output'];
  /** The query to retrieve the integrations for the selected jobs */
  jobsIntegrations: Array<JobsIntegration>;
  /** The query to retrieve the integrations for the selected jobs */
  jobsIntegrationsCount: Scalars['Int']['output'];
  /** The query to retrieve the number of pageviews for the selected jobs */
  jobsPageviewsCount: Scalars['Int']['output'];
  /** The query to retrieve the number of reposts for the selected jobs */
  jobsRepostsCount: Scalars['Int']['output'];
  /** The query to retrieve a market by id */
  market?: Maybe<Market>;
  /** The query to retrieve market access requests */
  marketAccessRequests: Array<MarketAccessRequest>;
  /** The query to retrieve market access requests */
  marketAccessRequestsConnection: MarketAccessRequestConnection;
  /** The query to retrieve the brands of markets and stands */
  marketBrands: Array<Brand>;
  /** The query to retrieve the brands of markets and stands */
  marketBrandsConnection: BrandConnection;
  /** The query to retrieve the number of brands of markets and stands */
  marketBrandsCount: Scalars['Int']['output'];
  /** The query to retrieve a market by slug */
  marketBySlug?: Maybe<Market>;
  /** The query to retrieve the markets */
  markets: Array<Market>;
  /** The query to retrieve the markets */
  marketsConnection: MarketConnection;
  /** The query to retrieve a material by id */
  material?: Maybe<Material>;
  /** The query to retrieve the materials */
  materials: Array<Material>;
  /** The query to retrieve the materials */
  materialsConnection: MaterialConnection;
  /** The query to retrieve the number of apply button clicks for all the jobs per month */
  monthlyAllJobsApplyButtonClicksCount: Array<MonthlyCount>;
  /** The query to retrieve the number of pageviews for all the jobs per month */
  monthlyAllJobsPageviewsCount: Array<MonthlyCount>;
  /** The query to retrieve the monthly count of applicants */
  monthlyApplicantsCount: Array<MonthlyCount>;
  /** The query to retrieve the number of transactions per month */
  monthlyTransactionsCount: Array<MonthlyCount>;
  /** The query to retrieve a news article by id */
  newsArticle?: Maybe<NewsArticle>;
  /** The query to retrieve news articles */
  newsArticles: Array<NewsArticle>;
  /** The query to retrieve news articles with pagination */
  newsArticlesConnection: NewsArticleConnection;
  /** The query to retrieve the number of news articles */
  newsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of news articles per month */
  newsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve the current date and time */
  now?: Maybe<Scalars['DateTime']['output']>;
  /** The query to retrieve an order */
  order?: Maybe<Order>;
  /** The query to retrieve an order item */
  orderItem?: Maybe<OrderItem>;
  /** The query to retrieve the order items */
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  /** The query to retrieve the order items */
  orderItemsConnection?: Maybe<OrderItemConnection>;
  /** The query to retrieve the number of order items */
  orderItemsCount: Scalars['Int']['output'];
  /** The query to retrieve the orders */
  orders: Array<Order>;
  /** The query to retrieve the orders */
  ordersConnection: OrderConnection;
  /** The query to retrieve the number of orders */
  ordersCount: Scalars['Int']['output'];
  /** The query to retrieve one position by locale and id */
  position?: Maybe<Position>;
  /** The query to retrieve one position by locales and slug */
  positionBySlug?: Maybe<Position>;
  /** The query to retrieve the positions */
  positions: Array<Position>;
  /** The query to retrieve the positions */
  positionsConnection: PositionConnection;
  /** Preview a job */
  previewJob?: Maybe<Job>;
  /** Preview a news article */
  previewNewsArticle: NewsArticle;
  /** The query to retrieve a price */
  price?: Maybe<Price>;
  /** The query to retrieve the prices */
  prices: Array<Price>;
  /** The query to retrieve the prices */
  pricesConnection: PriceConnection;
  /** The query to retrieve the number of prices */
  pricesCount: Scalars['Int']['output'];
  /** The query to retrieve a print by id */
  print?: Maybe<Print>;
  /** The query to retrieve the prints */
  prints: Array<Print>;
  /** The query to retrieve the prints */
  printsConnection: PrintConnection;
  /** The query to retrieve a product by id */
  product?: Maybe<Product>;
  /** The query to retrieve the products' age groups */
  productAgeGroups: Array<AgeGroup>;
  /** The query to retrieve the brands of matching products */
  productBrands: Array<Brand>;
  /** The query to retrieve the brands of matching products */
  productBrandsConnection: BrandConnection;
  /** The query to retrieve the number of brands of matching products */
  productBrandsCount: Scalars['Int']['output'];
  /** The query to retrieve the products' category paths */
  productCategoryPaths: Array<Scalars['String']['output']>;
  /** The query to retrieve the colors */
  productColors: Array<Color>;
  /** The query to retrieve the currencies of products */
  productCurrencies: Array<Scalars['String']['output']>;
  /** The query to retrieve the delivery days of products */
  productDeliveryDays?: Maybe<DeliveryDaysRange>;
  /** The query to retrieve the products' genders */
  productGenders: Array<Gender>;
  /** The query to retrieve the products' main categories */
  productMainCategories: Array<Scalars['String']['output']>;
  /** The query to retrieve the materials of products */
  productMaterials: Array<Material>;
  /** The query to retrieve the product materials */
  productMaterialsConnection: MaterialConnection;
  /** The query to retrieve the maximum delivery days range of products */
  productMaximumDeliveryDaysRange?: Maybe<Scalars['Int']['output']>;
  /** The query to retrieve the maximum order quantity range of products */
  productMaximumOrderQuantityRange?: Maybe<Scalars['Int']['output']>;
  /** The query to retrieve the maximum price range of products */
  productMaximumPriceRange?: Maybe<Scalars['Int']['output']>;
  /** The query to retrieve if there are model or product only photos */
  productModelImages: Array<Scalars['Boolean']['output']>;
  /** The query to retrieve the order quantities of products */
  productOrderQuantities?: Maybe<OrderQuantityRange>;
  /** The query to retrieve the price range of products */
  productPrices?: Maybe<PriceRange>;
  /** The query to retrieve the prints of products */
  productPrints: Array<Print>;
  /** The query to retrieve the product prints */
  productPrintsConnection: PrintConnection;
  /** The query to retrieve the products' seasons */
  productSeasons: Array<Scalars['String']['output']>;
  /** The query to retrieve the sizes */
  productSizes: Array<Scalars['String']['output']>;
  /** The query to retrieve the products */
  products: Array<Product>;
  /** The query to retrieve the products */
  productsConnection: ProductConnection;
  /** The query to retrieve the number of products */
  productsCount: Scalars['Int']['output'];
  /** The query to retrieve one profile by id */
  profile?: Maybe<Profile>;
  /** The query to retrieve one profile by id */
  profileBySlug?: Maybe<Profile>;
  /** The query to retrieve the profiles */
  profiles: Array<Profile>;
  /** The query to retrieve the profiles */
  profilesConnection: ProfileConnection;
  /** The query to retrieve the count of profiles */
  profilesCount: Scalars['Int']['output'];
  /** The query to retrieve the possible credit types to publish a job */
  publishJobCreditTypes: Array<CreditType>;
  /** The query to retrieve the possible credit types to repost a job */
  repostJobCreditTypes: Array<CreditType>;
  /** The query to retrieve responsive image urls for a url */
  responsiveImageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The query to retrieve one schedule by id */
  schedule?: Maybe<Schedule>;
  /** The query to retrieve schedules */
  schedules: Array<Schedule>;
  /** The query to retrieve schedules */
  schedulesConnection: ScheduleConnection;
  /** The query to retrieve the number schedules */
  schedulesCount: Scalars['Int']['output'];
  /** The query to retrieve a special page from the central newsboard */
  specialPage?: Maybe<SpecialPage>;
  /** The query to retrieve a special page from the central newsboard */
  specialPageBySlug?: Maybe<SpecialPage>;
  /** The query to retrieve special pages from the central newsboard */
  specialPages: Array<SpecialPage>;
  /** The query to retrieve special pages from the central newsboard */
  specialPagesConnection: SpecialPageConnection;
  /** The count of special pages in the central newsboard */
  specialPagesCount: Scalars['Int']['output'];
  /** The query to retrieve a stand by id */
  stand?: Maybe<Stand>;
  /** The query to retrieve stand access requests */
  standAccessRequests: Array<StandAccessRequest>;
  /** The query to retrieve stand access requests */
  standAccessRequestsConnection: StandAccessRequestConnection;
  /** The query to retrieve a stand by slug */
  standBySlug?: Maybe<Stand>;
  /** The query to retrieve the stands */
  stands: Array<Stand>;
  /** The query to retrieve the stands */
  standsConnection: StandConnection;
  /** The query to retrieve a tag from the central newsboard */
  tag?: Maybe<Tag>;
  /** The query to retrieve tags from the central newsboard */
  tags: Array<Tag>;
  /** The query to retrieve tags from the central newsboard */
  tagsConnection: TagConnection;
  /** The count of tags in the central newsboard */
  tagsCount: Scalars['Int']['output'];
  /** The query to retrieve one job template by id */
  template?: Maybe<Template>;
  /** The query to retrieve job templates */
  templates: Array<Template>;
  /** The query to retrieve job templates */
  templatesConnection: TemplateConnection;
  /** The query to retrieve the number job templates */
  templatesCount: Scalars['Int']['output'];
  /** The query to retrieve a transaction */
  transaction?: Maybe<Transaction>;
  /** The query to retrieve the transactions */
  transactions: Array<Transaction>;
  /** The query to retrieve the transactions */
  transactionsConnection: TransactionConnection;
  /** The query to retrieve the number of transactions */
  transactionsCount: Scalars['Int']['output'];
  /** The query to retrieve a universal author by email */
  universalAuthorByEmail?: Maybe<UniversalNewsUser>;
  /** The query to retrieve universalcategories */
  universalCategories: Array<UniversalNewsCategory>;
  /** The query to retrieve a universalcategory */
  universalCategory?: Maybe<UniversalNewsCategory>;
  /** The query to retrieve a universal news article by id */
  universalNewsArticle?: Maybe<UniversalNewsArticle>;
  /** The query to retrieve a universal news article by path */
  universalNewsArticleByPath?: Maybe<UniversalNewsArticle>;
  /** The query to retrieve universal news articles */
  universalNewsArticles: Array<UniversalNewsArticle>;
  /** The query to retrieve universalnews articles with pagination */
  universalNewsArticlesConnection: UniversalNewsArticleConnection;
  /** The query to retrieve the number of universalnews articles */
  universalNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve the number of universal news articles per month */
  universalNewsArticlesMonthlyCount: Array<MonthlyCount>;
  /** The query to retrieve one user id */
  user?: Maybe<User>;
  /** The query to retrieve the users */
  users: Array<User>;
  /** The query to retrieve the users */
  usersConnection: UserConnection;
  /** The query to retrieve the count of users */
  usersCount: Scalars['Int']['output'];
  /** The query to retrieve a variant by id */
  variant?: Maybe<Variant>;
  /** The query to retrieve the variants */
  variants: Array<Variant>;
  /** The query to retrieve the variants */
  variantsConnection: VariantConnection;
  /** The query to retrieve the number of variants */
  variantsCount: Scalars['Int']['output'];
};


export type RootQueryTypeaccountArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeaccountsArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  crmOrganizationNumber?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
  vtigerAccountId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeaccountsConnectionArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  crmOrganizationNumber?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
  vtigerAccountId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeaccountsCountArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  crmOrganizationNumber?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
  vtigerAccountId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeallJobsApplyButtonClicksCountArgs = {
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeallJobsPageviewsCountArgs = {
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeapplicantArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeapplicantMessageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeapplicantMessagesArgs = {
  applicantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  reasons?: InputMaybe<Array<InputMaybe<ApplicantMessageReason>>>;
};


export type RootQueryTypeapplicantMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reasons?: InputMaybe<Array<InputMaybe<ApplicantMessageReason>>>;
};


export type RootQueryTypeapplicantMessagesCountArgs = {
  applicantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reasons?: InputMaybe<Array<InputMaybe<ApplicantMessageReason>>>;
};


export type RootQueryTypeapplicantsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobId?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
};


export type RootQueryTypeapplicantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobId?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
};


export type RootQueryTypeapplicantsCountArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobId?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
};


export type RootQueryTypeauFashionunitedComAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypeauFashionunitedComCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeauFashionunitedComCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeauFashionunitedComNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeauFashionunitedComNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeauFashionunitedComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeauFashionunitedComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeauFashionunitedComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeauFashionunitedComNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeauFashionunitedComTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeauFashionunitedComTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypeauFashionunitedComTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypeauthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypebrandArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypebrandsArgs = {
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<BrandSorting>;
};


export type RootQueryTypebrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BrandSorting>;
};


export type RootQueryTypebrandsCountArgs = {
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypebundleArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypebundleItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypebundleItemsArgs = {
  bundleId?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypebundleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  bundleId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypebundleItemsCountArgs = {
  bundleId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypebundlesArgs = {
  accountType?: InputMaybe<AccountType>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  type?: InputMaybe<PaymentType>;
};


export type RootQueryTypebundlesConnectionArgs = {
  accountType?: InputMaybe<AccountType>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PaymentType>;
};


export type RootQueryTypebundlesCountArgs = {
  accountType?: InputMaybe<AccountType>;
  type?: InputMaybe<PaymentType>;
};


export type RootQueryTypecategoriesArgs = {
  filterAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypecategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypecategoryKeywordArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypecategoryKeywordsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypecategoryKeywordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypecitiesArgs = {
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobsFilter?: InputMaybe<JobsFilter>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<CitySorting>;
};


export type RootQueryTypecitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActiveJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobsFilter?: InputMaybe<JobsFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<CitySorting>;
};


export type RootQueryTypecitiesCountArgs = {
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypecityArgs = {
  id: Scalars['String']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypecityBySlugArgs = {
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
};


export type RootQueryTypecolorArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypecolorsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypecolorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypecourseArgs = {
  id: Scalars['Int']['input'];
  statuses?: InputMaybe<Array<CourseStatus>>;
};


export type RootQueryTypecourseCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypecourseCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypecourseCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypecourseCountriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypecourseCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypecourseCountryArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypecourseEducationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypecourseEducationsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypecourseEducationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypecoursesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  statuses?: InputMaybe<Array<CourseStatus>>;
};


export type RootQueryTypecoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<CourseStatus>>;
};


export type RootQueryTypecoursesCountArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<CourseStatus>>;
};


export type RootQueryTypecreditArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypecreditProductArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypecreditProductsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypecreditProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypecreditTypeArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypecreditTypesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<CreditTypeSorting>;
  type?: InputMaybe<AccountType>;
};


export type RootQueryTypecreditTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CreditTypeSorting>;
  type?: InputMaybe<AccountType>;
};


export type RootQueryTypecreditTypesCountArgs = {
  type?: InputMaybe<AccountType>;
};


export type RootQueryTypecreditsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<CreditSorting>;
};


export type RootQueryTypecreditsConnectionArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<CreditSorting>;
};


export type RootQueryTypecreditsCountArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypefashionunitedBeAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedBeCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeFrAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedBeFrCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeFrCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeFrNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeFrNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeFrNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeFrTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedBeFrTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedBeFrTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedBeNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedBeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedBeTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedBeTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedBeTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCaAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCaCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaFrAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCaFrCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaFrCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaFrNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaFrNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaFrNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaFrTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCaFrTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCaFrTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCaNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCaNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCaTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCaTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCaTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedChAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedChCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedChCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedChNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedChNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedChNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedChNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedChNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedChNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedChTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedChTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedChTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedClAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedClCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedClCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedClNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedClNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedClNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedClNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedClNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedClNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedClTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedClTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedClTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCnAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCnCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCnCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCnNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCnNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCnNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCnNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCnNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCnNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCnTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCnTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCnTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCoAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCoCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCoCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCoNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCoNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedCoNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCoNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCoNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCoNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedCoTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedCoTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedCoTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedComArAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedComArCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComArCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComArNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComArNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComArNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComArNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComArNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComArNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComArTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedComArTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedComArTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedComAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedComCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComPeAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedComPeCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComPeCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComPeNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComPeNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedComPeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComPeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComPeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComPeNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedComPeTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedComPeTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedComPeTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedComTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedComTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedComTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedDeAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedDeCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedDeCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedDeNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedDeNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedDeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedDeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedDeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedDeNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedDeTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedDeTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedDeTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedEsAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedEsCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedEsCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedEsNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedEsNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedEsNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedEsNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedEsNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedEsNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedEsTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedEsTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedEsTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedFrAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedFrCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedFrCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedFrNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedFrNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedFrNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedFrTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedFrTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedFrTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedInAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedInCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedInTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedInTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedInfoAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedInfoCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInfoCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInfoNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInfoNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedInfoNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInfoNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInfoNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInfoNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedInfoTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedInfoTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedInfoTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedItAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedItCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedItCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedItNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedItNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedItNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedItNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedItNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedItNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedItTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedItTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedItTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedMxAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedMxCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedMxCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedMxNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedMxNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedMxNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedMxNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedMxNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedMxNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedMxTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedMxTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedMxTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedNlAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedNlCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNlCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNlNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNlNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNlNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNlNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNlNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNlNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNlTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedNlTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedNlTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedNzAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedNzCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNzCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNzNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNzNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedNzNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNzNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNzNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNzNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedNzTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedNzTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedNzTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedRuAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedRuCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedRuCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedRuNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedRuNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedRuNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedRuNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedRuNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedRuNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedRuTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedRuTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedRuTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedUkAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedUkCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedUkCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedUkNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedUkNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionunitedUkNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedUkNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedUkNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedUkNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionunitedUkTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionunitedUkTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionunitedUkTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionweekwebComAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypefashionweekwebComCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionweekwebComCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionweekwebComNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionweekwebComNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypefashionweekwebComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionweekwebComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionweekwebComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionweekwebComNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypefashionweekwebComTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypefashionweekwebComTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypefashionweekwebComTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypehasMarketAccessRequestArgs = {
  marketId: Scalars['Int']['input'];
};


export type RootQueryTypehasStandAccessRequestArgs = {
  standId: Scalars['Int']['input'];
};


export type RootQueryTypehiddenProductsExistArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeimageArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeimageCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeimageCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeimagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeForCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
  freeForEditorialUse?: InputMaybe<Scalars['Boolean']['input']>;
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noAttributionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ImageSorting>;
};


export type RootQueryTypeinternationalfashionjobsComAuthorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootQueryTypeinternationalfashionjobsComCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeinternationalfashionjobsComCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeinternationalfashionjobsComNewsArticleArgs = {
  id: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeinternationalfashionjobsComNewsArticleByPathArgs = {
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeinternationalfashionjobsComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeinternationalfashionjobsComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeinternationalfashionjobsComTagArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeinternationalfashionjobsComTagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypeinternationalfashionjobsComTagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypejobArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypejobsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsAccountManagersArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsApplicantsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsApplyButtonClicksCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsAverageApplicantsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsAverageApplyButtonClicksCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsAveragePageviewsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsAverageRepostsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsCityNamesArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsIntegrationsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: JobsIntegrationSorting;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsIntegrationsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsPageviewsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypejobsRepostsCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagers?: InputMaybe<Array<Scalars['String']['input']>>;
  applyForm?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublications?: InputMaybe<Scalars['DateTime']['input']>;
  maxPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minPublications?: InputMaybe<Scalars['DateTime']['input']>;
  minPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<JobSorting>;
  status?: InputMaybe<JobStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypemarketArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypemarketAccessRequestsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypemarketAccessRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypemarketBrandsArgs = {
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: Scalars['Int']['input'];
  retailerName?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductBrandSorting>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypemarketBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductBrandSorting>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypemarketBrandsCountArgs = {
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypemarketBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypemarketsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypemarketsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypematerialArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypematerialsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypematerialsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypemonthlyAllJobsApplyButtonClicksCountArgs = {
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypemonthlyAllJobsPageviewsCountArgs = {
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypemonthlyApplicantsCountArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobId?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
};


export type RootQueryTypemonthlyTransactionsCountArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  creditIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypenewsArticleArgs = {
  id: Scalars['Int']['input'];
  newsboard?: InputMaybe<Newsboard>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypenewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypenewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypenewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypenewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeorderArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeorderItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeorderItemsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeorderItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeorderItemsCountArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeordersArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  insertedByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  statuses?: InputMaybe<Array<OrderStatus>>;
  subscriptionCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PaymentType>;
};


export type RootQueryTypeordersConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  insertedByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<OrderStatus>>;
  subscriptionCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PaymentType>;
};


export type RootQueryTypeordersCountArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  insertedByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<OrderStatus>>;
  subscriptionCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PaymentType>;
};


export type RootQueryTypepositionArgs = {
  id: Scalars['String']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypepositionBySlugArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
};


export type RootQueryTypepositionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypepositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypepreviewJobArgs = {
  job: JobInput;
};


export type RootQueryTypepreviewNewsArticleArgs = {
  accessLevel?: InputMaybe<AccessLevel>;
  alternativeReadmore?: InputMaybe<Scalars['String']['input']>;
  articleLayout?: InputMaybe<Scalars['String']['input']>;
  articlePageTitle?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  dek?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  infoBlockPosition?: InputMaybe<Scalars['Boolean']['input']>;
  infoBlockShowTitle?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  linkAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  linkCategory?: InputMaybe<Scalars['Boolean']['input']>;
  linkParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  linkTitles?: InputMaybe<Scalars['Boolean']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  originalNewsArticleId?: InputMaybe<Scalars['Int']['input']>;
  publishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  showArticleOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  showAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  showCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showCreateDate?: InputMaybe<Scalars['Boolean']['input']>;
  showEmailIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showHits?: InputMaybe<Scalars['Boolean']['input']>;
  showIcons?: InputMaybe<Scalars['Boolean']['input']>;
  showIntro?: InputMaybe<Scalars['Boolean']['input']>;
  showItemNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  showModifyDate?: InputMaybe<Scalars['Boolean']['input']>;
  showNoauth?: InputMaybe<Scalars['Boolean']['input']>;
  showParentCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showPrintIcon?: InputMaybe<Scalars['Boolean']['input']>;
  showPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  showPublishingOptions?: InputMaybe<Scalars['Boolean']['input']>;
  showTags?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  showUrlsImagesBackend?: InputMaybe<Scalars['Boolean']['input']>;
  showUrlsImagesFrontend?: InputMaybe<Scalars['Boolean']['input']>;
  showVote?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  urlsPosition?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<NewsArticleVisibility>;
};


export type RootQueryTypepriceArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypepricesArgs = {
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypepricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypepricesCountArgs = {
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeprintArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeprintsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypeprintsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeproductArgs = {
  id: Scalars['Int']['input'];
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeproductAgeGroupsArgs = {
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductBrandsArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: Scalars['Int']['input'];
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<ProductBrandSorting>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<ProductBrandSorting>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductBrandsCountArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  hasFinishedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductCategoryPathsArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductColorsArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductCurrenciesArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductDeliveryDaysArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductGendersArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductMainCategoriesArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductMaterialsArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: Scalars['Int']['input'];
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductMaterialsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  maybeBrandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maybeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductMaximumDeliveryDaysRangeArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductMaximumOrderQuantityRangeArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductMaximumPriceRangeArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductModelImagesArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maybeBrandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maybeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductOrderQuantitiesArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductPricesArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductPrintsArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: Scalars['Int']['input'];
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductPrintsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maybeBrandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maybeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductSeasonsArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductSizesArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductsArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maybeBrandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maybeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: Scalars['Int']['input'];
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<ProductSorting>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maybeBrandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maybeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<ProductSorting>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeproductsCountArgs = {
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveryDaysAtLeast?: InputMaybe<Scalars['Int']['input']>;
  deliveryDaysAtMost?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  orderQuantityAtLeast?: InputMaybe<Scalars['Int']['input']>;
  orderQuantityAtMost?: InputMaybe<Scalars['Int']['input']>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  withImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeprofileArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypeprofileBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeprofilesArgs = {
  canUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  hasTabs?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProfileSorting>;
  type?: InputMaybe<ProfileType>;
};


export type RootQueryTypeprofilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  canUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTabs?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProfileSorting>;
  type?: InputMaybe<ProfileType>;
};


export type RootQueryTypeprofilesCountArgs = {
  canUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  hasTabs?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
};


export type RootQueryTypepublishJobCreditTypesArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTyperepostJobCreditTypesArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTyperesponsiveImageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
  url: Scalars['String']['input'];
};


export type RootQueryTypescheduleArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeschedulesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ScheduleSorting>;
  statuses?: InputMaybe<Array<ScheduleStatus>>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  templates?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypeschedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ScheduleSorting>;
  statuses?: InputMaybe<Array<ScheduleStatus>>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  templates?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypeschedulesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ScheduleStatus>>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  templates?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypespecialPageArgs = {
  id: Scalars['Int']['input'];
  newsboard?: InputMaybe<Newsboard>;
};


export type RootQueryTypespecialPageBySlugArgs = {
  newsboard: Newsboard;
  slug: Scalars['String']['input'];
};


export type RootQueryTypespecialPagesArgs = {
  limit?: Scalars['Int']['input'];
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SpecialPageSorting>;
};


export type RootQueryTypespecialPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SpecialPageSorting>;
};


export type RootQueryTypespecialPagesCountArgs = {
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypestandArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypestandAccessRequestsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypestandAccessRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypestandBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypestandsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type RootQueryTypestandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypetagArgs = {
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  slug: Scalars['String']['input'];
};


export type RootQueryTypetagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypetagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypetagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypetemplateArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypetemplatesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypetemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypetemplatesCountArgs = {
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypetransactionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypetransactionsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  creditIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: Scalars['Int']['input'];
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypetransactionsConnectionArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  creditIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypetransactionsCountArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  creditIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeuniversalAuthorByEmailArgs = {
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  email: Scalars['String']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  newsboard?: InputMaybe<Newsboard>;
};


export type RootQueryTypeuniversalCategoriesArgs = {
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  limit?: Scalars['Int']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  offset?: Scalars['Int']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeuniversalCategoryArgs = {
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  id?: InputMaybe<Scalars['Int']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  path?: InputMaybe<Scalars['String']['input']>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeuniversalNewsArticleArgs = {
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  id: Scalars['Int']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeuniversalNewsArticleByPathArgs = {
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  newsboard?: InputMaybe<Newsboard>;
  path: Scalars['String']['input'];
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


export type RootQueryTypeuniversalNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeuniversalNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeuniversalNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeuniversalNewsArticlesMonthlyCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootQueryTypeuserArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeusersArgs = {
  accountManager?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  registeredVia?: InputMaybe<Registrar>;
  search?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeusersConnectionArgs = {
  accountManager?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  registeredVia?: InputMaybe<Registrar>;
  search?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeusersCountArgs = {
  accountManager?: InputMaybe<Scalars['Boolean']['input']>;
  registeredVia?: InputMaybe<Registrar>;
  search?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypevariantArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypevariantsArgs = {
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  colorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  standId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypevariantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  colorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypevariantsCountArgs = {
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  colorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** The subscription to image creation, returns the created image */
  imageCreated: Image;
  /** The subscription to image update, returns the updated image */
  imageUpdated: Image;
  orderUpdated: Order;
};


export type RootSubscriptionTypeimageCreatedArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  freeForCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
  freeForEditorialUse?: InputMaybe<Scalars['Boolean']['input']>;
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noAttributionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootSubscriptionTypeimageUpdatedArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSubscriptionTypeorderUpdatedArgs = {
  id: Scalars['Int']['input'];
};

/** An integration schedule */
export type Schedule = {
  __typename?: 'Schedule';
  /** The cron expression for the schedule timing */
  cron: Scalars['String']['output'];
  /** The ID of the schedule */
  id: Scalars['Int']['output'];
  /** When the schedule was created */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the schedule */
  insertedBy?: Maybe<User>;
  /** The last time the schedule has succeeded */
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The last time the schedule has failed */
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The URL-friendly slug of the schedule */
  slug: Scalars['String']['output'];
  /** The status of the schedule */
  status: ScheduleStatus;
  /** Is the schedule suspended? */
  suspended: Scalars['Boolean']['output'];
  /** The template used by the schedule */
  template: Scalars['String']['output'];
  /** The title of the schedule */
  title: Scalars['String']['output'];
  /** When the schedule was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the schedule */
  updatedBy?: Maybe<User>;
  /** The variables for the schedule */
  variables: Scalars['Json']['output'];
};

export type ScheduleConnection = {
  __typename?: 'ScheduleConnection';
  edges: Array<ScheduleEdge>;
  pageInfo: PageInfo;
};

export type ScheduleEdge = {
  __typename?: 'ScheduleEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Schedule;
};

/** The sorting of the schedules */
export enum ScheduleSorting {
  /** Sort by slug alphabetically */
  ALPHABETICAL = 'ALPHABETICAL',
  /** Sort by relevance */
  RELEVANCE = 'RELEVANCE'
}

/** The status of the schedule */
export enum ScheduleStatus {
  /** The schedule has completed */
  COMPLETE = 'COMPLETE',
  /** The schedule has failed */
  FAILED = 'FAILED',
  /** The schedule is currently running */
  RUNNING = 'RUNNING',
  /** The status of the schedule is unknown */
  UNKNOWN = 'UNKNOWN'
}

/** News article score */
export type Score = {
  __typename?: 'Score';
  /** The name of the score */
  name: Scalars['String']['output'];
  /** The value of the score */
  value: Scalars['Float']['output'];
};

/** News article score criteria */
export type ScoreCriteria = {
  /** The name of the score */
  name: Scalars['String']['input'];
  /** The value of the score */
  value: Scalars['Float']['input'];
};

/** The session object */
export type Session = {
  __typename?: 'Session';
  /** The access token */
  accessToken: Scalars['String']['output'];
};

export type SpecialPage = {
  __typename?: 'SpecialPage';
  /** The query to retrieve news articles on https://au.fashionunited.com */
  auFashionunitedComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://au.fashionunited.com with pagination */
  auFashionunitedComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://au.fashionunited.com */
  auFashionunitedComNewsArticlesCount: Scalars['Int']['output'];
  /** The description of the special page */
  description?: Maybe<Scalars['String']['output']>;
  /** The query to retrieve news articles on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be/fr with pagination */
  fashionunitedBeFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.be */
  fashionunitedBeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be with pagination */
  fashionunitedBeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.be */
  fashionunitedBeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca/fr with pagination */
  fashionunitedCaFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.ca */
  fashionunitedCaNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca with pagination */
  fashionunitedCaNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ca */
  fashionunitedCaNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.ch */
  fashionunitedChNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ch with pagination */
  fashionunitedChNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ch */
  fashionunitedChNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.cl */
  fashionunitedClNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.cl with pagination */
  fashionunitedClNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.cl */
  fashionunitedClNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://cn.fashionunited.com */
  fashionunitedCnNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://cn.fashionunited.com with pagination */
  fashionunitedCnNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://cn.fashionunited.com */
  fashionunitedCnNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.co */
  fashionunitedCoNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.co with pagination */
  fashionunitedCoNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.co */
  fashionunitedCoNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.com.ar */
  fashionunitedComArNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ar with pagination */
  fashionunitedComArNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com.ar */
  fashionunitedComArNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.com */
  fashionunitedComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.com with pagination */
  fashionunitedComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com */
  fashionunitedComNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.pe with pagination */
  fashionunitedComPeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.de */
  fashionunitedDeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.de with pagination */
  fashionunitedDeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.de */
  fashionunitedDeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.es */
  fashionunitedEsNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.es with pagination */
  fashionunitedEsNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.es */
  fashionunitedEsNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.fr */
  fashionunitedFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.fr with pagination */
  fashionunitedFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.fr */
  fashionunitedFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.in */
  fashionunitedInNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.in with pagination */
  fashionunitedInNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.in */
  fashionunitedInNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.info */
  fashionunitedInfoNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.info with pagination */
  fashionunitedInfoNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.info */
  fashionunitedInfoNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.it */
  fashionunitedItNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.it with pagination */
  fashionunitedItNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.it */
  fashionunitedItNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.mx */
  fashionunitedMxNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.mx with pagination */
  fashionunitedMxNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.mx */
  fashionunitedMxNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.nl */
  fashionunitedNlNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nl with pagination */
  fashionunitedNlNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.nl */
  fashionunitedNlNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.nz */
  fashionunitedNzNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nz with pagination */
  fashionunitedNzNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.nz */
  fashionunitedNzNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://ru.fashionunited.com */
  fashionunitedRuNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://ru.fashionunited.com with pagination */
  fashionunitedRuNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://ru.fashionunited.com */
  fashionunitedRuNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.uk */
  fashionunitedUkNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.uk with pagination */
  fashionunitedUkNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.uk */
  fashionunitedUkNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionweekweb.com */
  fashionweekwebComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionweekweb.com with pagination */
  fashionweekwebComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionweekweb.com */
  fashionweekwebComNewsArticlesCount: Scalars['Int']['output'];
  /** The header of the special page */
  header?: Maybe<Scalars['String']['output']>;
  /** The id of the special page */
  id: Scalars['Int']['output'];
  /** The image url of the special page */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image URLs of the special page */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The creation date of the special page */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the special page */
  insertedBy?: Maybe<User>;
  /** The query to retrieve news articles on https://internationalfashionjobs.com */
  internationalfashionjobsComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://internationalfashionjobs.com with pagination */
  internationalfashionjobsComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://internationalfashionjobs.com */
  internationalfashionjobsComNewsArticlesCount: Scalars['Int']['output'];
  /** The mobile image url of the special page */
  links: Array<SpecialPageLink>;
  /** The mobile image url of the special page */
  mobileImageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive mobile image URLs of the special page */
  mobileImageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The news articles related to this tag */
  newsArticles: Array<NewsArticle>;
  /** The news article connection of the tag's article */
  newsArticlesConnection: NewsArticleConnection;
  /** The count of the tag's news articles */
  newsArticlesCount: Scalars['Int']['output'];
  /** The newsboard for the special page */
  newsboard: Newsboard;
  /** The slug for the special page */
  slug: Scalars['String']['output'];
  /** The special page's tags on the site */
  tags: Array<Tag>;
  /** The special page's tags on the site */
  tagsConnection: TagConnection;
  /** The count of the special page's tags on the site */
  tagsCount: Scalars['Int']['output'];
  /** The title of the special page */
  title: Scalars['String']['output'];
  /** The query to retrieve universal news articles */
  universalNewsArticles: Array<UniversalNewsArticle>;
  /** The query to retrieve universalnews articles with pagination */
  universalNewsArticlesConnection: UniversalNewsArticleConnection;
  /** The query to retrieve the number of universalnews articles */
  universalNewsArticlesCount: Scalars['Int']['output'];
  /** The date of the last update of the special page */
  updatedAt: Scalars['DateTime']['output'];
  /** The last updater of the special page */
  updatedBy?: Maybe<User>;
};


export type SpecialPageauFashionunitedComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPageauFashionunitedComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPageauFashionunitedComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedBeFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedBeFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedBeFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedBeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedBeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedBeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCaFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCaFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCaFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCaNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCaNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCaNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedChNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedChNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedChNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedClNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedClNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedClNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCnNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCnNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCnNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCoNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCoNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedCoNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComArNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComArNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComArNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComPeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComPeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedComPeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedDeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedDeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedDeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedEsNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedEsNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedEsNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedInNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedInNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedInNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedInfoNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedInfoNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedInfoNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedItNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedItNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedItNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedMxNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedMxNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedMxNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedNlNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedNlNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedNlNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedNzNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedNzNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedNzNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedRuNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedRuNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedRuNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedUkNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedUkNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionunitedUkNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionweekwebComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionweekwebComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagefashionweekwebComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPageimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


export type SpecialPageinternationalfashionjobsComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPageinternationalfashionjobsComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPageinternationalfashionjobsComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagemobileImageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


export type SpecialPagenewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagenewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagenewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPagetagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SpecialPagetagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SpecialPagetagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SpecialPageuniversalNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPageuniversalNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SpecialPageuniversalNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SpecialPageConnection = {
  __typename?: 'SpecialPageConnection';
  edges: Array<SpecialPageEdge>;
  pageInfo: PageInfo;
};

export type SpecialPageEdge = {
  __typename?: 'SpecialPageEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: SpecialPage;
};

/** Special page identifier */
export type SpecialPageIdentifier = {
  /** The newsboard of the special page */
  newsboard: Newsboard;
  /** The slug of the special page */
  slug: Scalars['String']['input'];
};

export type SpecialPageLink = {
  __typename?: 'SpecialPageLink';
  /** The href of the special page link */
  href?: Maybe<Scalars['String']['output']>;
  /** The route parameters of the special page link */
  parameters?: Maybe<Scalars['Json']['output']>;
  /** The route of the special page link */
  route?: Maybe<Scalars['String']['output']>;
  /** The title of the special page link */
  title?: Maybe<Scalars['String']['output']>;
};

export type SpecialPageLinkInput = {
  /** The href of the special page link */
  href?: InputMaybe<Scalars['String']['input']>;
  /** The route parameters of the special page link */
  parameters?: InputMaybe<Scalars['Json']['input']>;
  /** The route of the special page link */
  route?: InputMaybe<Scalars['String']['input']>;
  /** The title of the special page link */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Special page sorting */
export enum SpecialPageSorting {
  /** By relevance descending */
  RELEVANCE_DESCENDING = 'RELEVANCE_DESCENDING',
  /** By slug ascending */
  SLUG_ASCENDING = 'SLUG_ASCENDING'
}

export type Stand = {
  __typename?: 'Stand';
  /** The body text of the market */
  body?: Maybe<Scalars['String']['output']>;
  /** The description of the stand */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of the stand */
  id: Scalars['Int']['output'];
  /** The image url of the stand */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of the stand */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The stand's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The market of the stand */
  market: Market;
  /** The name of the stand */
  name: Scalars['String']['output'];
  /** The slug of the stand */
  slug: Scalars['String']['output'];
  /** The text of the stand */
  text?: Maybe<Scalars['String']['output']>;
  /** The stand's last modification date */
  updatedAt: Scalars['DateTime']['output'];
};


export type StandimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

export type StandAccessRequest = {
  __typename?: 'StandAccessRequest';
  /** The id of the stand access request */
  id: Scalars['Int']['output'];
  /** The stand of the access request */
  stand: Stand;
  /** The user of the access request */
  user?: Maybe<User>;
};

export type StandAccessRequestConnection = {
  __typename?: 'StandAccessRequestConnection';
  edges: Array<StandAccessRequestEdge>;
  pageInfo: PageInfo;
};

export type StandAccessRequestEdge = {
  __typename?: 'StandAccessRequestEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: StandAccessRequest;
};

export type StandConnection = {
  __typename?: 'StandConnection';
  edges: Array<StandEdge>;
  pageInfo: PageInfo;
};

export type StandEdge = {
  __typename?: 'StandEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Stand;
};

export type Tag = {
  __typename?: 'Tag';
  /** The query to retrieve news articles on https://au.fashionunited.com */
  auFashionunitedComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://au.fashionunited.com with pagination */
  auFashionunitedComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://au.fashionunited.com */
  auFashionunitedComNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be/fr with pagination */
  fashionunitedBeFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.be/fr */
  fashionunitedBeFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.be */
  fashionunitedBeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.be with pagination */
  fashionunitedBeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.be */
  fashionunitedBeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca/fr with pagination */
  fashionunitedCaFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ca/fr */
  fashionunitedCaFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.ca */
  fashionunitedCaNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ca with pagination */
  fashionunitedCaNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ca */
  fashionunitedCaNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.ch */
  fashionunitedChNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ch with pagination */
  fashionunitedChNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.ch */
  fashionunitedChNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.cl */
  fashionunitedClNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.cl with pagination */
  fashionunitedClNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.cl */
  fashionunitedClNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://cn.fashionunited.com */
  fashionunitedCnNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://cn.fashionunited.com with pagination */
  fashionunitedCnNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://cn.fashionunited.com */
  fashionunitedCnNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.co */
  fashionunitedCoNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.co with pagination */
  fashionunitedCoNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.co */
  fashionunitedCoNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.com.ar */
  fashionunitedComArNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.ar with pagination */
  fashionunitedComArNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com.ar */
  fashionunitedComArNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.com */
  fashionunitedComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.com with pagination */
  fashionunitedComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com */
  fashionunitedComNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.pe with pagination */
  fashionunitedComPeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.com.pe */
  fashionunitedComPeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.de */
  fashionunitedDeNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.de with pagination */
  fashionunitedDeNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.de */
  fashionunitedDeNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.es */
  fashionunitedEsNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.es with pagination */
  fashionunitedEsNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.es */
  fashionunitedEsNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.fr */
  fashionunitedFrNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.fr with pagination */
  fashionunitedFrNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.fr */
  fashionunitedFrNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.in */
  fashionunitedInNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.in with pagination */
  fashionunitedInNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.in */
  fashionunitedInNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.info */
  fashionunitedInfoNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.info with pagination */
  fashionunitedInfoNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.info */
  fashionunitedInfoNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.it */
  fashionunitedItNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.it with pagination */
  fashionunitedItNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.it */
  fashionunitedItNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.mx */
  fashionunitedMxNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.mx with pagination */
  fashionunitedMxNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.mx */
  fashionunitedMxNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.nl */
  fashionunitedNlNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nl with pagination */
  fashionunitedNlNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.nl */
  fashionunitedNlNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.nz */
  fashionunitedNzNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.nz with pagination */
  fashionunitedNzNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.nz */
  fashionunitedNzNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://ru.fashionunited.com */
  fashionunitedRuNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://ru.fashionunited.com with pagination */
  fashionunitedRuNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://ru.fashionunited.com */
  fashionunitedRuNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionunited.uk */
  fashionunitedUkNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionunited.uk with pagination */
  fashionunitedUkNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionunited.uk */
  fashionunitedUkNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://fashionweekweb.com */
  fashionweekwebComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://fashionweekweb.com with pagination */
  fashionweekwebComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://fashionweekweb.com */
  fashionweekwebComNewsArticlesCount: Scalars['Int']['output'];
  /** The query to retrieve news articles on https://internationalfashionjobs.com */
  internationalfashionjobsComNewsArticles: Array<LocalNewsArticle>;
  /** The query to retrieve news articles on https://internationalfashionjobs.com with pagination */
  internationalfashionjobsComNewsArticlesConnection: LocalNewsArticleConnection;
  /** The query to retrieve the number of news articles on https://internationalfashionjobs.com */
  internationalfashionjobsComNewsArticlesCount: Scalars['Int']['output'];
  /** The news articles related to this tag */
  newsArticles: Array<NewsArticle>;
  /** The news article connection of the tag's article */
  newsArticlesConnection: NewsArticleConnection;
  /** The count of the tag's news articles */
  newsArticlesCount: Scalars['Int']['output'];
  /** The path for the tag */
  path?: Maybe<Scalars['String']['output']>;
  /** The slug for the tag */
  slug: Scalars['String']['output'];
  /** The title of the tag */
  title: Scalars['String']['output'];
  /** The query to retrieve universal news articles */
  universalNewsArticles: Array<UniversalNewsArticle>;
  /** The query to retrieve universalnews articles with pagination */
  universalNewsArticlesConnection: UniversalNewsArticleConnection;
  /** The query to retrieve the number of universalnews articles */
  universalNewsArticlesCount: Scalars['Int']['output'];
};


export type TagauFashionunitedComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagauFashionunitedComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagauFashionunitedComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedBeFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedBeFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedBeFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedBeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedBeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedBeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCaFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCaFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCaFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCaNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCaNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCaNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedChNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedChNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedChNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedClNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedClNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedClNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCnNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCnNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCnNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCoNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCoNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedCoNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComArNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComArNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComArNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComPeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComPeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedComPeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedDeNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedDeNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedDeNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedEsNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedEsNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedEsNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedFrNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedFrNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedFrNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedInNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedInNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedInNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedInfoNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedInfoNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedInfoNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedItNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedItNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedItNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedMxNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedMxNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedMxNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedNlNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedNlNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedNlNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedNzNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedNzNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedNzNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedRuNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedRuNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedRuNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedUkNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedUkNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionunitedUkNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionweekwebComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionweekwebComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagfashionweekwebComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TaginternationalfashionjobsComNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TaginternationalfashionjobsComNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TaginternationalfashionjobsComNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagnewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagnewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TagnewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOfId?: InputMaybe<Scalars['Int']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  localNewsboards?: InputMaybe<Array<LocalNewsboard>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  own?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TaguniversalNewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TaguniversalNewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TaguniversalNewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  duplicatesOf?: InputMaybe<UniversalNewsArticleSelector>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard?: InputMaybe<Newsboard>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TagConnection = {
  __typename?: 'TagConnection';
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Tag;
};

/** Tag sorting */
export enum TagSorting {
  /** By news articles count descending */
  NEWS_ARTICLES_COUNT_DESCENDING = 'NEWS_ARTICLES_COUNT_DESCENDING',
  /** By relevance and news articles count descending */
  RELEVANCE_AND_NEWS_ARTICLES_COUNT_DESCENDING = 'RELEVANCE_AND_NEWS_ARTICLES_COUNT_DESCENDING',
  /** By relevance descending */
  RELEVANCE_DESCENDING = 'RELEVANCE_DESCENDING',
  /** By slug ascending */
  SLUG_ASCENDING = 'SLUG_ASCENDING'
}

/** A job template */
export type Template = {
  __typename?: 'Template';
  /** List of company names used by this template */
  companyNames: Array<Scalars['String']['output']>;
  /** The templates's id */
  id: Scalars['String']['output'];
  /** The creation date of the template */
  insertedAt: Scalars['DateTime']['output'];
  /** The template's properties, including the ones provided by the parent */
  mergedProperties: Array<JobProperty>;
  /** The template's parent */
  parent?: Maybe<Template>;
  /** The templates's parent's id */
  parentId?: Maybe<Scalars['String']['output']>;
  /** The template's profile ids */
  profileIds: Array<Scalars['String']['output']>;
  /** The template's company profiles */
  profiles: Array<Profile>;
  /** The template's company profiles */
  profilesConnection: ProfileConnection;
  /** The count of the template's company profiles */
  profilesCount: Scalars['Int']['output'];
  /** The template's properties */
  properties: Array<JobProperty>;
  /** Is templates public? */
  public: Scalars['Boolean']['output'];
  /** The git commit hash of the template */
  revision: Scalars['String']['output'];
  /** The templates's compiled JavaScript source code */
  source: Scalars['String']['output'];
  /** The templates's source name */
  sourceName: Scalars['String']['output'];
  /** The date of the last update of the template */
  updatedAt: Scalars['DateTime']['output'];
};


/** A job template */
export type TemplateprofilesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<ProfileSorting>;
};


/** A job template */
export type TemplateprofilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfileSorting>;
};

export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  edges: Array<TemplateEdge>;
  pageInfo: PageInfo;
};

export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Template;
};

/** The response of the correctText mutation */
export type TextCorrectionResult = {
  __typename?: 'TextCorrectionResult';
  /** The input text of correction */
  input: Scalars['String']['output'];
  /** The result of the text correction */
  result: Scalars['String']['output'];
  /** The results of applying the rules */
  rules: Array<TextCorrectionRuleResult>;
};

/** The configuration for a text correction rule */
export type TextCorrectionRuleConfiguration = {
  /** The configuration for the generative AI for this rule */
  generationConfig?: InputMaybe<Scalars['Json']['input']>;
  /** The maximum number of revisions for applying this rule */
  maximumRevisions?: InputMaybe<Scalars['Int']['input']>;
  /** The model to use for this rule */
  model?: InputMaybe<Scalars['String']['input']>;
  /** The rule to apply */
  rule: Scalars['String']['input'];
  /** The timeout for applying this rule */
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

/** One step of a text correction */
export type TextCorrectionRuleResult = {
  __typename?: 'TextCorrectionRuleResult';
  /** The input text of correction */
  input: Scalars['String']['output'];
  /** The result after applying this rule */
  result: Scalars['String']['output'];
  /** The rule used */
  rule: Scalars['String']['output'];
  /** The steps of applying these rules */
  steps: Array<TextCorrectionRuleResultStep>;
};

/** One step of a text correction rule */
export type TextCorrectionRuleResultStep = {
  __typename?: 'TextCorrectionRuleResultStep';
  /** The feedback */
  feedback?: Maybe<Scalars['String']['output']>;
  /** The revision */
  revision: Scalars['Int']['output'];
  /** The text */
  text: Scalars['String']['output'];
  /** The type of the step */
  type: TextCorrectionRuleStepType;
};

/** The text correction rule step type */
export enum TextCorrectionRuleStepType {
  /** Edit */
  EDIT = 'EDIT',
  /** Proofread */
  PROOFREAD = 'PROOFREAD'
}

/** A transaction */
export type Transaction = {
  __typename?: 'Transaction';
  /** The account of the transaction */
  account: Account;
  /** The amount of the transaction */
  amount: Scalars['Decimal']['output'];
  /** The attributes of a transaction */
  attributes?: Maybe<Scalars['Json']['output']>;
  /** The comment of the transaction */
  comment?: Maybe<Scalars['String']['output']>;
  /** The credit type of the transaction */
  creditType: CreditType;
  /** The credits of the transaction */
  credits: Array<Credit>;
  /** The credits of the transaction */
  creditsConnection: CreditConnection;
  /** The number of credits of the transaction */
  creditsCount: Scalars['Int']['output'];
  /** The id of the transaction */
  id: Scalars['Int']['output'];
  /** The creation date of the transaction */
  insertedAt: Scalars['DateTime']['output'];
  /** The creator of the transaction */
  insertedBy?: Maybe<User>;
  /** The product of the transaction */
  product?: Maybe<CreditProduct>;
  /** The subject of the transaction */
  subject?: Maybe<TransactionSubject>;
  /** The subject id of the transaction */
  subjectId?: Maybe<Scalars['String']['output']>;
  /** The subject type of the transaction */
  subjectType?: Maybe<Scalars['String']['output']>;
};


/** A transaction */
export type TransactioncreditsArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<CreditSorting>;
};


/** A transaction */
export type TransactioncreditsConnectionArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<CreditSorting>;
};


/** A transaction */
export type TransactioncreditsCountArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  creditTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  minExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Transaction;
};

/** A transaction subject */
export type TransactionSubject = Job;

/** A universal news article */
export type UniversalNewsArticle = {
  /** The article's access level */
  accessLevel: AccessLevel;
  /** The article's attributes */
  attributes?: Maybe<NewsArticleAttributes>;
  /** Whether the article is auto-translated */
  autoTranslated: Scalars['Boolean']['output'];
  /** The article's body */
  body: Scalars['String']['output'];
  /**
   * The article's category like: fashion, retail, business, culture, people,
   * fairs, news, schools, report, management, video
   */
  category?: Maybe<UniversalNewsCategory>;
  /**
   * The article's creation date on the site
   * @deprecated Use insertedAt instead
   */
  createdAt: Scalars['DateTime']['output'];
  /** The article's creator user */
  creator?: Maybe<UniversalNewsUser>;
  /** The article's dek */
  dek?: Maybe<Scalars['String']['output']>;
  /** The article's meta description */
  description?: Maybe<Scalars['String']['output']>;
  /** The article's text as displayed on the site */
  displayText: Scalars['String']['output'];
  /** Is the article featured? */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** The article's first paragraph */
  firstParagraph: Scalars['String']['output'];
  /** Has the current user access to the artice? */
  hasAccess: Scalars['Boolean']['output'];
  /** The article's id */
  id: Scalars['Int']['output'];
  /** The caption of article's image */
  imageCaption?: Maybe<Scalars['String']['output']>;
  /** The url of article's image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The article's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The article's meta keywords */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The acticle's labels */
  labels: Array<Scalars['String']['output']>;
  /** Is the news article partner content? */
  partnerContent: Scalars['Boolean']['output'];
  /** Is the news article a press release? */
  pressRelease: Scalars['Boolean']['output'];
  /** The article's scheduled publication date, null if not scheduled */
  publishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reference of the news article */
  reference?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of article's image on the site */
  responsiveImageUrls?: Maybe<ResponsiveImageUrls>;
  /** The scores */
  scores: Array<Score>;
  /** The article's slug */
  slug: Scalars['String']['output'];
  /** The acticle's status: trashed, unpublished, published, archived */
  status: NewsArticleStatus;
  /** The article's summary */
  summary: Scalars['String']['output'];
  /** The article's tags */
  tags: Array<Tag>;
  /** The article's tags */
  tagsConnection: TagConnection;
  /** The count of the article's tags */
  tagsCount: Scalars['Int']['output'];
  /** The article's text */
  text: Scalars['String']['output'];
  /** The article's title */
  title: Scalars['String']['output'];
  /** The article's scheduled unpublish date, null if not scheduled */
  unpublishScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The article's date of last modification */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who updated the article the last on the site */
  updater?: Maybe<UniversalNewsUser>;
  /** The article's version */
  version?: Maybe<Scalars['Int']['output']>;
  /** The article's visibility: PUBLIC, REGISTERED, SPECIAL */
  visibility: NewsArticleVisibility;
};


/** A universal news article */
export type UniversalNewsArticlecategoryArgs = {
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
};


/** A universal news article */
export type UniversalNewsArticleimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A universal news article */
export type UniversalNewsArticlescoresArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A universal news article */
export type UniversalNewsArticletagsArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A universal news article */
export type UniversalNewsArticletagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<TagSorting>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A universal news article */
export type UniversalNewsArticletagsCountArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UniversalNewsArticleConnection = {
  edges: Array<UniversalNewsArticleEdge>;
  pageInfo: PageInfo;
};

export type UniversalNewsArticleEdge = {
  cursor: Scalars['String']['output'];
  node: UniversalNewsArticle;
};

/** Universal news article identifier */
export type UniversalNewsArticleSelector = {
  /** The id of the article */
  id: Scalars['Int']['input'];
  /** Whether a local news article should be returned */
  local?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter articles by newsboard */
  newsboard?: InputMaybe<Newsboard>;
};

/** A universal news category */
export type UniversalNewsCategory = {
  /** The category's id */
  id: Scalars['Int']['output'];
  /** The news articles related to this category */
  newsArticles: Array<UniversalNewsArticle>;
  /** The news article connection of the category's article */
  newsArticlesConnection: UniversalNewsArticleConnection;
  /** The count of the category's article */
  newsArticlesCount: Scalars['Int']['output'];
  /** The category's path */
  path?: Maybe<Scalars['String']['output']>;
  /** The category's title */
  title?: Maybe<Scalars['String']['output']>;
};


/** A universal news category */
export type UniversalNewsCategorynewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A universal news category */
export type UniversalNewsCategorynewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A universal news category */
export type UniversalNewsCategorynewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A universal news user */
export type UniversalNewsUser = {
  /** The user's email address */
  email: Scalars['String']['output'];
  /** The user's id */
  id: Scalars['Int']['output'];
  /** The image url of the author */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive image urls of the author */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The user's full name */
  name: Scalars['String']['output'];
  /** The news articles of the author */
  newsArticles: Array<UniversalNewsArticle>;
  /** The news article connection of the author */
  newsArticlesConnection: UniversalNewsArticleConnection;
  /** The count of the author's news articles */
  newsArticlesCount: Scalars['Int']['output'];
};


/** A universal news user */
export type UniversalNewsUserimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};


/** A universal news user */
export type UniversalNewsUsernewsArticlesArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: Scalars['Int']['input'];
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A universal news user */
export type UniversalNewsUsernewsArticlesConnectionArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** A universal news user */
export type UniversalNewsUsernewsArticlesCountArgs = {
  accessLevels?: InputMaybe<Array<AccessLevel>>;
  autoTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxScores?: InputMaybe<Array<ScoreCriteria>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NewsArticleSorting>;
  sortScore?: InputMaybe<Scalars['String']['input']>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  universalCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A FashionUnited dashboard, job board user */
export type User = {
  __typename?: 'User';
  /** The id of the user */
  _id: Scalars['String']['output'];
  /** The user's personal account */
  account?: Maybe<Account>;
  /** The chamber of commerce number of the user's company */
  chamberOfCommerceNumber?: Maybe<Scalars['String']['output']>;
  /** The city of the user */
  city?: Maybe<Scalars['String']['output']>;
  /** The company name of the user */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country of the user */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The creation date of the user
   * @deprecated Use insertedAt instead
   */
  createdAt: Scalars['DateTime']['output'];
  /** The first name of the user */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The user's groups */
  groups: Array<UserScopeGroup>;
  /** Has the user a complete buyer profile? */
  hasCompleteBuyerProfile: Scalars['Boolean']['output'];
  /** The gravatar image url for the user */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The responsive gravatar image urls for the user */
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  /** The creation date of the user */
  insertedAt: Scalars['DateTime']['output'];
  /** The language of the user */
  language?: Maybe<Scalars['String']['output']>;
  /** The last name of the user */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user's markets */
  markets: Array<Market>;
  /** The name of the user */
  name?: Maybe<Scalars['String']['output']>;
  /** Should the user set a password? */
  shouldSetPassword: Scalars['Boolean']['output'];
  /** The user's stands */
  stands: Array<Stand>;
  /** The username of the user */
  username?: Maybe<Scalars['String']['output']>;
  /** Has the user a verified email address? */
  verified: Scalars['Boolean']['output'];
  /** Is the user a verified buyer? */
  verifiedBuyer: Scalars['Boolean']['output'];
  /** The website url of the user */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


/** A FashionUnited dashboard, job board user */
export type UserimageUrlsArgs = {
  configurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: User;
};

/** The groups with scope that the user belongs to */
export type UserScopeGroup = {
  __typename?: 'UserScopeGroup';
  /** The scope */
  id: Scalars['String']['output'];
  /** The profile of the scope */
  profile?: Maybe<Profile>;
  /** The role groups of the group */
  roleGroups: Array<RoleGroup>;
};

export type Variant = {
  __typename?: 'Variant';
  /** The age groups of the variant */
  ageGroups: Array<AgeGroup>;
  /**
   * The color of the variant
   * @deprecated a variant can have multiple colors, use colors
   */
  color?: Maybe<Color>;
  /** The color name of the variant in the feed */
  colorName?: Maybe<Scalars['String']['output']>;
  /** The colors of the variant */
  colors: Array<Color>;
  /** The delivery time in days */
  deliveryDays?: Maybe<Scalars['Int']['output']>;
  /** The delivery time for the variant */
  deliveryTime?: Maybe<Scalars['String']['output']>;
  /** The GTIN/EAN (Global Trade Item Number) of the variant */
  gtin?: Maybe<Scalars['String']['output']>;
  /** The id of the variant */
  id: Scalars['Int']['output'];
  /** The images of the variant */
  images: Array<ProductImage>;
  /** The images of the variant */
  imagesConnection: ProductImageConnection;
  /** The variant's creation date */
  insertedAt: Scalars['DateTime']['output'];
  /** The MPN (Manufacturer Part Number) of the variant */
  mpn?: Maybe<Scalars['String']['output']>;
  /** The order quantity */
  orderQuantity?: Maybe<Scalars['Int']['output']>;
  /** The price amount of the variant */
  priceAmount?: Maybe<Scalars['Decimal']['output']>;
  /** The price currency of the variant */
  priceCurrency?: Maybe<Scalars['String']['output']>;
  /** The product the variant belongs to */
  product: Product;
  /** The shipping cost of the variant */
  shippingCost?: Maybe<Scalars['Decimal']['output']>;
  /** The size of the variant in the feed */
  sizeName?: Maybe<Scalars['String']['output']>;
  /** The available standardized sizes of the variant */
  sizes: Array<Scalars['String']['output']>;
  /** The product id of the variant in the feed */
  sourceProductId: Scalars['String']['output'];
  /** The id of the variant in the feed */
  sourceVariantId: Scalars['String']['output'];
  /** The variant's last modification date */
  updatedAt: Scalars['DateTime']['output'];
  /** The url of the variant */
  url?: Maybe<Scalars['String']['output']>;
};


export type VariantimagesArgs = {
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type VariantimagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VariantConnection = {
  __typename?: 'VariantConnection';
  edges: Array<VariantEdge>;
  pageInfo: PageInfo;
};

export type VariantEdge = {
  __typename?: 'VariantEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Variant;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypefieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeenumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeinputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  SCALAR = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  OBJECT = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  INTERFACE = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  UNION = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  ENUM = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  LIST = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NON_NULL = 'NON_NULL'
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldargsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

export type AddHighlightPeriodMutationVariables = Exact<{
  highlightPeriod: JobHighlightPeriodInput;
  id: Scalars['Int']['input'];
}>;


export type AddHighlightPeriodMutation = { __typename?: 'RootMutationType', addHighlightPeriod: { __typename?: 'Job', id: number } };

export type ApproveJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ApproveJobMutation = { __typename?: 'RootMutationType', approveJob: { __typename?: 'Job', id: number } };

export type CreateAnalyticsEventMutationVariables = Exact<{
  payload?: InputMaybe<Scalars['Json']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: AnalyticsEventType;
  url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type CreateAnalyticsEventMutation = { __typename?: 'RootMutationType', createAnalyticsEvent: { __typename?: 'AnalyticsEvent', id: number } };

export type CreateApplicantMutationVariables = Exact<{
  jobId: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  subscribedToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  cv: Scalars['Upload']['input'];
  coverLetter?: InputMaybe<Scalars['Upload']['input']>;
  extraDocument1?: InputMaybe<Scalars['Upload']['input']>;
  extraDocument2?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type CreateApplicantMutation = { __typename?: 'RootMutationType', createApplicant: boolean };

export type CreateImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateImageMutation = { __typename?: 'RootMutationType', createImage: { __typename?: 'Image', id: number, uploadUrl: string, credits?: string | null, title?: string | null, description?: string | null } };

export type CreateJobMutationVariables = Exact<{
  job: JobInput;
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobMutation = { __typename?: 'RootMutationType', createJob: { __typename?: 'Job', id: number, status: JobStatus } };

export type CreateLogoImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateLogoImageMutation = { __typename?: 'RootMutationType', createImage: { __typename?: 'Image', id: number, uploadUrl: string } };

export type CreateMarketAccessRequestMutationVariables = Exact<{
  marketId: Scalars['Int']['input'];
}>;


export type CreateMarketAccessRequestMutation = { __typename?: 'RootMutationType', createMarketAccessRequest: boolean };

export type CreateOrderMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  orderItems: Array<OrderItemInput>;
  redirectUrl: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentType>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrderMutation = { __typename?: 'RootMutationType', createOrder: { __typename?: 'Order', id: number, checkoutUrl: string, redirectUrl: string } };

export type CreatePersonalAccountMutationVariables = Exact<{
  address: Scalars['String']['input'];
  addressRegion?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
}>;


export type CreatePersonalAccountMutation = { __typename?: 'RootMutationType', createPersonalAccount: { __typename?: 'Account', id: number } };

export type CreateProfileJobMutationVariables = Exact<{
  fullName: Scalars['String']['input'];
  contact?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  type: ProfileType;
}>;


export type CreateProfileJobMutation = { __typename?: 'RootMutationType', createProfile: { __typename?: 'Profile', id: string } };

export type DuplicateJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DuplicateJobMutation = { __typename?: 'RootMutationType', duplicateJob: { __typename?: 'Job', id: number, _id: string } };

export type GenerateTextMutationVariables = Exact<{
  model: Scalars['String']['input'];
  text: Scalars['String']['input'];
  generationConfig?: InputMaybe<Scalars['Json']['input']>;
}>;


export type GenerateTextMutation = { __typename?: 'RootMutationType', generateText: string };

export type GeocodeMutationVariables = Exact<{
  country?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  location: Scalars['String']['input'];
}>;


export type GeocodeMutation = { __typename?: 'RootMutationType', geocode: { __typename?: 'Location', address?: string | null, addressRegion?: string | null, city: string, postalCode?: string | null, geolocation?: { __typename?: 'GeoJsonGeometry', type: string, coordinates: Array<number> } | null } };

export type AddressByVatNumberMutationVariables = Exact<{
  vatNumber: Scalars['String']['input'];
}>;


export type AddressByVatNumberMutation = { __typename?: 'RootMutationType', getAddressByVatNumber: { __typename?: 'AccountAddress', address?: string | null, addressRegion?: string | null, city?: string | null, companyName?: string | null, country?: string | null, postCode?: string | null } };

export type ExchangeRateMutationVariables = Exact<{
  from: Currency;
  to: Currency;
}>;


export type ExchangeRateMutation = { __typename?: 'RootMutationType', getExchangeRate: any };

export type LoginMutationVariables = Exact<{
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'RootMutationType', login: { __typename?: 'Session', accessToken: string } };

export type LoginWithTokenMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  provider: Provider;
}>;


export type LoginWithTokenMutation = { __typename?: 'RootMutationType', loginWithToken?: { __typename?: 'Session', accessToken: string } | null };

export type PublishJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PublishJobMutation = { __typename?: 'RootMutationType', publishJob: { __typename?: 'Job', id: number } };

export type PublishNewsArticleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PublishNewsArticleMutation = { __typename?: 'RootMutationType', publishNewsArticle: { __typename?: 'NewsArticle', id: number } };

export type RefreshAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshAccessTokenMutation = { __typename?: 'RootMutationType', refreshAccessToken: { __typename?: 'Session', accessToken: string } };

export type RegisterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  captchaResponse: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterMutation = { __typename?: 'RootMutationType', register: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, name?: string | null, username?: string | null } };

export type RegisterWithTokenMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  provider: Provider;
  registeredVia: Registrar;
}>;


export type RegisterWithTokenMutation = { __typename?: 'RootMutationType', registerWithToken?: { __typename?: 'User', name?: string | null, username?: string | null } | null };

export type RemoveHighlightPeriodMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  highlightPeriod: JobHighlightPeriodInput;
}>;


export type RemoveHighlightPeriodMutation = { __typename?: 'RootMutationType', removeHighlightPeriod: { __typename?: 'Job', id: number } };

export type RepostJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  preferredCreditTypeId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RepostJobMutation = { __typename?: 'RootMutationType', repostJob: { __typename?: 'Job', id: number } };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { __typename?: 'RootMutationType', resendVerificationEmail: boolean };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'RootMutationType', resetPassword: boolean };

export type RestrictedUpdateJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  job: RestrictedJobInput;
}>;


export type RestrictedUpdateJobMutation = { __typename?: 'RootMutationType', restrictedUpdateJob: { __typename?: 'Job', id: number } };

export type ScheduleJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ScheduleJobMutation = { __typename?: 'RootMutationType', scheduleJob: { __typename?: 'Job', id: number } };

export type SendMessageToApplicantMutationVariables = Exact<{
  applicantId: Scalars['Int']['input'];
  reason?: InputMaybe<ApplicantMessageReason>;
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type SendMessageToApplicantMutation = { __typename?: 'RootMutationType', sendMessageToApplicant: { __typename?: 'ApplicantMessage', id: number } };

export type SendResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'RootMutationType', sendResetPasswordEmail: boolean };

export type SetApplicantStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status: ApplicantStatus;
}>;


export type SetApplicantStatusMutation = { __typename?: 'RootMutationType', setApplicantStatus: boolean };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { __typename?: 'RootMutationType', resetPassword: boolean };

export type SubscribeToNewsletterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  captchaResponse: Scalars['String']['input'];
}>;


export type SubscribeToNewsletterMutation = { __typename?: 'RootMutationType', subscribeToNewsletter: boolean };

export type UnpublishJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UnpublishJobMutation = { __typename?: 'RootMutationType', unpublishJob: { __typename?: 'Job', id: number } };

export type UnpublishNewsArticleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UnpublishNewsArticleMutation = { __typename?: 'RootMutationType', unpublishNewsArticle: { __typename?: 'NewsArticle', id: number } };

export type UpdateCurrentProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCurrentProfileMutation = { __typename?: 'RootMutationType', updateCurrentProfile: { __typename?: 'User', _id: string, name?: string | null, username?: string | null } };

export type UpdateEmployeeProfileMutationVariables = Exact<{
  aboutPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  aboutPageTitle?: InputMaybe<Scalars['String']['input']>;
  showAboutPage?: InputMaybe<Scalars['Boolean']['input']>;
  newsPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  newsPageTitle?: InputMaybe<Scalars['String']['input']>;
  showNewsPage?: InputMaybe<Scalars['Boolean']['input']>;
  workingAtPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  workingAtPageTitle?: InputMaybe<Scalars['String']['input']>;
  showWorkingAtPage?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
}>;


export type UpdateEmployeeProfileMutation = { __typename?: 'RootMutationType', updateProfile: { __typename?: 'Profile', id: string } };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  job: JobInput;
}>;


export type UpdateJobMutation = { __typename?: 'RootMutationType', updateJob: { __typename?: 'Job', id: number } };

export type UpdateNewsArticleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  accessLevel?: InputMaybe<AccessLevel>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dek?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  unpublishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateNewsArticleMutation = { __typename?: 'RootMutationType', updateNewsArticle: { __typename?: 'NewsArticle', id: number } };

export type UpdateProfileMutationVariables = Exact<{
  about?: InputMaybe<Scalars['String']['input']>;
  b2bPartnerPolicy?: InputMaybe<Scalars['String']['input']>;
  collectionImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileImageUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProfileMutation = { __typename?: 'RootMutationType', updateProfile: { __typename?: 'Profile', id: string } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'RootQueryType', countries: Array<{ __typename?: 'Country', euMember: boolean, name: string }> };

export type CourseCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CourseCategoriesQuery = { __typename?: 'RootQueryType', courseCategories: Array<{ __typename?: 'CourseCategory', id: number, title: string }> };

export type CourseQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  firstImageFetchPriority?: InputMaybe<FetchPriority>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type CourseQuery = { __typename?: 'RootQueryType', course?: { __typename?: 'Course', id: number, additionalInformation?: string | null, city?: string | null, slug?: string | null, country?: string | null, companyDescription?: string | null, companyName?: string | null, logoUrls: Array<string | null>, description?: string | null, introduction?: string | null, education?: string | null, hits?: number | null, title: string, category: { __typename?: 'CourseCategory', id: number, title: string } } | null };

export type CoursesCountQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoursesCountQuery = { __typename?: 'RootQueryType', coursesCount: number };

export type CoursesQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type CoursesQuery = { __typename?: 'RootQueryType', coursesConnection: { __typename?: 'CourseConnection', edges: Array<{ __typename?: 'CourseEdge', node: { __typename?: 'Course', city?: string | null, introduction?: string | null, id: number, title: string, companyName?: string | null, country?: string | null, slug?: string | null, logoUrls: Array<string | null> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type AccountsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
}>;


export type AccountsQuery = { __typename?: 'RootQueryType', accounts: Array<{ __typename?: 'Account', id: number, name?: string | null, crmOrganizationNumber?: string | null, vtigerAccountId?: number | null }> };

export type BundlesAccountsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
}>;


export type BundlesAccountsQuery = { __typename?: 'RootQueryType', accounts: Array<{ __typename?: 'Account', id: number, name?: string | null, vatRate?: any | null }> };

export type AddBrandToProfileMutationVariables = Exact<{
  profileId: Scalars['String']['input'];
  brandId: Scalars['Int']['input'];
}>;


export type AddBrandToProfileMutation = { __typename?: 'RootMutationType', addBrandToProfile: boolean };

export type AllJobsApplyButtonClicksCountQueryVariables = Exact<{
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AllJobsApplyButtonClicksCountQuery = { __typename?: 'RootQueryType', allJobsApplyButtonClicksCount: number };

export type AllJobsPageviewsCountQueryVariables = Exact<{
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AllJobsPageviewsCountQuery = { __typename?: 'RootQueryType', allJobsPageviewsCount: number };

export type ApplicantsCountQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobId?: InputMaybe<Scalars['Int']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
}>;


export type ApplicantsCountQuery = { __typename?: 'RootQueryType', applicantsCount: number };

export type ApplicantsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasDocumentsRole: Scalars['Boolean']['input'];
  hasApplicantMessagesRole: Scalars['Boolean']['input'];
  statuses?: InputMaybe<Array<ApplicantStatus>>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ApplicantsQuery = { __typename?: 'RootQueryType', applicants: Array<{ __typename?: 'Applicant', email: string, coverLetterUrl?: string | null, cvUrl?: string | null, extraDocument1Url?: string | null, extraDocument2Url?: string | null, firstName: string, id: number, insertedAt: string, lastName: string, motivation?: string | null, status: ApplicantStatus, applicantMessagesCount?: number, job?: { __typename?: 'Job', id: number, title: string, city: string, publishedAt?: string | null, status: JobStatus, company: { __typename?: 'JobCompany', name: string, displayName: string } } | null }> };

export type ApproveMarketAccessRequestMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ApproveMarketAccessRequestMutation = { __typename?: 'RootMutationType', approveMarketAccessRequest: boolean };

export type ApproveStandAccessRequestMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ApproveStandAccessRequestMutation = { __typename?: 'RootMutationType', approveStandAccessRequest: boolean };

export type ArticleFormQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  statuses: Array<NewsArticleStatus>;
  scheduledNow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArticleFormQuery = { __typename?: 'RootQueryType', newsArticle?: { __typename?: 'NewsArticle', id: number, accessLevel: AccessLevel, comments?: string | null, description?: string | null, dek?: string | null, featured?: boolean | null, keywords?: string | null, markdown?: string | null, newsboards: Array<Newsboard>, title: string, imageUrl?: string | null, labels: Array<string>, htmlModified: boolean, text: string, status: NewsArticleStatus, insertedAt: string, publishScheduledAt?: string | null, unpublishScheduledAt?: string | null, category?: { __typename?: 'NewsCategory', id: number, title: string } | null, creator?: { __typename?: 'NewsUser', id: number, name: string } | null } | null };

export type AuthorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorsQuery = { __typename?: 'RootQueryType', authors: Array<{ __typename?: 'NewsUser', name: string, id: number } | null> };

export type BrandNamesConnectionQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type BrandNamesConnectionQuery = { __typename?: 'RootQueryType', brandsConnection: { __typename?: 'BrandConnection', edges: Array<{ __typename?: 'BrandEdge', node: { __typename?: 'Brand', id: number, name: string } }> } };

export type BundlesQueryVariables = Exact<{
  accountType: AccountType;
}>;


export type BundlesQuery = { __typename?: 'RootQueryType', bundles: Array<{ __typename?: 'Bundle', id: number, name: string, description?: string | null, price: { __typename?: 'PriceWithCurrency', amount: any, currency: string } }> };

export type CategoriesQueryVariables = Exact<{
  filterAllowed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CategoriesQuery = { __typename?: 'RootQueryType', categories: Array<{ __typename?: 'NewsCategory', title: string, path?: string | null, id: number }> };

export type CheckTagsQueryVariables = Exact<{
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type CheckTagsQuery = { __typename?: 'RootQueryType', tags: Array<{ __typename?: 'Tag', slug: string, title: string }> };

export type CreateBrandMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateBrandMutation = { __typename?: 'RootMutationType', createBrand: { __typename?: 'Brand', id: number, name: string } };

export type CreateNewsArticleMutationVariables = Exact<{
  title: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
  markdown?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  dek?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  accessLevel?: InputMaybe<AccessLevel>;
  comments?: InputMaybe<Scalars['String']['input']>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  unpublishScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateNewsArticleMutation = { __typename?: 'RootMutationType', createNewsArticle: { __typename?: 'NewsArticle', id: number, title: string, slug: string, category?: { __typename?: 'NewsCategory', id: number, title: string } | null } };

export type CreateProfileMutationVariables = Exact<{
  about?: InputMaybe<Scalars['String']['input']>;
  aboutPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  aboutPageTitle?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<CompanyAddressInput>>;
  b2bPartnerPolicy?: InputMaybe<Scalars['String']['input']>;
  careerSiteReturnUrl?: InputMaybe<Scalars['String']['input']>;
  collectionImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<Scalars['String']['input']>;
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coursesName?: InputMaybe<Scalars['String']['input']>;
  crmOrganizationNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptions?: InputMaybe<CompanyDescriptionsInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  fullName: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  jobKeywords?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl?: InputMaybe<Scalars['String']['input']>;
  newsPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  newsPageTitle?: InputMaybe<Scalars['String']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  isEbpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  showAboutPage?: InputMaybe<Scalars['Boolean']['input']>;
  showNewsList?: InputMaybe<Scalars['Boolean']['input']>;
  showNewsPage?: InputMaybe<Scalars['Boolean']['input']>;
  showWorkingAtPage?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snapchat?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  type: ProfileType;
  url?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  workingAtPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  workingAtPageTitle?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type CreateProfileMutation = { __typename?: 'RootMutationType', createProfile: { __typename?: 'Profile', id: string } };

export type DeleteMarketAccessRequestMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteMarketAccessRequestMutation = { __typename?: 'RootMutationType', deleteMarketAccessRequest: boolean };

export type DeleteStandAccessRequestMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteStandAccessRequestMutation = { __typename?: 'RootMutationType', deleteStandAccessRequest: boolean };

export type CompanyDescriptionsInputQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyDescriptionsInputQuery = { __typename?: 'RootQueryType', __type?: { __typename?: '__Type', inputFields?: Array<{ __typename?: '__InputValue', name: string }> | null } | null };

export type TemplatesQueryVariables = Exact<{
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TemplatesQuery = { __typename?: 'RootQueryType', templates: Array<{ __typename?: 'Template', id: string, sourceName: string, revision: string, public: boolean }> };

export type JobVersionsConnectionQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobVersionsConnectionQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', id: number, title: string, versionsConnection: { __typename?: 'JobVersionConnection', edges: Array<{ __typename?: 'JobVersionEdge', node: { __typename?: 'JobVersion', address?: string | null, addressRegion?: string | null, applyForm?: boolean | null, applyUrl?: string | null, categories: Array<string>, city: string, country: string, description?: string | null, expiresAt?: string | null, externalId?: string | null, insertedAt: string, jobId?: string | null, locales: Array<string>, numberOfPositions?: number | null, postalCode?: string | null, publications: Array<string>, publishedAt?: string | null, region?: string | null, scheduled?: boolean | null, sender?: string | null, showTitle?: boolean | null, slug: string, teaser: string, title: string, updatedAt: string, version?: number | null, createdById: string, updatedById: string, company: { __typename?: 'JobCompany', contact?: string | null, description?: string | null, email?: string | null, imageUrl?: string | null, logoUrl?: string | null, name: string, displayName: string, phone?: string | null }, highlightPeriods: Array<{ __typename?: 'JobHighlightPeriod', beginsAt: string, endsAt: string, locale: string, type: HighlightPeriodType }>, properties: Array<{ __typename?: 'JobProperty', name: string, value?: string | null, type?: string | null }>, salary?: { __typename?: 'JobSalary', amount?: number | null, currency?: string | null } | null, template: { __typename?: 'Template', id: string }, creator?: { __typename?: 'User', _id: string, username?: string | null } | null, updater?: { __typename?: 'User', _id: string, username?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type JobsApplicantsCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsApplicantsCountQuery = { __typename?: 'RootQueryType', jobsApplicantsCount: number };

export type JobsApplyButtonClicksCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsApplyButtonClicksCountQuery = { __typename?: 'RootQueryType', jobsApplyButtonClicksCount: number };

export type JobsAverageApplicantsCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsAverageApplicantsCountQuery = { __typename?: 'RootQueryType', jobsAverageApplicantsCount: number };

export type JobsAverageApplyButtonClicksCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsAverageApplyButtonClicksCountQuery = { __typename?: 'RootQueryType', jobsAverageApplyButtonClicksCount: number };

export type JobsAveragePageviewsCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsAveragePageviewsCountQuery = { __typename?: 'RootQueryType', jobsAveragePageviewsCount: number };

export type JobsAverageRepostsCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsAverageRepostsCountQuery = { __typename?: 'RootQueryType', jobsAverageRepostsCount: number };

export type JobsConnectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<JobSorting>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  highlightAnytime?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type JobsConnectionQuery = { __typename?: 'RootQueryType', jobsConnection: { __typename?: 'JobConnection', edges: Array<{ __typename?: 'JobEdge', node: { __typename?: 'Job', id: number, _id: string, status: JobStatus, title: string, city: string, address?: string | null, addressRegion?: string | null, buildingName?: string | null, country: string, categories: Array<string>, hasActiveHighlightPeriod: boolean, slug: string, insertedAt: string, publishedAt?: string | null, expiresAt?: string | null, locales: Array<string>, postingType: JobPostingType, company: { __typename?: 'JobCompany', name: string, displayName: string }, geolocation?: { __typename?: 'GeoJsonGeometry', coordinates: Array<number> } | null, highlightPeriods: Array<{ __typename?: 'JobHighlightPeriod', beginsAt: string, endsAt: string, locale: string, type: HighlightPeriodType }>, statistics: { __typename?: 'JobStatistics', applicantCount?: number | null, applyButtonClickCount?: number | null, pageViewCount?: number | null } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type JobsCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsCountQuery = { __typename?: 'RootQueryType', jobsCount: number };

export type JobsPageviewsCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsPageviewsCountQuery = { __typename?: 'RootQueryType', jobsPageviewsCount: number };

export type JobsRepostsCountQueryVariables = Exact<{
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  companyNameSearch?: InputMaybe<Scalars['String']['input']>;
  postingType?: InputMaybe<JobPostingType>;
  status?: InputMaybe<JobStatus>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsRepostsCountQuery = { __typename?: 'RootQueryType', jobsRepostsCount: number };

export type MarketAccessRequestsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketAccessRequestsQuery = { __typename?: 'RootQueryType', marketAccessRequestsConnection: { __typename?: 'MarketAccessRequestConnection', edges: Array<{ __typename?: 'MarketAccessRequestEdge', node: { __typename?: 'MarketAccessRequest', id: number, market: { __typename?: 'Market', id: number, name: string }, user?: { __typename?: 'User', _id: string, chamberOfCommerceNumber?: string | null, city?: string | null, companyName?: string | null, country?: string | null, firstName?: string | null, language?: string | null, lastName?: string | null, name?: string | null, username?: string | null, websiteUrl?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type MonthlyAllJobsApplyButtonClicksCountQueryVariables = Exact<{
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MonthlyAllJobsApplyButtonClicksCountQuery = { __typename?: 'RootQueryType', monthlyAllJobsApplyButtonClicksCount: Array<{ __typename?: 'MonthlyCount', count?: number | null, month?: string | null }> };

export type MonthlyAllJobsPageviewsCountQueryVariables = Exact<{
  minEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
  maxEventInsertedAt?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MonthlyAllJobsPageviewsCountQuery = { __typename?: 'RootQueryType', monthlyAllJobsPageviewsCount: Array<{ __typename?: 'MonthlyCount', count?: number | null, month?: string | null }> };

export type MonthlyApplicantsCountQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobId?: InputMaybe<Scalars['Int']['input']>;
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ApplicantStatus>>;
}>;


export type MonthlyApplicantsCountQuery = { __typename?: 'RootQueryType', monthlyApplicantsCount: Array<{ __typename?: 'MonthlyCount', count?: number | null, month?: string | null }> };

export type MonthlyTransactionsCountQueryVariables = Exact<{
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type MonthlyTransactionsCountQuery = { __typename?: 'RootQueryType', monthlyTransactionsCount: Array<{ __typename?: 'MonthlyCount', count?: number | null, month?: string | null }> };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type OrderQuery = { __typename?: 'RootQueryType', order?: { __typename?: 'Order', id: number, checkoutUrl: string, insertedAt: string, paymentCheckoutUrl?: string | null, paymentId?: string | null, status: OrderStatus, account: { __typename?: 'Account', id: number, name?: string | null }, orderItems: Array<{ __typename?: 'OrderItem', id: number, amount: number, bundle: { __typename?: 'Bundle', id: number, name: string } }> } | null };

export type OrderStatusQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type OrderStatusQuery = { __typename?: 'RootQueryType', order?: { __typename?: 'Order', id: number, status: OrderStatus } | null };

export type PreviewNewsArticleQueryVariables = Exact<{
  title: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
  markdown?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  accessLevel?: InputMaybe<AccessLevel>;
  description: Scalars['String']['input'];
  dek?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  authorImageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type PreviewNewsArticleQuery = { __typename?: 'RootQueryType', previewNewsArticle: { __typename?: 'NewsArticle', id: number, title: string, description?: string | null, dek?: string | null, body: string, imageUrls: Array<string | null>, imageCaption?: string | null, insertedAt: string, updatedAt: string, keywords?: string | null, slug: string, labels: Array<string>, featured?: boolean | null, accessLevel: AccessLevel, pressRelease: boolean, partnerContent: boolean, hasAccess: boolean, creator?: { __typename?: 'NewsUser', email: string, id: number, name: string, imageUrls: Array<string | null> } | null, tags: Array<{ __typename?: 'Tag', title: string, slug: string }>, category?: { __typename?: 'NewsCategory', id: number, title: string, path?: string | null } | null, scores: Array<{ __typename?: 'Score', name: string, value: number }> } };

export type PreviewNewsArticleCardQueryVariables = Exact<{
  title: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
  markdown?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  accessLevel?: InputMaybe<AccessLevel>;
  description: Scalars['String']['input'];
  dek?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type PreviewNewsArticleCardQuery = { __typename?: 'RootQueryType', previewNewsArticle: { __typename?: 'NewsArticle', title: string, imageUrls: Array<string | null>, slug: string, id: number, summary: string, labels: Array<string>, insertedAt: string, featured?: boolean | null, accessLevel: AccessLevel, pressRelease: boolean, partnerContent: boolean, category?: { __typename?: 'NewsCategory', id: number, title: string, path?: string | null } | null } };

export type ProfileQueryVariables = Exact<{
  profileId: Scalars['String']['input'];
}>;


export type ProfileQuery = { __typename?: 'RootQueryType', profile?: { __typename?: 'Profile', id: string, brands: Array<{ __typename?: 'Brand', id: number, name: string }> } | null };

export type ProfileByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProfileByIdQuery = { __typename?: 'RootQueryType', profile?: { __typename?: 'Profile', type: ProfileType, id: string, account?: { __typename?: 'Account', id: number, name?: string | null, crmOrganizationNumber?: string | null, vtigerAccountId?: number | null } | null, page: { __typename?: 'ProfilePage', premium?: boolean | null, isEbpEnabled?: boolean | null, slug: string, imageUrl?: string | null, mobileImageUrl?: string | null, collectionImageUrls: Array<string>, title?: string | null, b2bPartnerPolicy?: string | null, contactDetails?: string | null, about?: string | null, videoUrl?: string | null, industries: Array<string>, metaDescription?: string | null, aboutPageMarkdown?: string | null, aboutPageTitle?: string | null, newsPageMarkdown?: string | null, newsPageTitle?: string | null, workingAtPageMarkdown?: string | null, workingAtPageTitle?: string | null, showAboutPage?: boolean | null, showNewsPage?: boolean | null, showWorkingAtPage?: boolean | null, careerSiteReturnUrl?: string | null, jobKeywords?: string | null }, company: { __typename?: 'ProfileCompany', fullName: string, displayName?: string | null, coursesName?: string | null, url?: string | null, description?: string | null, crmOrganizationNumber?: string | null, country?: string | null, contact?: string | null, phone?: string | null, email?: string | null, logoUrl?: string | null, newsTags: Array<string>, tags: Array<string>, emailDomains: Array<string>, descriptions?: { __typename?: 'CompanyDescriptions', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null }, addresses: Array<{ __typename?: 'CompanyAddress', country?: string | null, locality?: string | null, postbox?: string | null, region?: string | null, street?: string | null, zipcode?: string | null }>, facebook: Array<{ __typename?: 'CompanySocialNetworkPage', fullName?: string | null, pageId?: string | null, url?: string | null }>, twitter: Array<{ __typename?: 'CompanySocialNetworkPage', fullName?: string | null, pageId?: string | null, url?: string | null }>, instagram: Array<{ __typename?: 'CompanySocialNetworkUser', fullName?: string | null, url?: string | null, userId?: string | null }>, pinterest: Array<{ __typename?: 'CompanySocialNetworkPage', fullName?: string | null, pageId?: string | null, url?: string | null }>, snapchat: Array<{ __typename?: 'CompanySocialNetworkUser', fullName?: string | null, url?: string | null, userId?: string | null }> } | null };

export type ProfileNameSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfileNameSearchQuery = { __typename?: 'RootQueryType', profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', fullName: string } }> };

export type ProfileNamesByIdQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type ProfileNamesByIdQuery = { __typename?: 'RootQueryType', profiles: Array<{ __typename?: 'Profile', type: ProfileType, id: string, company: { __typename?: 'ProfileCompany', fullName: string } }> };

export type ProfilesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  canUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfilesQuery = { __typename?: 'RootQueryType', profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', fullName: string, displayName?: string | null, contact?: string | null, phone?: string | null, email?: string | null, logoUrl?: string | null }, account?: { __typename?: 'Account', id: number, name?: string | null, crmOrganizationNumber?: string | null, vtigerAccountId?: number | null } | null }> };

export type ProfilesNamesConnectionQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfilesNamesConnectionQuery = { __typename?: 'RootQueryType', profilesConnection: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', fullName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ProfilesCountQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfilesCountQuery = { __typename?: 'RootQueryType', profilesCount: number };

export type ProfileNamesQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProfileSorting>;
}>;


export type ProfileNamesQuery = { __typename?: 'RootQueryType', profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', fullName: string } }> };

export type RemoveBrandFromProfileMutationVariables = Exact<{
  profileId: Scalars['String']['input'];
  brandId: Scalars['Int']['input'];
}>;


export type RemoveBrandFromProfileMutation = { __typename?: 'RootMutationType', removeBrandFromProfile: boolean };

export type RemoveProfileMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveProfileMutation = { __typename?: 'RootMutationType', removeProfile: boolean };

export type RepostJobCreditTypesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RepostJobCreditTypesQuery = { __typename?: 'RootQueryType', repostJobCreditTypes: Array<{ __typename?: 'CreditType', id: number, name: string }> };

export type StandAccessRequestsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type StandAccessRequestsQuery = { __typename?: 'RootQueryType', standAccessRequestsConnection: { __typename?: 'StandAccessRequestConnection', edges: Array<{ __typename?: 'StandAccessRequestEdge', node: { __typename?: 'StandAccessRequest', id: number, stand: { __typename?: 'Stand', id: number, name: string, market: { __typename?: 'Market', id: number, name: string } }, user?: { __typename?: 'User', _id: string, chamberOfCommerceNumber?: string | null, city?: string | null, companyName?: string | null, country?: string | null, firstName?: string | null, language?: string | null, lastName?: string | null, name?: string | null, username?: string | null, websiteUrl?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SuggestedTagsQueryVariables = Exact<{
  title: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
  markdown?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  dek?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuggestedTagsQuery = { __typename?: 'RootQueryType', previewNewsArticle: { __typename?: 'NewsArticle', id: number, suggestedTags: Array<{ __typename?: 'Tag', slug: string, title: string, newsArticlesCount: number }> } };

export type TagSearchQueryVariables = Exact<{
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type TagSearchQuery = { __typename?: 'RootQueryType', tags: Array<{ __typename?: 'Tag', slug: string, title: string, newsArticlesCount: number }> };

export type TagsArticlesCountsQueryVariables = Exact<{
  titles: Array<Scalars['String']['input']>;
  newsboards?: InputMaybe<Array<Newsboard>>;
}>;


export type TagsArticlesCountsQuery = { __typename?: 'RootQueryType', tags: Array<{ __typename?: 'Tag', title: string, newsArticlesCount: number }> };

export type TopTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopTagsQuery = { __typename?: 'RootQueryType', tags: Array<{ __typename?: 'Tag', slug: string, title: string }> };

export type TransactionsCountQueryVariables = Exact<{
  minInsertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type TransactionsCountQuery = { __typename?: 'RootQueryType', transactionsCount: number };

export type UpdateProfileDashboardMutationVariables = Exact<{
  about?: InputMaybe<Scalars['String']['input']>;
  aboutPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  aboutPageTitle?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<CompanyAddressInput>>;
  b2bPartnerPolicy?: InputMaybe<Scalars['String']['input']>;
  careerSiteReturnUrl?: InputMaybe<Scalars['String']['input']>;
  collectionImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<Scalars['String']['input']>;
  contactDetails?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coursesName?: InputMaybe<Scalars['String']['input']>;
  crmOrganizationNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptions?: InputMaybe<CompanyDescriptionsInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  jobKeywords?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl?: InputMaybe<Scalars['String']['input']>;
  newsPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  newsPageTitle?: InputMaybe<Scalars['String']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  isEbpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  showAboutPage?: InputMaybe<Scalars['Boolean']['input']>;
  showNewsPage?: InputMaybe<Scalars['Boolean']['input']>;
  showWorkingAtPage?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snapchat?: InputMaybe<Array<CompanySocialNetworkUserInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Array<CompanySocialNetworkPageInput>>;
  type?: InputMaybe<ProfileType>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  workingAtPageMarkdown?: InputMaybe<Scalars['String']['input']>;
  workingAtPageTitle?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type UpdateProfileDashboardMutation = { __typename?: 'RootMutationType', updateProfile: { __typename?: 'Profile', id: string } };

export type UploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadMutation = { __typename?: 'RootMutationType', createImage: { __typename?: 'Image', id: number, uploadUrl: string, credits?: string | null } };

export type ApplyForJobQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locales: Array<Scalars['String']['input']>;
}>;


export type ApplyForJobQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', _id: string, id: number, slug: string, title: string, city: string, country: string, expiresAt?: string | null, addressRegion?: string | null, postalCode?: string | null, publishedAt?: string | null, categories: Array<string>, active?: boolean | null, company: { __typename?: 'JobCompany', name: string, displayName: string } } | null };

export type CitiesQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CitiesQuery = { __typename?: 'RootQueryType', citiesConnection: { __typename?: 'CityConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'CityEdge', node: { __typename?: 'City', id: string, jobsCount: number, name: string, slug: string } }> } };

export type FilterCitiesQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CitySorting>;
  jobsFilter: JobsFilter;
  category?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterCitiesQuery = { __typename?: 'RootQueryType', cities: Array<{ __typename?: 'City', id: string, name: string, slug: string, jobsCount: number }> };

export type CityBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locales: Array<Scalars['String']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type CityBySlugQuery = { __typename?: 'RootQueryType', cityBySlug?: { __typename?: 'City', id: string, name: string, imageUrls: Array<string | null> } | null };

export type CompanyProfilesConnectionQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type CompanyProfilesConnectionQuery = { __typename?: 'RootQueryType', profilesConnection: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', description?: string | null, country?: string | null, logoUrl?: string | null, logoUrls: Array<string | null>, fullName: string, descriptions?: { __typename?: 'CompanyDescriptions', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frCh?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itCh?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null }, page: { __typename?: 'ProfilePage', imageUrl?: string | null, imageUrls: Array<string | null>, mobileImageUrls: Array<string | null>, premium?: boolean | null, slug: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type IncreaseApplyButtonClicksMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type IncreaseApplyButtonClicksMutation = { __typename?: 'RootMutationType', increaseApplyButtonClicks: boolean };

export type IncreaseJobPageViewsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type IncreaseJobPageViewsMutation = { __typename?: 'RootMutationType', increaseJobPageViews: boolean };

export type JobActiveQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locales: Array<Scalars['String']['input']>;
}>;


export type JobActiveQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', id: number, active?: boolean | null, slug: string } | null };

export type JobExistsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobExistsQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', id: number } | null };

export type JobAdminFormQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type JobAdminFormQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', id: number, active?: boolean | null, scheduled?: boolean | null, approved?: boolean | null, applyForm?: boolean | null, applyUrl?: string | null, disableEmails?: boolean | null, showTitle?: boolean | null, title: string, address?: string | null, buildingName?: string | null, city: string, addressRegion?: string | null, postalCode?: string | null, country: string, createdByEmail?: string | null, categories: Array<string>, categoriesGuessed?: boolean | null, teaser: string, locales: Array<string>, publications: Array<string>, publishedAt?: string | null, expiresAt?: string | null, postingType: JobPostingType, account?: { __typename?: 'Account', id: number, name?: string | null, crmOrganizationNumber?: string | null, vtigerAccountId?: number | null } | null, profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', fullName: string } }>, company: { __typename?: 'JobCompany', contact?: string | null, email?: string | null, imageUrl?: string | null, logoUrl?: string | null, name: string, displayName: string, phone?: string | null }, template: { __typename?: 'Template', id: string }, properties: Array<{ __typename?: 'JobProperty', name: string, type?: string | null, value?: string | null }>, geolocation?: { __typename?: 'GeoJsonGeometry', coordinates: Array<number> } | null } | null };

export type JobFormQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type JobFormQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', address?: string | null, buildingName?: string | null, addressRegion?: string | null, applyForm?: boolean | null, applyUrl?: string | null, categories: Array<string>, city: string, country: string, id: number, locales: Array<string>, postalCode?: string | null, teaser: string, title: string, hasBeenPublished: boolean, company: { __typename?: 'JobCompany', contact?: string | null, email?: string | null, logoUrl?: string | null, name: string, displayName: string, phone?: string | null }, geolocation?: { __typename?: 'GeoJsonGeometry', coordinates: Array<number> } | null, properties: Array<{ __typename?: 'JobProperty', name: string, type?: string | null, value?: string | null }>, template: { __typename?: 'Template', id: string } } | null };

export type JobQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locales: Array<Scalars['String']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type JobQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', _id: string, active?: boolean | null, address?: string | null, addressRegion?: string | null, applyForm?: boolean | null, applyUrl?: string | null, buildingName?: string | null, categories: Array<string>, city: string, cityIds: Array<string>, country: string, expiresAt?: string | null, id: number, insertedAt: string, locales: Array<string>, postalCode?: string | null, profileIds: Array<string>, publishedAt?: string | null, publications: Array<string>, region?: string | null, slug: string, teaser: string, title: string, updatedAt: string, cities: Array<{ __typename?: 'City', id: string, name: string, slug: string }>, company: { __typename?: 'JobCompany', contact?: string | null, email?: string | null, imageUrls: Array<string | null>, logoUrls: Array<string | null>, name: string, displayName: string, phone?: string | null }, highlightPeriods: Array<{ __typename?: 'JobHighlightPeriod', beginsAt: string, endsAt: string, locale: string }>, profiles: Array<{ __typename?: 'Profile', id: string, hasTabs: boolean, company: { __typename?: 'ProfileCompany', fullName: string, newsTags: Array<string> }, page: { __typename?: 'ProfilePage', slug: string, title?: string | null, imageUrls: Array<string | null>, mobileImageUrls: Array<string | null>, premium?: boolean | null } }>, mergedProperties: Array<{ __typename?: 'JobProperty', imageUrls: Array<string | null>, name: string, type?: string | null, value?: string | null }>, salary?: { __typename?: 'JobSalary', amount?: number | null, currency?: string | null } | null, template: { __typename?: 'Template', id: string, sourceName: string, revision: string } } | null };

export type JobSlugQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locales: Array<Scalars['String']['input']>;
}>;


export type JobSlugQuery = { __typename?: 'RootQueryType', job?: { __typename?: 'Job', id: number, slug: string } | null };

export type JobsListConnectionQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  profileIdsOrKeywords?: InputMaybe<ProfileIdsOrKeywords>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  locationSearch?: InputMaybe<Scalars['String']['input']>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
  sort?: InputMaybe<JobSorting>;
  distanceFrom?: InputMaybe<GeoJsonGeometryInput>;
}>;


export type JobsListConnectionQuery = { __typename?: 'RootQueryType', jobsConnection: { __typename?: 'JobConnection', edges: Array<{ __typename?: 'JobEdge', node: { __typename?: 'Job', id: number, _id: string, slug: string, title: string, teaser: string, city: string, address?: string | null, addressRegion?: string | null, buildingName?: string | null, postalCode?: string | null, distance?: number | null, defaultLocale?: string | null, locales: Array<string>, publishedAt?: string | null, company: { __typename?: 'JobCompany', name: string, displayName: string, logoUrls: Array<string | null> }, profiles: Array<{ __typename?: 'Profile', id: string, hasTabs: boolean, page: { __typename?: 'ProfilePage', slug: string, premium?: boolean | null }, company: { __typename?: 'ProfileCompany', fullName: string } }>, cities: Array<{ __typename?: 'City', id: string, name: string, slug: string }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type JobsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  locales: Array<Scalars['String']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
  imageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type JobsQuery = { __typename?: 'RootQueryType', jobs: Array<{ __typename?: 'Job', id: number, title: string, city: string, urls?: { __typename?: 'JobUrls', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frCh?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itCh?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null, company: { __typename?: 'JobCompany', name: string, displayName: string, logoUrls: Array<string | null>, description?: string | null, imageUrls: Array<string | null> } }> };

export type LatestJobsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  locales: Array<Scalars['String']['input']>;
  highlightLocale?: InputMaybe<Scalars['String']['input']>;
  highlightType?: InputMaybe<HighlightPeriodType>;
}>;


export type LatestJobsQuery = { __typename?: 'RootQueryType', jobs: Array<{ __typename?: 'Job', id: number, city: string, title: string, company: { __typename?: 'JobCompany', name: string, displayName: string }, urls?: { __typename?: 'JobUrls', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frCh?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itCh?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null }> };

export type PositionBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locales: Array<Scalars['String']['input']>;
}>;


export type PositionBySlugQuery = { __typename?: 'RootQueryType', positionBySlug?: { __typename?: 'Position', id: string, name?: string | null, names?: { __typename?: 'PositionNames', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frCh?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itCh?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null } | null };

export type PositionsQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PositionsQuery = { __typename?: 'RootQueryType', positionsConnection: { __typename?: 'PositionConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PositionEdge', node: { __typename?: 'Position', id: string, jobsCount: number, name?: string | null, slug: string, names?: { __typename?: 'PositionNames', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frCh?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itCh?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null } }> } };

export type PreviewJobQueryVariables = Exact<{
  job: JobInput;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type PreviewJobQuery = { __typename?: 'RootQueryType', previewJob?: { __typename?: 'Job', _id: string, active?: boolean | null, address?: string | null, addressRegion?: string | null, applyForm?: boolean | null, applyUrl?: string | null, buildingName?: string | null, categories: Array<string>, city: string, cityIds: Array<string>, country: string, expiresAt?: string | null, id: number, insertedAt: string, locales: Array<string>, postalCode?: string | null, profileIds: Array<string>, publishedAt?: string | null, publications: Array<string>, region?: string | null, slug: string, teaser: string, title: string, updatedAt: string, cities: Array<{ __typename?: 'City', id: string, name: string, slug: string }>, company: { __typename?: 'JobCompany', contact?: string | null, email?: string | null, imageUrls: Array<string | null>, logoUrls: Array<string | null>, name: string, displayName: string, phone?: string | null }, highlightPeriods: Array<{ __typename?: 'JobHighlightPeriod', beginsAt: string, endsAt: string, locale: string }>, profiles: Array<{ __typename?: 'Profile', id: string, hasTabs: boolean, company: { __typename?: 'ProfileCompany', fullName: string }, page: { __typename?: 'ProfilePage', slug: string, title?: string | null, imageUrls: Array<string | null>, mobileImageUrls: Array<string | null>, premium?: boolean | null } }>, mergedProperties: Array<{ __typename?: 'JobProperty', imageUrls: Array<string | null>, name: string, type?: string | null, value?: string | null }>, salary?: { __typename?: 'JobSalary', amount?: number | null, currency?: string | null } | null, template: { __typename?: 'Template', id: string, sourceName: string, revision: string } } | null };

export type ProfileBySlugEmployerQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProfileBySlugEmployerQuery = { __typename?: 'RootQueryType', profileBySlug?: { __typename?: 'Profile', id: string, canUpdate?: boolean | null, page: { __typename?: 'ProfilePage', aboutPageMarkdown?: string | null, aboutPageTitle?: string | null, newsPageMarkdown?: string | null, newsPageTitle?: string | null, showAboutPage?: boolean | null, showNewsPage?: boolean | null, showWorkingAtPage?: boolean | null, slug: string, title?: string | null, workingAtPageMarkdown?: string | null, workingAtPageTitle?: string | null }, company: { __typename?: 'ProfileCompany', newsTags: Array<string> } } | null };

export type RelatedJobsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  locales: Array<Scalars['String']['input']>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type RelatedJobsQuery = { __typename?: 'RootQueryType', jobs: Array<{ __typename?: 'Job', _id: string, id: number, slug: string, title: string, teaser: string, city: string, address?: string | null, addressRegion?: string | null, buildingName?: string | null, postalCode?: string | null, publishedAt?: string | null, company: { __typename?: 'JobCompany', name: string, displayName: string, logoUrls: Array<string | null> }, profiles: Array<{ __typename?: 'Profile', id: string, page: { __typename?: 'ProfilePage', slug: string }, company: { __typename?: 'ProfileCompany', fullName: string } }>, cities: Array<{ __typename?: 'City', id: string, name: string, slug: string }> }> };

export type RelatedProfilesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<ProfileSorting>;
}>;


export type RelatedProfilesQuery = { __typename?: 'RootQueryType', profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', description?: string | null, fullName: string, logoUrls: Array<string | null> }, page: { __typename?: 'ProfilePage', slug: string, imageUrls: Array<string | null>, mobileImageUrls: Array<string | null> } }> };

export type WFBProfilesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  locales: Array<Scalars['String']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
  sort?: InputMaybe<ProfileSorting>;
}>;


export type WFBProfilesQuery = { __typename?: 'RootQueryType', profiles: Array<{ __typename?: 'Profile', id: string, page: { __typename?: 'ProfilePage', imageUrls: Array<string | null>, mobileImageUrls: Array<string | null>, slug: string }, company: { __typename?: 'ProfileCompany', fullName: string, logoUrls: Array<string | null> } }> };

export type LookbookCreateImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  credits?: InputMaybe<Scalars['String']['input']>;
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LookbookCreateImageMutation = { __typename?: 'RootMutationType', createImage: { __typename?: 'Image', id: number } };

export type ImageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type ImageQuery = { __typename?: 'RootQueryType', image?: { __typename?: 'Image', id: number, title?: string | null, imageUrls: Array<string | null>, description?: string | null, insertedAt: string, slug?: string | null, credits?: string | null, uploadUrl: string, freeForCommercialUse?: boolean | null, freeForEditorialUse?: boolean | null, internalUseOnly?: boolean | null, noAttributionRequired?: boolean | null, creator?: { __typename?: 'User', name?: string | null, username?: string | null } | null, category?: { __typename?: 'ImageCategory', id: number, title: string, slug: string } | null } | null };

export type ImageCategoriesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImageCategoriesQuery = { __typename?: 'RootQueryType', imageCategories: { __typename?: 'ImageCategoryConnection', edges: Array<{ __typename?: 'ImageCategoryEdge', node: { __typename?: 'ImageCategory', id: number, title: string, slug: string } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type ImageCategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ImageCategoryQuery = { __typename?: 'RootQueryType', imageCategory?: { __typename?: 'ImageCategory', id: number, title: string, slug: string } | null };

export type ImagesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type ImagesQuery = { __typename?: 'RootQueryType', images: { __typename?: 'ImageConnection', edges: Array<{ __typename?: 'ImageEdge', node: { __typename?: 'Image', id: number, title?: string | null, imageUrls: Array<string | null>, description?: string | null, insertedAt: string, slug?: string | null, credits?: string | null, uploadUrl: string, creator?: { __typename?: 'User', name?: string | null, username?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type RemoveImageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  removeFile?: InputMaybe<Scalars['Boolean']['input']>;
  purgeResponsiveImageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type RemoveImageMutation = { __typename?: 'RootMutationType', removeImage: boolean };

export type UpdateImageMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freeForCommercialUse?: InputMaybe<Scalars['Boolean']['input']>;
  freeForEditorialUse?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  internalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noAttributionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateImageMutation = { __typename?: 'RootMutationType', updateImage: { __typename?: 'Image', id: number } };

export type ArticleQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  authorImageConfigurations: Array<ResponsiveImageConfiguration>;
  newsboard: Newsboard;
}>;


export type ArticleQuery = { __typename?: 'RootQueryType', universalNewsArticle?: { __typename?: 'LocalNewsArticle', id: number, title: string, description?: string | null, dek?: string | null, body: string, imageUrls: Array<string | null>, imageCaption?: string | null, autoTranslated: boolean, insertedAt: string, updatedAt: string, keywords?: string | null, slug: string, labels: Array<string>, featured?: boolean | null, pressRelease: boolean, partnerContent: boolean, accessLevel: AccessLevel, hasAccess: boolean, creator?: { __typename?: 'LocalNewsUser', email: string, id: number, name: string, imageUrls: Array<string | null> } | null, tags: Array<{ __typename?: 'Tag', title: string, slug: string }>, category?: { __typename?: 'LocalNewsCategory', id: number, title: string, path?: string | null } | null, scores: Array<{ __typename?: 'Score', name: string, value: number }> } | { __typename?: 'NewsArticle', id: number, title: string, description?: string | null, dek?: string | null, body: string, imageUrls: Array<string | null>, imageCaption?: string | null, autoTranslated: boolean, insertedAt: string, updatedAt: string, keywords?: string | null, slug: string, labels: Array<string>, featured?: boolean | null, pressRelease: boolean, partnerContent: boolean, accessLevel: AccessLevel, hasAccess: boolean, creator?: { __typename?: 'NewsUser', email: string, id: number, name: string, imageUrls: Array<string | null> } | null, tags: Array<{ __typename?: 'Tag', title: string, slug: string }>, category?: { __typename?: 'NewsCategory', id: number, title: string, path?: string | null } | null, scores: Array<{ __typename?: 'Score', name: string, value: number }> } | null };

export type ArticlesConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPathPrefix?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  popularInDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minScores?: InputMaybe<Array<ScoreCriteria>>;
  newsboard: Newsboard;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearch?: InputMaybe<Scalars['String']['input']>;
  embeddingsSearchModel?: InputMaybe<EmbeddingsSearchModel>;
  sort?: InputMaybe<NewsArticleSorting>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  specialPageIdentifiers?: InputMaybe<Array<SpecialPageIdentifier>>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  pageviews: Scalars['Boolean']['input'];
}>;


export type ArticlesConnectionQuery = { __typename?: 'RootQueryType', universalNewsArticlesConnection: { __typename?: 'LocalNewsArticleConnection', edges: Array<{ __typename?: 'LocalNewsArticleEdge', node: { __typename?: 'LocalNewsArticle', path?: string | null, pageviews?: number | null, id: number, title: string, description?: string | null, summary: string, imageUrls: Array<string | null>, insertedAt: string, slug: string, pressRelease: boolean, partnerContent: boolean, labels: Array<string>, featured?: boolean | null, accessLevel: AccessLevel, creator?: { __typename?: 'LocalNewsUser', id: number, name: string } | null, category?: { __typename?: 'LocalNewsCategory', id: number, title: string, path?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | { __typename?: 'NewsArticleConnection', edges: Array<{ __typename?: 'NewsArticleEdge', node: { __typename?: 'NewsArticle', pageviews?: number | null, id: number, title: string, description?: string | null, summary: string, imageUrls: Array<string | null>, insertedAt: string, slug: string, pressRelease: boolean, partnerContent: boolean, labels: Array<string>, featured?: boolean | null, accessLevel: AccessLevel, creator?: { __typename?: 'NewsUser', id: number, name: string } | null, category?: { __typename?: 'NewsCategory', id: number, title: string, path?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ArticlesQueryVariables = Exact<{
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  notInIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sort?: InputMaybe<NewsArticleSorting>;
  inDays?: InputMaybe<Scalars['Int']['input']>;
  inIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  inCreatedByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  pressRelease?: InputMaybe<Scalars['Boolean']['input']>;
  partnerContent?: InputMaybe<Scalars['Boolean']['input']>;
  withoutSummaryAndLabel: Scalars['Boolean']['input'];
  withoutDescriptionAndCreator: Scalars['Boolean']['input'];
  newsboard: Newsboard;
  relatedToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type ArticlesQuery = { __typename?: 'RootQueryType', universalNewsArticles: Array<{ __typename?: 'LocalNewsArticle', id: number, summary?: string, description?: string | null, labels?: Array<string>, title: string, imageUrls: Array<string | null>, slug: string, insertedAt: string, featured?: boolean | null, accessLevel: AccessLevel, pressRelease: boolean, partnerContent: boolean, creator?: { __typename?: 'LocalNewsUser', id: number, name: string } | null, category?: { __typename?: 'LocalNewsCategory', id: number, title: string, path?: string | null } | null } | { __typename?: 'NewsArticle', id: number, summary?: string, description?: string | null, labels?: Array<string>, title: string, imageUrls: Array<string | null>, slug: string, insertedAt: string, featured?: boolean | null, accessLevel: AccessLevel, pressRelease: boolean, partnerContent: boolean, creator?: { __typename?: 'NewsUser', id: number, name: string } | null, category?: { __typename?: 'NewsCategory', id: number, title: string, path?: string | null } | null }> };

export type AuthorByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  authorImageConfigurations: Array<ResponsiveImageConfiguration>;
  newsboard: Newsboard;
}>;


export type AuthorByEmailQuery = { __typename?: 'RootQueryType', universalAuthorByEmail?: { __typename?: 'LocalNewsUser', bioHtml?: string | null, id: number, name: string, imageUrls: Array<string | null>, newsArticlesConnection: { __typename?: 'LocalNewsArticleConnection', edges: Array<{ __typename?: 'LocalNewsArticleEdge', node: { __typename?: 'LocalNewsArticle', id: number, slug: string, accessLevel: AccessLevel, pressRelease: boolean, partnerContent: boolean, labels: Array<string>, featured?: boolean | null, description?: string | null, summary: string, insertedAt: string, title: string, imageUrls: Array<string | null>, category?: { __typename?: 'LocalNewsCategory', id: number, title: string, path?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } } | { __typename?: 'NewsUser', bioHtml?: string | null, id: number, name: string, imageUrls: Array<string | null>, newsArticlesConnection: { __typename?: 'NewsArticleConnection', edges: Array<{ __typename?: 'NewsArticleEdge', node: { __typename?: 'NewsArticle', id: number, slug: string, accessLevel: AccessLevel, pressRelease: boolean, partnerContent: boolean, labels: Array<string>, featured?: boolean | null, description?: string | null, summary: string, insertedAt: string, title: string, imageUrls: Array<string | null>, category?: { __typename?: 'NewsCategory', id: number, title: string, path?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } } | null };

export type CategoryHeaderArticlesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  newsboard: Newsboard;
}>;


export type CategoryHeaderArticlesQuery = { __typename?: 'RootQueryType', universalCategory?: { __typename?: 'LocalNewsCategory', id: number, title: string, path?: string | null } | { __typename?: 'NewsCategory', id: number, title: string, path?: string | null } | null };

export type CategoryArticlesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  imageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
  newsboard: Newsboard;
}>;


export type CategoryArticlesQuery = { __typename?: 'RootQueryType', universalCategory?: { __typename?: 'LocalNewsCategory', id: number, path?: string | null, title: string, newsArticles: Array<{ __typename?: 'LocalNewsArticle', id: number, title: string, description?: string | null, summary: string, slug: string, imageUrls: Array<string | null>, labels: Array<string>, accessLevel: AccessLevel, insertedAt: string, creator?: { __typename?: 'LocalNewsUser', id: number, name: string } | null, category?: { __typename?: 'LocalNewsCategory', id: number, path?: string | null, title: string } | null }> } | { __typename?: 'NewsCategory', id: number, path?: string | null, title: string, newsArticles: Array<{ __typename?: 'NewsArticle', id: number, title: string, description?: string | null, summary: string, slug: string, imageUrls: Array<string | null>, labels: Array<string>, accessLevel: AccessLevel, insertedAt: string, creator?: { __typename?: 'NewsUser', id: number, name: string } | null, category?: { __typename?: 'NewsCategory', id: number, path?: string | null, title: string } | null }> } | null };

export type IncreaseHitsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  newsboard: Newsboard;
}>;


export type IncreaseHitsMutation = { __typename?: 'RootMutationType', increaseUniversalNewsArticleHits: boolean };

export type RelatedProfilesCountQueryVariables = Exact<{
  newsTags?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RelatedProfilesCountQuery = { __typename?: 'RootQueryType', profilesCount: number };

export type SpecialPageBySlugQueryVariables = Exact<{
  newsboard: Newsboard;
  slug: Scalars['String']['input'];
  mobileImageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
  desktopImageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type SpecialPageBySlugQuery = { __typename?: 'RootQueryType', specialPageBySlug?: { __typename?: 'SpecialPage', id: number, slug: string, newsboard: Newsboard, title: string, header?: string | null, description?: string | null, imageUrl?: string | null, imageUrls: Array<string | null>, mobileImageUrl?: string | null, mobileImageUrls: Array<string | null>, links: Array<{ __typename?: 'SpecialPageLink', title?: string | null, href?: string | null, route?: string | null, parameters?: any | null }>, tags: Array<{ __typename?: 'Tag', slug: string, title: string }> } | null };

export type SpecialPageNewsArticlesQueryVariables = Exact<{
  newsboard: Newsboard;
  slug: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  imageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type SpecialPageNewsArticlesQuery = { __typename?: 'RootQueryType', specialPageBySlug?: { __typename?: 'SpecialPage', id: number, slug: string, title: string, universalNewsArticles: Array<{ __typename?: 'LocalNewsArticle', id: number, title: string, description?: string | null, summary: string, slug: string, imageUrls: Array<string | null>, labels: Array<string>, insertedAt: string, creator?: { __typename?: 'LocalNewsUser', id: number, name: string } | null, category?: { __typename?: 'LocalNewsCategory', id: number, path?: string | null, title: string } | null } | { __typename?: 'NewsArticle', id: number, title: string, description?: string | null, summary: string, slug: string, imageUrls: Array<string | null>, labels: Array<string>, insertedAt: string, creator?: { __typename?: 'NewsUser', id: number, name: string } | null, category?: { __typename?: 'NewsCategory', id: number, path?: string | null, title: string } | null }> } | null };

export type NowQueryVariables = Exact<{ [key: string]: never; }>;


export type NowQuery = { __typename?: 'RootQueryType', now?: string | null };

export type BrandsConnectionQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  imageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type BrandsConnectionQuery = { __typename?: 'RootQueryType', brandsConnection: { __typename?: 'BrandConnection', edges: Array<{ __typename?: 'BrandEdge', node: { __typename?: 'Brand', id: number, name: string, profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', country?: string | null, logoUrls: Array<string | null> }, page: { __typename?: 'ProfilePage', premium?: boolean | null, slug: string, industries: Array<string> } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ProfileProductsQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  mainCategories: Array<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileProductsQuery = { __typename?: 'RootQueryType', hiddenProductsExist: boolean, products: Array<{ __typename?: 'Product', id: number }> };

export type ProductBrandsFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandIdsScope?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductBrandsFilterQuery = { __typename?: 'RootQueryType', productBrands: Array<{ __typename?: 'Brand', id: number, name: string }>, brands: Array<{ __typename?: 'Brand', id: number, name: string }> };

export type FilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterQuery = { __typename?: 'RootQueryType', productMainCategories: Array<string> };

export type ProductColorsFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductColorsFilterQuery = { __typename?: 'RootQueryType', productColors: Array<{ __typename?: 'Color', id: number, name: string }> };

export type ProductDepartmentFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductDepartmentFilterQuery = { __typename?: 'RootQueryType', productGenders: Array<Gender>, productAgeGroups: Array<AgeGroup> };

export type ProductMaterialsFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductMaterialsFilterQuery = { __typename?: 'RootQueryType', productMaterials: Array<{ __typename?: 'Material', id: number, name: string }> };

export type ProductModelImagesFilterQueryVariables = Exact<{
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  allGenders?: InputMaybe<Array<Gender>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales: Array<Scalars['String']['input']>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maybeBrandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maybeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  priceAmountAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAmountAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductModelImagesFilterQuery = { __typename?: 'RootQueryType', productModelImages: Array<boolean> };

export type ProductPricesFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductPricesFilterQuery = { __typename?: 'RootQueryType', productMaximumPriceRange?: number | null };

export type ProductPrintsFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductPrintsFilterQuery = { __typename?: 'RootQueryType', productPrints: Array<{ __typename?: 'Print', id: number, name: string }> };

export type ProductSeasonsFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductSeasonsFilterQuery = { __typename?: 'RootQueryType', productSeasons: Array<string> };

export type ProductSizesFilterQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductSizesFilterQuery = { __typename?: 'RootQueryType', productSizes: Array<string> };

export type HasMarketAccessQueryVariables = Exact<{
  marketId: Scalars['Int']['input'];
}>;


export type HasMarketAccessQuery = { __typename?: 'RootQueryType', hasMarketAccessRequest: boolean };

export type HiddenProductsExistQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type HiddenProductsExistQuery = { __typename?: 'RootQueryType', hiddenProductsExist: boolean };

export type MarketBrandsConnectionQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  brandSearch?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type MarketBrandsConnectionQuery = { __typename?: 'RootQueryType', marketBrandsConnection: { __typename?: 'BrandConnection', edges: Array<{ __typename?: 'BrandEdge', node: { __typename?: 'Brand', id: number, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type MarketQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MarketQuery = { __typename?: 'RootQueryType', market?: { __typename?: 'Market', id: number, name: string, description?: string | null, body?: string | null } | null };

export type MarketsConnectionQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  imageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type MarketsConnectionQuery = { __typename?: 'RootQueryType', marketsConnection: { __typename?: 'MarketConnection', edges: Array<{ __typename?: 'MarketEdge', node: { __typename?: 'Market', id: number, name: string, imageUrls: Array<string | null> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ProductBrandsConnectionQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  locales: Array<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  hasProfile?: InputMaybe<Scalars['Boolean']['input']>;
  includeProfile: Scalars['Boolean']['input'];
  hasPremiumProfile?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductBrandsConnectionQuery = { __typename?: 'RootQueryType', productBrandsConnection: { __typename?: 'BrandConnection', edges: Array<{ __typename?: 'BrandEdge', node: { __typename?: 'Brand', id: number, name: string, profiles?: Array<{ __typename?: 'Profile', id: string, page: { __typename?: 'ProfilePage', slug: string } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ProductMainCategoriesQueryVariables = Exact<{
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  locales: Array<Scalars['String']['input']>;
}>;


export type ProductMainCategoriesQuery = { __typename?: 'RootQueryType', productMainCategories: Array<string> };

export type ProductQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type ProductQuery = { __typename?: 'RootQueryType', product?: { __typename?: 'Product', colorNames: Array<string>, sizeNames: Array<string>, deliveryTimes: Array<string>, url?: string | null, season?: string | null, shortDescription?: string | null, description?: string | null, summary?: string | null, name?: string | null, sourceName?: string | null, retailerName?: string | null, priceCurrencies: Array<string>, id: number, ageGroups: Array<AgeGroup>, genders: Array<Gender>, categoryMain?: string | null, categoryPath?: string | null, categorySub?: string | null, print?: string | null, material?: string | null, gtins: Array<string>, brand?: { __typename?: 'Brand', id: number, name: string, profiles: Array<{ __typename?: 'Profile', id: string, page: { __typename?: 'ProfilePage', slug: string } }> } | null, images: Array<{ __typename?: 'ProductImage', id: number, urls: Array<string> }>, orderQuantities?: { __typename?: 'OrderQuantityRange', minimum?: number | null, maximum?: number | null } | null, pricesWithCurrencies: Array<{ __typename?: 'PriceRangeWithCurrency', currency?: string | null, range?: { __typename?: 'PriceRange', average?: any | null, maximum?: any | null, minimum?: any | null } | null }>, materials: Array<{ __typename?: 'Material', id: number, name: string }> } | null };

export type ProductsConnectionQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories: Array<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  printIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductSorting>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  includeProfile: Scalars['Boolean']['input'];
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductsConnectionQuery = { __typename?: 'RootQueryType', productsConnection: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', id: number, name?: string | null, url?: string | null, sourceName?: string | null, ageGroups: Array<AgeGroup>, sizes: Array<string>, season?: string | null, images: Array<{ __typename?: 'ProductImage', id: number, urls: Array<string> }>, brand?: { __typename?: 'Brand', id: number, name: string, profiles?: Array<{ __typename?: 'Profile', id: string, page: { __typename?: 'ProfilePage', slug: string } }> } | null, colors: Array<{ __typename?: 'Color', id: number, name: string }>, pricesWithCurrencies: Array<{ __typename?: 'PriceRangeWithCurrency', currency?: string | null, range?: { __typename?: 'PriceRange', average?: any | null, maximum?: any | null, minimum?: any | null } | null }>, orderQuantities?: { __typename?: 'OrderQuantityRange', minimum?: number | null, maximum?: number | null } | null, deliveryDays?: { __typename?: 'DeliveryDaysRange', maximum?: number | null } | null, prints: Array<{ __typename?: 'Print', id: number, name: string }>, materials: Array<{ __typename?: 'Material', id: number, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ProductsCountQueryVariables = Exact<{
  locales: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainCategories: Array<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  seasons?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  ageGroups?: InputMaybe<Array<AgeGroup>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  standId?: InputMaybe<Scalars['Int']['input']>;
  priceAtLeast?: InputMaybe<Scalars['Decimal']['input']>;
  priceAtMost?: InputMaybe<Scalars['Decimal']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  retailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductsCountQuery = { __typename?: 'RootQueryType', productsCount: number };

export type ProfileBySlugEbpCoursesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  mobileImageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type ProfileBySlugEbpCoursesQuery = { __typename?: 'RootQueryType', profileBySlug?: { __typename?: 'Profile', id: string, page: { __typename?: 'ProfilePage', imageUrls: Array<string | null>, mobileImageUrls: Array<string | null>, title?: string | null, contactDetails?: string | null }, company: { __typename?: 'ProfileCompany', logoUrls: Array<string | null> }, coursesConnection: { __typename?: 'CourseConnection', edges: Array<{ __typename?: 'CourseEdge', node: { __typename?: 'Course', companyName?: string | null, title: string, description?: string | null, city?: string | null, introduction?: string | null, id: number, slug?: string | null, logoUrls: Array<string | null> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } } | null };

export type ProfileBySlugEbpQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  mobileImageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type ProfileBySlugEbpQuery = { __typename?: 'RootQueryType', profileBySlug?: { __typename?: 'Profile', id: string, canUpdate?: boolean | null, hasTabs: boolean, page: { __typename?: 'ProfilePage', premium?: boolean | null, isEbpEnabled?: boolean | null, slug: string, imageUrl?: string | null, imageUrls: Array<string | null>, mobileImageUrl?: string | null, mobileImageUrls: Array<string | null>, title?: string | null, showAboutPage?: boolean | null, showWorkingAtPage?: boolean | null, showNewsPage?: boolean | null, aboutPageTitle?: string | null, aboutPageHtml?: string | null, workingAtPageTitle?: string | null, workingAtPageHtml?: string | null, newsPageTitle?: string | null, newsPageHtml?: string | null, careerSiteReturnUrl?: string | null, jobKeywords?: string | null }, company: { __typename?: 'ProfileCompany', displayName?: string | null, description?: string | null, logoUrl?: string | null, logoUrls: Array<string | null>, newsTags: Array<string>, descriptions?: { __typename?: 'CompanyDescriptions', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frCh?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itCh?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null } } | null };

export type ProfileBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  mobileImageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
  collectionImageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type ProfileBySlugQuery = { __typename?: 'RootQueryType', profileBySlug?: { __typename?: 'Profile', type: ProfileType, id: string, canUpdate?: boolean | null, page: { __typename?: 'ProfilePage', premium?: boolean | null, slug: string, imageUrl?: string | null, imageUrls: Array<string | null>, mobileImageUrl?: string | null, mobileImageUrls: Array<string | null>, collectionImageUrls: Array<string>, title?: string | null, b2bPartnerPolicy?: string | null, contactDetails?: string | null, about?: string | null, videoUrl?: string | null, industries: Array<string>, responsiveCollectionImageUrls: Array<Array<string>>, showAboutPage?: boolean | null, showWorkingAtPage?: boolean | null, showNewsPage?: boolean | null, aboutPageTitle?: string | null, aboutPageHtml?: string | null, workingAtPageTitle?: string | null, workingAtPageHtml?: string | null, newsPageTitle?: string | null, newsPageHtml?: string | null }, company: { __typename?: 'ProfileCompany', fullName: string, description?: string | null, logoUrl?: string | null, logoUrls: Array<string | null>, newsTags: Array<string>, url?: string | null, descriptions?: { __typename?: 'CompanyDescriptions', csCz?: string | null, daDk?: string | null, deAt?: string | null, deCh?: string | null, deDe?: string | null, enAu?: string | null, enCa?: string | null, enGb?: string | null, enIe?: string | null, enIn?: string | null, enNz?: string | null, enUs?: string | null, esAr?: string | null, esCl?: string | null, esCo?: string | null, esEs?: string | null, esMx?: string | null, esPe?: string | null, fiFi?: string | null, frBe?: string | null, frCh?: string | null, frFr?: string | null, frLu?: string | null, huHu?: string | null, itCh?: string | null, itIt?: string | null, jaJp?: string | null, nbNo?: string | null, nlBe?: string | null, nlNl?: string | null, plPl?: string | null, ptBr?: string | null, ptPt?: string | null, ruRu?: string | null, svSe?: string | null, trTr?: string | null, zhCn?: string | null, zhHk?: string | null } | null }, brands: Array<{ __typename?: 'Brand', id: number }>, coursesConnection: { __typename?: 'CourseConnection', edges: Array<{ __typename?: 'CourseEdge', node: { __typename?: 'Course', id: number } }> } } | null };

export type ProfilesConnectionQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProfileType>;
  premium?: InputMaybe<Scalars['Boolean']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  logoConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type ProfilesConnectionQuery = { __typename?: 'RootQueryType', profilesConnection: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', country?: string | null, logoUrl?: string | null, logoUrls: Array<string | null>, fullName: string }, page: { __typename?: 'ProfilePage', about?: string | null, imageUrl?: string | null, imageUrls: Array<string | null>, premium?: boolean | null, slug: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RelatedProductsQueryVariables = Exact<{
  maybeBrandKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  maybeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSorting>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type RelatedProductsQuery = { __typename?: 'RootQueryType', products: Array<{ __typename?: 'Product', id: number, name?: string | null, url?: string | null, imageUrls: Array<string | null>, sourceName?: string | null, brand?: { __typename?: 'Brand', id: number, name: string } | null }> };

export type SelectedBrandsConnectionQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type SelectedBrandsConnectionQuery = { __typename?: 'RootQueryType', brandsConnection: { __typename?: 'BrandConnection', edges: Array<{ __typename?: 'BrandEdge', node: { __typename?: 'Brand', id: number, name: string } }> } };

export type StandQueryVariables = Exact<{
  standId: Scalars['Int']['input'];
}>;


export type StandQuery = { __typename?: 'RootQueryType', stand?: { __typename?: 'Stand', id: number, name: string, description?: string | null, body?: string | null, market: { __typename?: 'Market', id: number, name: string } } | null };

export type StandsConnectionQueryVariables = Exact<{
  marketId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  imageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type StandsConnectionQuery = { __typename?: 'RootQueryType', market?: { __typename?: 'Market', id: number, name: string, description?: string | null, standsConnection: { __typename?: 'StandConnection', edges: Array<{ __typename?: 'StandEdge', node: { __typename?: 'Stand', id: number, name: string, imageUrls: Array<string | null> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type SpecialPagesConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SpecialPageSorting>;
  newsboard: Newsboard;
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type SpecialPagesConnectionQuery = { __typename?: 'RootQueryType', specialPagesConnection: { __typename?: 'SpecialPageConnection', edges: Array<{ __typename?: 'SpecialPageEdge', node: { __typename?: 'SpecialPage', id: number, title: string, imageUrls: Array<string | null>, mobileImageUrls: Array<string | null>, slug: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type TagNewsCategoryQueryVariables = Exact<{
  imageConfigurations: Array<ResponsiveImageConfiguration>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  statuses?: InputMaybe<Array<NewsArticleStatus>>;
  newsboard: Newsboard;
}>;


export type TagNewsCategoryQuery = { __typename?: 'RootQueryType', tag?: { __typename?: 'Tag', title: string, slug: string, universalNewsArticles: Array<{ __typename?: 'LocalNewsArticle', insertedAt: string, id: number, imageUrls: Array<string | null>, slug: string, title: string, accessLevel: AccessLevel, category?: { __typename?: 'LocalNewsCategory', id: number, path?: string | null } | null } | { __typename?: 'NewsArticle', insertedAt: string, id: number, imageUrls: Array<string | null>, slug: string, title: string, accessLevel: AccessLevel, category?: { __typename?: 'NewsCategory', id: number, path?: string | null } | null }> } | null };

export type TagBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type TagBySlugQuery = { __typename?: 'RootQueryType', tag?: { __typename?: 'Tag', title: string, path?: string | null, slug: string } | null };

export type TagsCountQueryVariables = Exact<{
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  newsboard: Newsboard;
}>;


export type TagsCountQuery = { __typename?: 'RootQueryType', tagsCount: number };

export type TagsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  newsboard: Newsboard;
  sort?: InputMaybe<TagSorting>;
}>;


export type TagsQuery = { __typename?: 'RootQueryType', tags: Array<{ __typename?: 'Tag', title: string, path?: string | null, slug: string }> };

export type CreateTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<JobPropertyInput>>;
}>;


export type CreateTemplateMutation = { __typename?: 'RootMutationType', createTemplate: { __typename?: 'Template', id: string } };

export type RemoveTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveTemplateMutation = { __typename?: 'RootMutationType', removeTemplate: boolean };

export type TemplateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TemplateQuery = { __typename?: 'RootQueryType', template?: { __typename?: 'Template', id: string, parentId?: string | null, sourceName: string, revision: string, mergedProperties: Array<{ __typename?: 'JobProperty', name: string, type?: string | null, value?: string | null }> } | null };

export type TemplatesConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type TemplatesConnectionQuery = { __typename?: 'RootQueryType', templatesConnection: { __typename?: 'TemplateConnection', edges: Array<{ __typename?: 'TemplateEdge', node: { __typename?: 'Template', id: string, parentId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type UpdateTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<JobPropertyInput>>;
}>;


export type UpdateTemplateMutation = { __typename?: 'RootMutationType', updateTemplate: { __typename?: 'Template', id: string } };

export type TemplateForUpdateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TemplateForUpdateQuery = { __typename?: 'RootQueryType', template?: { __typename?: 'Template', id: string, parentId?: string | null, mergedProperties: Array<{ __typename?: 'JobProperty', name: string, type?: string | null, value?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', fullName: string } }> } | null };

export type CurrentUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', _id: string, username?: string | null, language?: string | null, account?: { __typename?: 'Account', id: number, address?: string | null, addressRegion?: string | null, city?: string | null, companyName?: string | null, country?: string | null, firstName?: string | null, lastName?: string | null, postCode?: string | null, vatNumber?: string | null } | null } | null };

export type CurrentUserFormQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserFormQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', _id: string, username?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, country?: string | null, city?: string | null, language?: string | null, companyName?: string | null, websiteUrl?: string | null, chamberOfCommerceNumber?: string | null } | null };

export type CurrentUserProfileQueryVariables = Exact<{
  imageConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
  logoConfigurations?: InputMaybe<Array<ResponsiveImageConfiguration>>;
}>;


export type CurrentUserProfileQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', _id: string, username?: string | null, insertedAt: string, name?: string | null, country?: string | null, language?: string | null, companyName?: string | null, websiteUrl?: string | null, chamberOfCommerceNumber?: string | null, imageUrls: Array<string | null>, markets: Array<{ __typename?: 'Market', id: number, name: string }> } | null, profiles: Array<{ __typename?: 'Profile', id: string, company: { __typename?: 'ProfileCompany', country?: string | null, fullName: string, logoUrls: Array<string | null> }, page: { __typename?: 'ProfilePage', slug: string } }> };

export type CurrentUserQueryVariables = Exact<{
  imageConfigurations: Array<ResponsiveImageConfiguration>;
}>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, username?: string | null, name?: string | null, verified: boolean, hasCompleteBuyerProfile: boolean, shouldSetPassword: boolean, imageUrls: Array<string | null> } | null };

export type OrderUpdatedSubscriptionVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OrderUpdatedSubscription = { __typename?: 'RootSubscriptionType', orderUpdated: { __typename?: 'Order', id: number, status: OrderStatus } };


export const AddHighlightPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddHighlightPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightPeriod"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobHighlightPeriodInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addHighlightPeriod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"highlightPeriod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightPeriod"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddHighlightPeriodMutation, AddHighlightPeriodMutationVariables>;
export const ApproveJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApproveJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApproveJobMutation, ApproveJobMutationVariables>;
export const CreateAnalyticsEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnalyticsEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subjectType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsEventType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnalyticsEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}},{"kind":"Argument","name":{"kind":"Name","value":"subjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subjectType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subjectType"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAnalyticsEventMutation, CreateAnalyticsEventMutationVariables>;
export const CreateApplicantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApplicant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscribedToNewsletter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"motivation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cv"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverLetter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extraDocument1"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extraDocument2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createApplicant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"subscribedToNewsletter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscribedToNewsletter"}}},{"kind":"Argument","name":{"kind":"Name","value":"motivation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"motivation"}}},{"kind":"Argument","name":{"kind":"Name","value":"cv"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cv"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverLetter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverLetter"}}},{"kind":"Argument","name":{"kind":"Name","value":"extraDocument1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extraDocument1"}}},{"kind":"Argument","name":{"kind":"Name","value":"extraDocument2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extraDocument2"}}}]}]}}]} as unknown as DocumentNode<CreateApplicantMutation, CreateApplicantMutationVariables>;
export const CreateImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"private"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credits"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalUseOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"private"},"value":{"kind":"Variable","name":{"kind":"Name","value":"private"}}},{"kind":"Argument","name":{"kind":"Name","value":"credits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credits"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"captchaResponse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreateImageMutation, CreateImageMutationVariables>;
export const CreateJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"job"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"job"},"value":{"kind":"Variable","name":{"kind":"Name","value":"job"}}},{"kind":"Argument","name":{"kind":"Name","value":"captchaResponse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CreateJobMutation, CreateJobMutationVariables>;
export const CreateLogoImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLogoImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalUseOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"captchaResponse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]} as unknown as DocumentNode<CreateLogoImageMutation, CreateLogoImageMutationVariables>;
export const CreateMarketAccessRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMarketAccessRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMarketAccessRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}}]}]}}]} as unknown as DocumentNode<CreateMarketAccessRequestMutation, CreateMarketAccessRequestMutationVariables>;
export const CreateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItemInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"referralCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreatePersonalAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePersonalAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressRegion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vatNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPersonalAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"addressRegion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressRegion"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"postCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"vatNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vatNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePersonalAccountMutation, CreatePersonalAccountMutationVariables>;
export const CreateProfileJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProfileJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fullName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}}},{"kind":"Argument","name":{"kind":"Name","value":"contact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"logoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateProfileJobMutation, CreateProfileJobMutationVariables>;
export const DuplicateJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<DuplicateJobMutation, DuplicateJobMutationVariables>;
export const GenerateTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generationConfig"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"generationConfig"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generationConfig"}}}]}]}}]} as unknown as DocumentNode<GenerateTextMutation, GenerateTextMutationVariables>;
export const GeocodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Geocode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geocode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}}]}}]}}]} as unknown as DocumentNode<GeocodeMutation, GeocodeMutationVariables>;
export const AddressByVatNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddressByVatNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vatNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAddressByVatNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vatNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vatNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}}]}}]}}]} as unknown as DocumentNode<AddressByVatNumberMutation, AddressByVatNumberMutationVariables>;
export const ExchangeRateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExchangeRate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getExchangeRate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}]}}]} as unknown as DocumentNode<ExchangeRateMutation, ExchangeRateMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LoginWithTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginWithToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<LoginWithTokenMutation, LoginWithTokenMutationVariables>;
export const PublishJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PublishJobMutation, PublishJobMutationVariables>;
export const PublishNewsArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishNewsArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PublishNewsArticleMutation, PublishNewsArticleMutationVariables>;
export const RefreshAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshAccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshAccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chamberOfCommerceNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"registeredVia"},"value":{"kind":"EnumValue","value":"NEWS"}},{"kind":"Argument","name":{"kind":"Name","value":"chamberOfCommerceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chamberOfCommerceNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"websiteUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"captchaResponse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const RegisterWithTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterWithToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registeredVia"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Registrar"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerWithToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}},{"kind":"Argument","name":{"kind":"Name","value":"registeredVia"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registeredVia"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<RegisterWithTokenMutation, RegisterWithTokenMutationVariables>;
export const RemoveHighlightPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveHighlightPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightPeriod"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobHighlightPeriodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeHighlightPeriod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightPeriod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightPeriod"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveHighlightPeriodMutation, RemoveHighlightPeriodMutationVariables>;
export const RepostJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RepostJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferredCreditTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repostJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"preferredCreditTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferredCreditTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RepostJobMutation, RepostJobMutationVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerificationEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"}}]}}]} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RestrictedUpdateJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestrictedUpdateJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"job"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RestrictedJobInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restrictedUpdateJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"job"},"value":{"kind":"Variable","name":{"kind":"Name","value":"job"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RestrictedUpdateJobMutation, RestrictedUpdateJobMutationVariables>;
export const ScheduleJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScheduleJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ScheduleJobMutation, ScheduleJobMutationVariables>;
export const SendMessageToApplicantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessageToApplicant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplicantMessageReason"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessageToApplicant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"applicantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}},{"kind":"Argument","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SendMessageToApplicantMutation, SendMessageToApplicantMutationVariables>;
export const SendResetPasswordEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendResetPasswordEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendResetPasswordEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}]}}]} as unknown as DocumentNode<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const SetApplicantStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetApplicantStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplicantStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setApplicantStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}]} as unknown as DocumentNode<SetApplicantStatusMutation, SetApplicantStatusMutationVariables>;
export const SetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<SetPasswordMutation, SetPasswordMutationVariables>;
export const SubscribeToNewsletterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubscribeToNewsletter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToNewsletter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"captchaResponse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"captchaResponse"}}}]}]}}]} as unknown as DocumentNode<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;
export const UnpublishJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnpublishJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpublishJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UnpublishJobMutation, UnpublishJobMutationVariables>;
export const UnpublishNewsArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnpublishNewsArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpublishNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UnpublishNewsArticleMutation, UnpublishNewsArticleMutationVariables>;
export const UpdateCurrentProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCurrentProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chamberOfCommerceNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"websiteUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"chamberOfCommerceNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chamberOfCommerceNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<UpdateCurrentProfileMutation, UpdateCurrentProfileMutationVariables>;
export const UpdateEmployeeProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEmployeeProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showAboutPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showNewsPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showWorkingAtPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aboutPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"aboutPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"showAboutPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showAboutPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"showNewsPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showNewsPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"workingAtPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"workingAtPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"showWorkingAtPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showWorkingAtPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateEmployeeProfileMutation, UpdateEmployeeProfileMutationVariables>;
export const UpdateJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"job"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"job"},"value":{"kind":"Variable","name":{"kind":"Name","value":"job"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateJobMutation, UpdateJobMutationVariables>;
export const UpdateNewsArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNewsArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publishScheduledAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unpublishScheduledAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"dek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dek"}}},{"kind":"Argument","name":{"kind":"Name","value":"comments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comments"}}},{"kind":"Argument","name":{"kind":"Name","value":"insertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"publishScheduledAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publishScheduledAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"unpublishScheduledAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unpublishScheduledAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateNewsArticleMutation, UpdateNewsArticleMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"about"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"b2bPartnerPolicy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageUrls"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"industries"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"about"},"value":{"kind":"Variable","name":{"kind":"Name","value":"about"}}},{"kind":"Argument","name":{"kind":"Name","value":"b2bPartnerPolicy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"b2bPartnerPolicy"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionImageUrls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageUrls"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"industries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"industries"}}},{"kind":"Argument","name":{"kind":"Name","value":"mobileImageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const CountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"euMember"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CountriesQuery, CountriesQueryVariables>;
export const CourseCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CourseCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CourseCategoriesQuery, CourseCategoriesQueryVariables>;
export const CourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Course"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstImageFetchPriority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchPriority"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"additionalInformation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstImageFetchPriority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstImageFetchPriority"}}}]},{"kind":"Field","name":{"kind":"Name","value":"introduction"}},{"kind":"Field","name":{"kind":"Name","value":"education"}},{"kind":"Field","name":{"kind":"Name","value":"hits"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CourseQuery, CourseQueryVariables>;
export const CoursesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CoursesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coursesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}}]}]}}]} as unknown as DocumentNode<CoursesCountQuery, CoursesCountQueryVariables>;
export const CoursesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Courses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coursesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CoursesQuery, CoursesQueryVariables>;
export const AccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Accounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"crmOrganizationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"vtigerAccountId"}}]}}]}}]} as unknown as DocumentNode<AccountsQuery, AccountsQueryVariables>;
export const BundlesAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BundlesAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}}]}}]} as unknown as DocumentNode<BundlesAccountsQuery, BundlesAccountsQueryVariables>;
export const AddBrandToProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddBrandToProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addBrandToProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}]}]}}]} as unknown as DocumentNode<AddBrandToProfileMutation, AddBrandToProfileMutationVariables>;
export const AllJobsApplyButtonClicksCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllJobsApplyButtonClicksCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allJobsApplyButtonClicksCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"minEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}}}]}]}}]} as unknown as DocumentNode<AllJobsApplyButtonClicksCountQuery, AllJobsApplyButtonClicksCountQueryVariables>;
export const AllJobsPageviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllJobsPageviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allJobsPageviewsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"minEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}}}]}]}}]} as unknown as DocumentNode<AllJobsPageviewsCountQuery, AllJobsPageviewsCountQueryVariables>;
export const ApplicantsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplicantsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplicantStatus"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicantsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}]}]}}]} as unknown as DocumentNode<ApplicantsCountQuery, ApplicantsCountQueryVariables>;
export const ApplicantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Applicants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasDocumentsRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasApplicantMessagesRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplicantStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"coverLetterUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasDocumentsRole"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"cvUrl"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasDocumentsRole"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"extraDocument1Url"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasDocumentsRole"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"extraDocument2Url"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasDocumentsRole"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"motivation"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"applicantMessagesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reasons"},"value":{"kind":"EnumValue","value":"REJECTION"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasApplicantMessagesRole"}}}]}]}]}}]}}]} as unknown as DocumentNode<ApplicantsQuery, ApplicantsQueryVariables>;
export const ApproveMarketAccessRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApproveMarketAccessRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveMarketAccessRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ApproveMarketAccessRequestMutation, ApproveMarketAccessRequestMutationVariables>;
export const ApproveStandAccessRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApproveStandAccessRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveStandAccessRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ApproveStandAccessRequestMutation, ApproveStandAccessRequestMutationVariables>;
export const ArticleFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleStatus"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledNow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduledNow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledNow"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"dek"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}},{"kind":"Field","name":{"kind":"Name","value":"newsboards"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"htmlModified"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishScheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"unpublishScheduledAt"}}]}}]}}]} as unknown as DocumentNode<ArticleFormQuery, ArticleFormQueryVariables>;
export const AuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Authors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AuthorsQuery, AuthorsQueryVariables>;
export const BrandNamesConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandNamesConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandNamesConnectionQuery, BrandNamesConnectionQueryVariables>;
export const BundlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Bundles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountType"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<BundlesQuery, BundlesQueryVariables>;
export const CategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Categories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterAllowed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterAllowed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterAllowed"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const CheckTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"titles"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"titles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"titles"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CheckTagsQuery, CheckTagsQueryVariables>;
export const CreateBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateBrandMutation, CreateBrandMutationVariables>;
export const CreateNewsArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewsArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publishScheduledAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unpublishScheduledAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"dek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dek"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"Argument","name":{"kind":"Name","value":"comments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comments"}}},{"kind":"Argument","name":{"kind":"Name","value":"insertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"publishScheduledAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publishScheduledAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"unpublishScheduledAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unpublishScheduledAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewsArticleMutation, CreateNewsArticleMutationVariables>;
export const CreateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"about"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addresses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAddressInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"b2bPartnerPolicy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careerSiteReturnUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageUrls"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coursesName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmOrganizationNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descriptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDescriptionsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facebook"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkPageInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"industries"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkUserInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobKeywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metaDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pinterest"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkPageInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"premium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEbpEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showAboutPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showNewsList"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showNewsPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showWorkingAtPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"snapchat"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkUserInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twitter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkPageInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailDomains"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"about"},"value":{"kind":"Variable","name":{"kind":"Name","value":"about"}}},{"kind":"Argument","name":{"kind":"Name","value":"aboutPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"aboutPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"addresses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addresses"}}},{"kind":"Argument","name":{"kind":"Name","value":"b2bPartnerPolicy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"b2bPartnerPolicy"}}},{"kind":"Argument","name":{"kind":"Name","value":"careerSiteReturnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careerSiteReturnUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionImageUrls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageUrls"}}},{"kind":"Argument","name":{"kind":"Name","value":"contact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"coursesName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coursesName"}}},{"kind":"Argument","name":{"kind":"Name","value":"crmOrganizationNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmOrganizationNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"descriptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descriptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"facebook"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facebook"}}},{"kind":"Argument","name":{"kind":"Name","value":"fullName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"industries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"industries"}}},{"kind":"Argument","name":{"kind":"Name","value":"instagram"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"logoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"metaDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metaDescription"}}},{"kind":"Argument","name":{"kind":"Name","value":"mobileImageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsTags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"pinterest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pinterest"}}},{"kind":"Argument","name":{"kind":"Name","value":"premium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"premium"}}},{"kind":"Argument","name":{"kind":"Name","value":"isEbpEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEbpEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"showAboutPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showAboutPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"showNewsList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showNewsList"}}},{"kind":"Argument","name":{"kind":"Name","value":"showNewsPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showNewsPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"showWorkingAtPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showWorkingAtPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"snapchat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"snapchat"}}},{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"twitter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twitter"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"workingAtPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"workingAtPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"emailDomains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailDomains"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateProfileMutation, CreateProfileMutationVariables>;
export const DeleteMarketAccessRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMarketAccessRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMarketAccessRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteMarketAccessRequestMutation, DeleteMarketAccessRequestMutationVariables>;
export const DeleteStandAccessRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteStandAccessRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteStandAccessRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteStandAccessRequestMutation, DeleteStandAccessRequestMutationVariables>;
export const CompanyDescriptionsInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyDescriptionsInput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"CompanyDescriptionsInput","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyDescriptionsInputQuery, CompanyDescriptionsInputQueryVariables>;
export const TemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Templates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"600"}},{"kind":"Argument","name":{"kind":"Name","value":"scoped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}}]}}]} as unknown as DocumentNode<TemplatesQuery, TemplatesQueryVariables>;
export const JobVersionsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobVersionsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"versionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"applyForm"}},{"kind":"Field","name":{"kind":"Name","value":"applyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"highlightPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beginsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfPositions"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publications"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"sender"}},{"kind":"Field","name":{"kind":"Name","value":"showTitle"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdById"}},{"kind":"Field","name":{"kind":"Name","value":"updater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedById"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobVersionsConnectionQuery, JobVersionsConnectionQueryVariables>;
export const JobsApplicantsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsApplicantsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsApplicantsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsApplicantsCountQuery, JobsApplicantsCountQueryVariables>;
export const JobsApplyButtonClicksCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsApplyButtonClicksCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsApplyButtonClicksCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsApplyButtonClicksCountQuery, JobsApplyButtonClicksCountQueryVariables>;
export const JobsAverageApplicantsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsAverageApplicantsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsAverageApplicantsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsAverageApplicantsCountQuery, JobsAverageApplicantsCountQueryVariables>;
export const JobsAverageApplyButtonClicksCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsAverageApplyButtonClicksCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsAverageApplyButtonClicksCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsAverageApplyButtonClicksCountQuery, JobsAverageApplyButtonClicksCountQueryVariables>;
export const JobsAveragePageviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsAveragePageviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsAveragePageviewsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsAveragePageviewsCountQuery, JobsAveragePageviewsCountQueryVariables>;
export const JobsAverageRepostsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsAverageRepostsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsAverageRepostsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsAverageRepostsCountQuery, JobsAverageRepostsCountQueryVariables>;
export const JobsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobSorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightPeriodType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightAnytime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"scoped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightLocale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightAnytime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightAnytime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveHighlightPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"highlightPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beginsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicantCount"}},{"kind":"Field","name":{"kind":"Name","value":"applyButtonClickCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageViewCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"postingType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<JobsConnectionQuery, JobsConnectionQueryVariables>;
export const JobsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"scoped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsCountQuery, JobsCountQueryVariables>;
export const JobsPageviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsPageviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsPageviewsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsPageviewsCountQuery, JobsPageviewsCountQueryVariables>;
export const JobsRepostsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsRepostsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPostingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsRepostsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyNameSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyNameSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"postingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]} as unknown as DocumentNode<JobsRepostsCountQuery, JobsRepostsCountQueryVariables>;
export const MarketAccessRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketAccessRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketAccessRequestsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"chamberOfCommerceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<MarketAccessRequestsQuery, MarketAccessRequestsQueryVariables>;
export const MonthlyAllJobsApplyButtonClicksCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MonthlyAllJobsApplyButtonClicksCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthlyAllJobsApplyButtonClicksCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"minEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]} as unknown as DocumentNode<MonthlyAllJobsApplyButtonClicksCountQuery, MonthlyAllJobsApplyButtonClicksCountQueryVariables>;
export const MonthlyAllJobsPageviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MonthlyAllJobsPageviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthlyAllJobsPageviewsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"minEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minEventInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxEventInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxEventInsertedAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]} as unknown as DocumentNode<MonthlyAllJobsPageviewsCountQuery, MonthlyAllJobsPageviewsCountQueryVariables>;
export const MonthlyApplicantsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MonthlyApplicantsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplicantStatus"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthlyApplicantsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]} as unknown as DocumentNode<MonthlyApplicantsCountQuery, MonthlyApplicantsCountQueryVariables>;
export const MonthlyTransactionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MonthlyTransactionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthlyTransactionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]} as unknown as DocumentNode<MonthlyTransactionsCountQuery, MonthlyTransactionsCountQueryVariables>;
export const OrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Order"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"bundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentCheckoutUrl"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const OrderStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<OrderStatusQuery, OrderStatusQueryVariables>;
export const PreviewNewsArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PreviewNewsArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authorImageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"dek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dek"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"Argument","name":{"kind":"Name","value":"comments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"dek"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"imageCaption"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authorImageConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pressRelease"}},{"kind":"Field","name":{"kind":"Name","value":"scores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerContent"}},{"kind":"Field","name":{"kind":"Name","value":"hasAccess"}}]}}]}}]} as unknown as DocumentNode<PreviewNewsArticleQuery, PreviewNewsArticleQueryVariables>;
export const PreviewNewsArticleCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PreviewNewsArticleCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"dek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dek"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"Argument","name":{"kind":"Name","value":"comments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pressRelease"}},{"kind":"Field","name":{"kind":"Name","value":"partnerContent"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<PreviewNewsArticleCardQuery, PreviewNewsArticleCardQueryVariables>;
export const ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Profile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const ProfileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"crmOrganizationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"vtigerAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"isEbpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"collectionImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"b2bPartnerPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industries"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}},{"kind":"Field","name":{"kind":"Name","value":"aboutPageMarkdown"}},{"kind":"Field","name":{"kind":"Name","value":"aboutPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageMarkdown"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageMarkdown"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"showAboutPage"}},{"kind":"Field","name":{"kind":"Name","value":"showNewsPage"}},{"kind":"Field","name":{"kind":"Name","value":"showWorkingAtPage"}},{"kind":"Field","name":{"kind":"Name","value":"careerSiteReturnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"jobKeywords"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"coursesName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"crmOrganizationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsTags"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"emailDomains"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postbox"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"twitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinterest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapchat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileByIdQuery, ProfileByIdQueryVariables>;
export const ProfileNameSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileNameSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"scoped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileNameSearchQuery, ProfileNameSearchQueryVariables>;
export const ProfileNamesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileNamesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileNamesByIdQuery, ProfileNamesByIdQueryVariables>;
export const ProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Profiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"canUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canUpdate"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"scoped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scoped"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"crmOrganizationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"vtigerAccountId"}}]}}]}}]}}]} as unknown as DocumentNode<ProfilesQuery, ProfilesQueryVariables>;
export const ProfilesNamesConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfilesNamesConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profilesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ProfilesNamesConnectionQuery, ProfilesNamesConnectionQueryVariables>;
export const ProfilesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfilesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeInactive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profilesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeInactive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeInactive"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}]}}]} as unknown as DocumentNode<ProfilesCountQuery, ProfilesCountQueryVariables>;
export const ProfileNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeInactive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeInactive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeInactive"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileNamesQuery, ProfileNamesQueryVariables>;
export const RemoveBrandFromProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveBrandFromProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBrandFromProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}]}]}}]} as unknown as DocumentNode<RemoveBrandFromProfileMutation, RemoveBrandFromProfileMutationVariables>;
export const RemoveProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveProfileMutation, RemoveProfileMutationVariables>;
export const RepostJobCreditTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RepostJobCreditTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repostJobCreditTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RepostJobCreditTypesQuery, RepostJobCreditTypesQueryVariables>;
export const StandAccessRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StandAccessRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standAccessRequestsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"chamberOfCommerceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<StandAccessRequestsQuery, StandAccessRequestsQueryVariables>;
export const SuggestedTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuggestedTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"dek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dek"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdById"}}},{"kind":"Argument","name":{"kind":"Name","value":"comments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"NEWS_ARTICLES_COUNT_DESCENDING"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"newsArticlesCount"}}]}}]}}]}}]} as unknown as DocumentNode<SuggestedTagsQuery, SuggestedTagsQueryVariables>;
export const TagSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"RELEVANCE_AND_NEWS_ARTICLES_COUNT_DESCENDING"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"newsArticlesCount"}}]}}]}}]} as unknown as DocumentNode<TagSearchQuery, TagSearchQueryVariables>;
export const TagsArticlesCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagsArticlesCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"titles"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"titles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"titles"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"newsArticlesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsboards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboards"}}}]}]}}]}}]} as unknown as DocumentNode<TagsArticlesCountsQuery, TagsArticlesCountsQueryVariables>;
export const TopTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TopTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"NEWS_ARTICLES_COUNT_DESCENDING"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<TopTagsQuery, TopTagsQueryVariables>;
export const TransactionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"minInsertedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minInsertedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}]}}]} as unknown as DocumentNode<TransactionsCountQuery, TransactionsCountQueryVariables>;
export const UpdateProfileDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfileDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"about"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addresses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAddressInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"b2bPartnerPolicy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careerSiteReturnUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageUrls"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coursesName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmOrganizationNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descriptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDescriptionsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facebook"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkPageInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"industries"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkUserInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobKeywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metaDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pinterest"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkPageInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"premium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEbpEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showAboutPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showNewsPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showWorkingAtPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"snapchat"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkUserInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twitter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySocialNetworkPageInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageMarkdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailDomains"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"about"},"value":{"kind":"Variable","name":{"kind":"Name","value":"about"}}},{"kind":"Argument","name":{"kind":"Name","value":"aboutPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"aboutPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"addresses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addresses"}}},{"kind":"Argument","name":{"kind":"Name","value":"b2bPartnerPolicy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"b2bPartnerPolicy"}}},{"kind":"Argument","name":{"kind":"Name","value":"careerSiteReturnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careerSiteReturnUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionImageUrls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageUrls"}}},{"kind":"Argument","name":{"kind":"Name","value":"contact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"coursesName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coursesName"}}},{"kind":"Argument","name":{"kind":"Name","value":"crmOrganizationNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmOrganizationNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"descriptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descriptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"facebook"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facebook"}}},{"kind":"Argument","name":{"kind":"Name","value":"fullName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"industries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"industries"}}},{"kind":"Argument","name":{"kind":"Name","value":"instagram"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"logoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"metaDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metaDescription"}}},{"kind":"Argument","name":{"kind":"Name","value":"mobileImageUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsTags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"pinterest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pinterest"}}},{"kind":"Argument","name":{"kind":"Name","value":"premium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"premium"}}},{"kind":"Argument","name":{"kind":"Name","value":"isEbpEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEbpEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"showAboutPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showAboutPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"showNewsPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showNewsPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"showWorkingAtPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showWorkingAtPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"snapchat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"snapchat"}}},{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"twitter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twitter"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"videoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"workingAtPageMarkdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageMarkdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"workingAtPageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workingAtPageTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"emailDomains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailDomains"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProfileDashboardMutation, UpdateProfileDashboardMutationVariables>;
export const UploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Upload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credits"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalUseOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"credits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credits"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}}]}}]}}]} as unknown as DocumentNode<UploadMutation, UploadMutationVariables>;
export const ApplyForJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplyForJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<ApplyForJobQuery, ApplyForJobQueryVariables>;
export const CitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Cities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"citiesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CitiesQuery, CitiesQueryVariables>;
export const FilterCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterCities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CitySorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIdsOrKeywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileIdsOrKeywords"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"positionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobsFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"jobsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIdsOrKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIdsOrKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"positionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}}]}]}}]}}]} as unknown as DocumentNode<FilterCitiesQuery, FilterCitiesQueryVariables>;
export const CityBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CityBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}}]}}]} as unknown as DocumentNode<CityBySlugQuery, CityBySlugQueryVariables>;
export const CompanyProfilesConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyProfilesConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"premium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profilesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"premium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"premium"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frCh"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itCh"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyProfilesConnectionQuery, CompanyProfilesConnectionQueryVariables>;
export const IncreaseApplyButtonClicksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncreaseApplyButtonClicks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increaseApplyButtonClicks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<IncreaseApplyButtonClicksMutation, IncreaseApplyButtonClicksMutationVariables>;
export const IncreaseJobPageViewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncreaseJobPageViews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increaseJobPageViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<IncreaseJobPageViewsMutation, IncreaseJobPageViewsMutationVariables>;
export const JobActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<JobActiveQuery, JobActiveQueryVariables>;
export const JobExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<JobExistsQuery, JobExistsQueryVariables>;
export const JobAdminFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobAdminForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"crmOrganizationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"vtigerAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applyForm"}},{"kind":"Field","name":{"kind":"Name","value":"applyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"disableEmails"}},{"kind":"Field","name":{"kind":"Name","value":"showTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"createdByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"categoriesGuessed"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"publications"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"postingType"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}}]}}]}}]} as unknown as DocumentNode<JobAdminFormQuery, JobAdminFormQueryVariables>;
export const JobFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"applyForm"}},{"kind":"Field","name":{"kind":"Name","value":"applyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenPublished"}}]}}]}}]} as unknown as DocumentNode<JobFormQuery, JobFormQueryVariables>;
export const JobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Job"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"applyForm"}},{"kind":"Field","name":{"kind":"Name","value":"applyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityIds"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"highlightPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beginsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"profileIds"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"newsTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"312"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"250"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"624"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"500"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"9"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"720"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"148"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1440"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"296"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"320"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"256"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"640"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"512"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]}]}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"312"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"250"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"624"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"500"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"320"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"256"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"640"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"512"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]}]}}]},{"kind":"Field","name":{"kind":"Name","value":"premium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTabs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mergedProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"200"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"314"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"600"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"942"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1752"}}]}]}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publications"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<JobQuery, JobQueryVariables>;
export const JobSlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobSlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<JobSlugQuery, JobSlugQueryVariables>;
export const JobsListConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsListConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIdsOrKeywords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileIdsOrKeywords"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"positionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightPeriodType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobSorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distanceFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoJsonGeometryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIdsOrKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIdsOrKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"positionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightLocale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"distanceFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distanceFrom"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLocale"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTabs"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<JobsListConnectionQuery, JobsListConnectionQueryVariables>;
export const JobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Jobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightPeriodType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightLocale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frCh"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itCh"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}}]}}]}}]} as unknown as DocumentNode<JobsQuery, JobsQueryVariables>;
export const LatestJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightPeriodType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightLocale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightLocale"}}},{"kind":"Argument","name":{"kind":"Name","value":"highlightType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highlightType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frCh"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itCh"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}}]}}]}}]} as unknown as DocumentNode<LatestJobsQuery, LatestJobsQueryVariables>;
export const PositionBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PositionBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positionBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"names"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frCh"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itCh"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}}]}}]}}]} as unknown as DocumentNode<PositionBySlugQuery, PositionBySlugQueryVariables>;
export const PositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Positions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"names"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frCh"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itCh"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PositionsQuery, PositionsQueryVariables>;
export const PreviewJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PreviewJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"job"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"job"},"value":{"kind":"Variable","name":{"kind":"Name","value":"job"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"applyForm"}},{"kind":"Field","name":{"kind":"Name","value":"applyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityIds"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"highlightPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beginsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"profileIds"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"312"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"250"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"624"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"500"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"9"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"720"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"148"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1440"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"296"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"320"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"256"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"640"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"512"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]}]}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"312"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"250"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"624"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"500"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"34"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"320"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"256"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"640"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"512"}},{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"EnumValue","value":"FILL_DOWN"}}]}]}}]},{"kind":"Field","name":{"kind":"Name","value":"premium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTabs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mergedProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"42"}},{"kind":"ObjectField","name":{"kind":"Name","value":"quality"},"value":{"kind":"IntValue","value":"10"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"200"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"314"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"600"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"942"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1752"}}]}]}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publications"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<PreviewJobQuery, PreviewJobQueryVariables>;
export const ProfileBySlugEmployerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileBySlugEmployer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aboutPageMarkdown"}},{"kind":"Field","name":{"kind":"Name","value":"aboutPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageMarkdown"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"showAboutPage"}},{"kind":"Field","name":{"kind":"Name","value":"showNewsPage"}},{"kind":"Field","name":{"kind":"Name","value":"showWorkingAtPage"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageMarkdown"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsTags"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileBySlugEmployerQuery, ProfileBySlugEmployerQueryVariables>;
export const RelatedJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelatedJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsTags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<RelatedJobsQuery, RelatedJobsQueryVariables>;
export const RelatedProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelatedProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"premium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsTags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}}},{"kind":"Argument","name":{"kind":"Name","value":"premium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"premium"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}}]}}]}}]} as unknown as DocumentNode<RelatedProfilesQuery, RelatedProfilesQueryVariables>;
export const WFBProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WFBProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasTabs"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"premium"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}}]}}]}}]} as unknown as DocumentNode<WFBProfilesQuery, WFBProfilesQueryVariables>;
export const LookbookCreateImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LookbookCreateImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credits"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"credits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credits"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalUseOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LookbookCreateImageMutation, LookbookCreateImageMutationVariables>;
export const ImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Image"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"freeForCommercialUse"}},{"kind":"Field","name":{"kind":"Name","value":"freeForEditorialUse"}},{"kind":"Field","name":{"kind":"Name","value":"internalUseOnly"}},{"kind":"Field","name":{"kind":"Name","value":"noAttributionRequired"}}]}}]}}]} as unknown as DocumentNode<ImageQuery, ImageQueryVariables>;
export const ImageCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImageCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<ImageCategoriesQuery, ImageCategoriesQueryVariables>;
export const ImageCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImageCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<ImageCategoryQuery, ImageCategoryQueryVariables>;
export const ImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Images"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalUseOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<ImagesQuery, ImagesQueryVariables>;
export const RemoveImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeFile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purgeResponsiveImageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"removeFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeFile"}}},{"kind":"Argument","name":{"kind":"Name","value":"purgeResponsiveImageConfigurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purgeResponsiveImageConfigurations"}}}]}]}}]} as unknown as DocumentNode<RemoveImageMutation, RemoveImageMutationVariables>;
export const UpdateImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"freeForCommercialUse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"freeForEditorialUse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noAttributionRequired"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credits"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"freeForCommercialUse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"freeForCommercialUse"}}},{"kind":"Argument","name":{"kind":"Name","value":"freeForEditorialUse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"freeForEditorialUse"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalUseOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalUseOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"noAttributionRequired"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noAttributionRequired"}}},{"kind":"Argument","name":{"kind":"Name","value":"credits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credits"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateImageMutation, UpdateImageMutationVariables>;
export const ArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Article"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authorImageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalNewsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"dek"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"imageCaption"}},{"kind":"Field","name":{"kind":"Name","value":"autoTranslated"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authorImageConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"pressRelease"}},{"kind":"Field","name":{"kind":"Name","value":"scores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerContent"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"hasAccess"}}]}}]}}]} as unknown as DocumentNode<ArticleQuery, ArticleQueryVariables>;
export const ArticlesConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticlesConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryPathPrefix"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inCreatedByIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"popularInDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagSlugs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minScores"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScoreCriteria"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notInIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"embeddingsSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"embeddingsSearchModel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmbeddingsSearchModel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleSorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialPageIdentifiers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialPageIdentifier"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerContent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageviews"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalNewsArticlesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryPathPrefix"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryPathPrefix"}}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"inCreatedByIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inCreatedByIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"inDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inDays"}}},{"kind":"Argument","name":{"kind":"Name","value":"popularInDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"popularInDays"}}},{"kind":"Argument","name":{"kind":"Name","value":"inIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagSlugs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagSlugs"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"minScores"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minScores"}}},{"kind":"Argument","name":{"kind":"Name","value":"notInIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notInIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"embeddingsSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"embeddingsSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"embeddingsSearchModel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"embeddingsSearchModel"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"specialPageIdentifiers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialPageIdentifiers"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressRelease"}},{"kind":"Field","name":{"kind":"Name","value":"partnerContent"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"popularInDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"popularInDays"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageviews"}}}]}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocalNewsArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"pageviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"popularInDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"popularInDays"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageviews"}}}]}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ArticlesConnectionQuery, ArticlesConnectionQueryVariables>;
export const ArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Articles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notInIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleSorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inCreatedByIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagSlugs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pressRelease"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerContent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withoutSummaryAndLabel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withoutDescriptionAndCreator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relatedToIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalNewsArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"notInIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notInIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"inDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inDays"}}},{"kind":"Argument","name":{"kind":"Name","value":"inIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"inCreatedByIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inCreatedByIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagSlugs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagSlugs"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"pressRelease"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pressRelease"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relatedToIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withoutSummaryAndLabel"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withoutDescriptionAndCreator"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"labels"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withoutSummaryAndLabel"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"creator"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withoutDescriptionAndCreator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pressRelease"}},{"kind":"Field","name":{"kind":"Name","value":"partnerContent"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<ArticlesQuery, ArticlesQueryVariables>;
export const AuthorByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthorByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authorImageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalAuthorByEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authorImageConfigurations"}}}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bioHtml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocalNewsUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bioHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsArticlesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pressRelease"}},{"kind":"Field","name":{"kind":"Name","value":"partnerContent"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthorByEmailQuery, AuthorByEmailQueryVariables>;
export const CategoryHeaderArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoryHeaderArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]} as unknown as DocumentNode<CategoryHeaderArticlesQuery, CategoryHeaderArticlesQueryVariables>;
export const CategoryArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoryArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"newsArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CategoryArticlesQuery, CategoryArticlesQueryVariables>;
export const IncreaseHitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncreaseHits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increaseUniversalNewsArticleHits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}}]}]}}]} as unknown as DocumentNode<IncreaseHitsMutation, IncreaseHitsMutationVariables>;
export const RelatedProfilesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelatedProfilesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profilesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"premium"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"newsTags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsTags"}}}]}]}}]} as unknown as DocumentNode<RelatedProfilesCountQuery, RelatedProfilesCountQueryVariables>;
export const SpecialPageBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpecialPageBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"desktopImageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialPageBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"newsboard"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"desktopImageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"parameters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialPageBySlugQuery, SpecialPageBySlugQueryVariables>;
export const SpecialPageNewsArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpecialPageNewsArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialPageBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"universalNewsArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialPageNewsArticlesQuery, SpecialPageNewsArticlesQueryVariables>;
export const NowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Now"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"now"}}]}}]} as unknown as DocumentNode<NowQuery, NowQueryVariables>;
export const BrandsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasProfile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasPremiumProfile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"industries"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasProfile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasProfile"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasPremiumProfile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasPremiumProfile"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"industries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"industries"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"industries"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<BrandsConnectionQuery, BrandsConnectionQueryVariables>;
export const ProfileProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenProductsExist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<ProfileProductsQuery, ProfileProductsQueryVariables>;
export const ProductBrandsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductBrandsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIdsScope"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productBrands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIdsScope"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"PRODUCTS_COUNT"}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"21"}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductBrandsFilterQuery, ProductBrandsFilterQueryVariables>;
export const FilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Filter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productMainCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<FilterQuery, FilterQueryVariables>;
export const ProductColorsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductColorsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productColors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductColorsFilterQuery, ProductColorsFilterQueryVariables>;
export const ProductDepartmentFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductDepartmentFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productGenders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]},{"kind":"Field","name":{"kind":"Name","value":"productAgeGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<ProductDepartmentFilterQuery, ProductDepartmentFilterQueryVariables>;
export const ProductMaterialsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductMaterialsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productMaterials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductMaterialsFilterQuery, ProductMaterialsFilterQueryVariables>;
export const ProductModelImagesFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductModelImagesFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allGenders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandKeywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryPaths"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maybeBrandKeywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maybeKeywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAmountAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAmountAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productModelImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allGenders"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryPaths"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryPaths"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"genders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"maybeBrandKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maybeBrandKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"maybeKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maybeKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAmountAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAmountAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<ProductModelImagesFilterQuery, ProductModelImagesFilterQueryVariables>;
export const ProductPricesFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductPricesFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productMaximumPriceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<ProductPricesFilterQuery, ProductPricesFilterQueryVariables>;
export const ProductPrintsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductPrintsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productPrints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductPrintsFilterQuery, ProductPrintsFilterQueryVariables>;
export const ProductSeasonsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductSeasonsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<ProductSeasonsFilterQuery, ProductSeasonsFilterQueryVariables>;
export const ProductSizesFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductSizesFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSizes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<ProductSizesFilterQuery, ProductSizesFilterQueryVariables>;
export const HasMarketAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasMarketAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMarketAccessRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}}]}]}}]} as unknown as DocumentNode<HasMarketAccessQuery, HasMarketAccessQueryVariables>;
export const HiddenProductsExistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiddenProductsExist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiddenProductsExist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<HiddenProductsExistQuery, HiddenProductsExistQueryVariables>;
export const MarketBrandsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketBrandsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketBrandsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<MarketBrandsConnectionQuery, MarketBrandsConnectionQueryVariables>;
export const MarketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Market"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"market"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]} as unknown as DocumentNode<MarketQuery, MarketQueryVariables>;
export const MarketsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<MarketsConnectionQuery, MarketsConnectionQueryVariables>;
export const ProductBrandsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductBrandsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasProfile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProfile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasPremiumProfile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productBrandsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasProfile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasProfile"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasPremiumProfile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasPremiumProfile"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProfile"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ProductBrandsConnectionQuery, ProductBrandsConnectionQueryVariables>;
export const ProductMainCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductMainCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productMainCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}}]}]}}]} as unknown as DocumentNode<ProductMainCategoriesQuery, ProductMainCategoriesQueryVariables>;
export const ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"colorNames"}},{"kind":"Field","name":{"kind":"Name","value":"sizeNames"}},{"kind":"Field","name":{"kind":"Name","value":"orderQuantities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimes"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"retailerName"}},{"kind":"Field","name":{"kind":"Name","value":"priceCurrencies"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroups"}},{"kind":"Field","name":{"kind":"Name","value":"genders"}},{"kind":"Field","name":{"kind":"Name","value":"categoryMain"}},{"kind":"Field","name":{"kind":"Name","value":"categoryPath"}},{"kind":"Field","name":{"kind":"Name","value":"categorySub"}},{"kind":"Field","name":{"kind":"Name","value":"print"}},{"kind":"Field","name":{"kind":"Name","value":"pricesWithCurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"material"}},{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gtins"}}]}}]}}]} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const ProductsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProfile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"printIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"printIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"280"}},{"kind":"Argument","name":{"kind":"Name","value":"prioritizedColorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"prioritizedModel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProfile"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroups"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"pricesWithCurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderQuantities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maximum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ProductsConnectionQuery, ProductsConnectionQueryVariables>;
export const ProductsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgeGroup"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sizes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sizes"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasons"}}},{"kind":"Argument","name":{"kind":"Name","value":"allGenders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genders"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtLeast"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtLeast"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceAmountAtMost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceAtMost"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}}]}]}}]} as unknown as DocumentNode<ProductsCountQuery, ProductsCountQueryVariables>;
export const ProfileBySlugEbpCoursesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileBySlugEbpCourses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"coursesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileBySlugEbpCoursesQuery, ProfileBySlugEbpCoursesQueryVariables>;
export const ProfileBySlugEbpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileBySlugEbp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"hasTabs"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"isEbpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"showAboutPage"}},{"kind":"Field","name":{"kind":"Name","value":"showWorkingAtPage"}},{"kind":"Field","name":{"kind":"Name","value":"showNewsPage"}},{"kind":"Field","name":{"kind":"Name","value":"aboutPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"aboutPageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"careerSiteReturnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"jobKeywords"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frCh"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itCh"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"newsTags"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileBySlugEbpQuery, ProfileBySlugEbpQueryVariables>;
export const ProfileBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobileImageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"collectionImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"b2bPartnerPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industries"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveCollectionImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionImageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"showAboutPage"}},{"kind":"Field","name":{"kind":"Name","value":"showWorkingAtPage"}},{"kind":"Field","name":{"kind":"Name","value":"showNewsPage"}},{"kind":"Field","name":{"kind":"Name","value":"aboutPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"aboutPageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"workingAtPageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"newsPageHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"}},{"kind":"Field","name":{"kind":"Name","value":"daDk"}},{"kind":"Field","name":{"kind":"Name","value":"deAt"}},{"kind":"Field","name":{"kind":"Name","value":"deCh"}},{"kind":"Field","name":{"kind":"Name","value":"deDe"}},{"kind":"Field","name":{"kind":"Name","value":"enAu"}},{"kind":"Field","name":{"kind":"Name","value":"enCa"}},{"kind":"Field","name":{"kind":"Name","value":"enGb"}},{"kind":"Field","name":{"kind":"Name","value":"enIe"}},{"kind":"Field","name":{"kind":"Name","value":"enIn"}},{"kind":"Field","name":{"kind":"Name","value":"enNz"}},{"kind":"Field","name":{"kind":"Name","value":"enUs"}},{"kind":"Field","name":{"kind":"Name","value":"esAr"}},{"kind":"Field","name":{"kind":"Name","value":"esCl"}},{"kind":"Field","name":{"kind":"Name","value":"esCo"}},{"kind":"Field","name":{"kind":"Name","value":"esEs"}},{"kind":"Field","name":{"kind":"Name","value":"esMx"}},{"kind":"Field","name":{"kind":"Name","value":"esPe"}},{"kind":"Field","name":{"kind":"Name","value":"fiFi"}},{"kind":"Field","name":{"kind":"Name","value":"frBe"}},{"kind":"Field","name":{"kind":"Name","value":"frCh"}},{"kind":"Field","name":{"kind":"Name","value":"frFr"}},{"kind":"Field","name":{"kind":"Name","value":"frLu"}},{"kind":"Field","name":{"kind":"Name","value":"huHu"}},{"kind":"Field","name":{"kind":"Name","value":"itCh"}},{"kind":"Field","name":{"kind":"Name","value":"itIt"}},{"kind":"Field","name":{"kind":"Name","value":"jaJp"}},{"kind":"Field","name":{"kind":"Name","value":"nbNo"}},{"kind":"Field","name":{"kind":"Name","value":"nlBe"}},{"kind":"Field","name":{"kind":"Name","value":"nlNl"}},{"kind":"Field","name":{"kind":"Name","value":"plPl"}},{"kind":"Field","name":{"kind":"Name","value":"ptBr"}},{"kind":"Field","name":{"kind":"Name","value":"ptPt"}},{"kind":"Field","name":{"kind":"Name","value":"ruRu"}},{"kind":"Field","name":{"kind":"Name","value":"svSe"}},{"kind":"Field","name":{"kind":"Name","value":"trTr"}},{"kind":"Field","name":{"kind":"Name","value":"zhCn"}},{"kind":"Field","name":{"kind":"Name","value":"zhHk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"newsTags"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coursesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileBySlugQuery, ProfileBySlugQueryVariables>;
export const ProfilesConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfilesConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"premium"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profilesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"premium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"premium"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<ProfilesConnectionQuery, ProfilesConnectionQueryVariables>;
export const RelatedProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelatedProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maybeBrandKeywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maybeKeywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maybeBrandKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maybeBrandKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"maybeKeywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maybeKeywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"marketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"withImage"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}}]}}]}}]} as unknown as DocumentNode<RelatedProductsQuery, RelatedProductsQueryVariables>;
export const SelectedBrandsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectedBrandsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SelectedBrandsConnectionQuery, SelectedBrandsConnectionQueryVariables>;
export const StandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Stand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<StandQuery, StandQueryVariables>;
export const StandsConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StandsConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"market"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"standsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StandsConnectionQuery, StandsConnectionQueryVariables>;
export const SpecialPagesConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpecialPagesConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialPageSorting"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialPagesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mobileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialPagesConnectionQuery, SpecialPagesConnectionQueryVariables>;
export const TagNewsCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagNewsCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"universalNewsArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<TagNewsCategoryQuery, TagNewsCategoryQueryVariables>;
export const TagBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<TagBySlugQuery, TagBySlugQueryVariables>;
export const TagsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}}]}]}}]} as unknown as DocumentNode<TagsCountQuery, TagsCountQueryVariables>;
export const TagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Newsboard"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TagSorting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"newsboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsboard"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<TagsQuery, TagsQueryVariables>;
export const CreateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"properties"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPropertyInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"properties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"properties"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const RemoveTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveTemplateMutation, RemoveTemplateMutationVariables>;
export const TemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Template"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"mergedProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}}]}}]}}]} as unknown as DocumentNode<TemplateQuery, TemplateQueryVariables>;
export const TemplatesConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplatesConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templatesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<TemplatesConnectionQuery, TemplatesConnectionQueryVariables>;
export const UpdateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"properties"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobPropertyInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"properties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"properties"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const TemplateForUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateForUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"mergedProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TemplateForUpdateQuery, TemplateForUpdateQueryVariables>;
export const CurrentUserAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>;
export const CurrentUserFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"chamberOfCommerceNumber"}}]}}]}}]} as unknown as DocumentNode<CurrentUserFormQuery, CurrentUserFormQueryVariables>;
export const CurrentUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"chamberOfCommerceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]},{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"scoped"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoConfigurations"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserProfileQuery, CurrentUserProfileQueryVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResponsiveImageConfiguration"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompleteBuyerProfile"}},{"kind":"Field","name":{"kind":"Name","value":"shouldSetPassword"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageConfigurations"}}}]}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const OrderUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrderUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<OrderUpdatedSubscription, OrderUpdatedSubscriptionVariables>;